import { DICTIONARY } from 'Enum';
import {
  AppointmentLogo,
  CallCenterLogo,
  ComplaintsCenterLogo,
  SupportCenterLogo,
} from 'Images';
import { ROUTES } from 'Config';
import { BROWSER_TYPE, DEVICE_TYPE, FEEDBACK_STATUSES } from 'Enum/Feedback';
import { PAYMENT_DEDUCTION_STATUS } from 'Enum/paymentsDeduction';
import { STATUS_TYPES } from 'Enum/EmergencyCall';
import { payslipMonthToText } from 'Utils';
import { IUserNotesStats } from 'API/DataAnalysis/dataAnalysis';
import { Levels } from 'Enum/MedicalCar';
import { SEARCH_RESULTS_TYPE, SORT_BY, STATUSES } from 'Enum/SearchResults';
import { format } from 'date-fns';

export const Dictionary = {
  [DICTIONARY.Status]: {
    stepEndedAt: 'השלב הסתיים ב-',
    applicationSubmissionDate: 'תאריך הגשת הבקשה',
    treatmentStatus: 'מצב הטיפול:',
    ministryOfDefenseRehabilitationCenter: 'אגף שיקום משרד הביטחון',
    title: 'התקדמות הטיפול בהכרה בנכות',
    introInformation: {
      title: 'חשוב לנו לשתף אותך בתהליך',
      information:
        'פה אפשר להתעדכן לגבי שלב הטיפול בבקשה שלך להכרה בנכות,  להכיר את העשייה סביב התהליך ולהתכונן לשלבים הבאים',
      summarize: 'מסמכים הקשורים לתהליך ההכרה, יופיעו',
      digitalFolder: 'בתיקייה הדיגיטלית שלך',
    },
    subTitle: 'מצב הטיפול בבקשה שלך',
    pageTitle: 'התקדמות הטיפול בבקשה שלך',
    yourApplicationIsMadeOfInjuries: (numberOfInjuries: number) =>
      `פיצלנו את הבקשה שלך ל-${numberOfInjuries} פגיעות שונות, כדי שנוכל להתייחס לכל אחת בצורה מלאה.`,
    hereYouCanFollowTheirProgress:
      'פה אפשר לעקוב אחרי התקדמות הטיפול של כל אחת מהן',
    generalData: {
      matter: 'נושא הבקשה',
      treatmentStage: 'שלב הטיפול',
      lastUpdate: 'תאריך העדכון',
      nextStep: 'השלב הבא',
    },
    dialogSubTitle: 'התקדמות הטיפול בבקשה',
    moreInfo: 'למידע נוסף',
    collapse: 'לסגירה',
    noData: {
      title: 'אין מידע על הבקשה',
      info: 'המערכת נמצאת בשלבי הרצה',
      info2:
        'התקדמות הטיפול מוצגת עבור בקשות חדשות להכרה בנכות שהוגשו החל מ - 01.07.2022',
      info3: 'כדי להתעדכן על מצב הטיפול בבקשה באפשרותך לפנות למוקד',
      info4: 'הטלפוני בטלפון',
    },
    statusSent: (date: string) => `נשלחה ב-${date}`,
    documentsThatGotUpdatedForYou: 'מסמכים שעודכנו עבורך',
    SectionsInfo:
      'הבקשה שלך מורכבת ממספר סעיפים. ניתן לסנן לפי השלב בו נמצא הסעיף הרלוונטי',
    expertReview: 'בדיקת מומחים',
    aDecisionWasMade: 'התקבלה החלטה',
    inTheCareOfABenefitsOfficer: 'בטיפול קצין תגמולים',
    currentStep: 'שלב נוכחי',
    whatIsRequestedFromYou: 'מה קורה עכשיו?',
    whatIsRequestedFromYou1:
      '1. לקבוע תור לרופא או רופאה מומחים, הרלוונטיים לתחום הפגיעה.',
    whatIsRequestedFromYou1title: 'איך קובעים',
    whatIsRequestedFromYou1info:
      'בקופת החולים שלך, או בעזרת רשימת הרופאים והרופאות המומחים.',
    whatIsRequestedFromYou1link: 'https://google.com',
    whatIsRequestedFromYou1linkTitle: 'לצפייה ברשימה המלאה',
    whatIsRequestedFromYou2: '2. להעביר את חוות הדעת לכתובת מייל:',
    whatIsRequestedFromYou2link: 'tagmulim@tagmulim.co.il',
    uploadDate: 'תאריך העלאה',
    updateDate: 'נכון לתאריך',
    updatedAt: 'עודכן בתאריך:',
    recognitionSteps: {
      submissionReview: [
        (submissionDate: string) =>
          `קיבלנו את הבקשה שלך להכרה בנכות במשרד הבטחון בתאריך ${submissionDate} כל המידע והמסמכים שהעברת נמצאים בבדיקה - אם יהיה חסר מידע או מסמך כלשהו, אנחנו נודיע לך על כך.`,
        'בשלב זה אנחנו בודקים האם הפגיעה או המחלה שלך נגרמה כתוצאה מהשרות הצבאי או הבטחוני שלך משך הבדיקה משתנה בהתאם לפגיעה ולמסמכים שהגשת, והיא יכולה להימשך זמן.',
        'חשוב לדעת, אם יש לך צורך בטיפול רפואי בגלל הפגיעה, אנו מזמינים אותך לפנות אלינו כדי לקבל טיפול.',
        'בכל שאלה ניתן לפנות למוקד הטלפוני של אגף השיקום במספר *8150 (שלוחה 7 לפניות בנושא תביעות)',
      ],
    },
    importantToKnow: 'חשוב לדעת בשלב זה',
    steps: {
      init: {
        name: 'הגשת בקשה',
        title: 'הבקשה שלך הוגשה והועברה לטיפול.',
        info: 'בימים הקרובים נעבור על המידע והמסמכים שהעברת. מומלץ לעקוב באתר אחר ההתקדמות.',
      },
      step0: 'ייקבע בהמשך',
      step1: {
        name: 'בדיקת הבקשה',
        info1: 'קיבלנו את הבקשה שלך להכרה בנכות.',
        info2:
          'הפרטים שהעברת נמצאים בבדיקה - אם יחסר לנו מידע או מסמך כלשהו, נדאג ליצור איתך קשר.',
        info3: 'משך הבדיקה משתנה בהתאם לפגיעה ולמסמכים שהגשת.',
        info4: [
          'חשוב לדעת, ',
          'אם יש לך צורך בטיפול רפואי בגלל הפגיעה, אפשר לפנות אלינו.',
        ],
        info5:
          'בכל שאלה ניתן לפנות למוקד הטלפוני 8150* (שלוחה 7 לפניות בנושא תביעות)',
      },
      step2: {
        name: 'חוות דעת רפואית',
        info1: `הבקשה שלך הועברה לוועדה רפואית לצורך קביעת אחוזי הנכות בעקבות הפגיעה.
        הוועדה כוללת רופאים ורופאות עם מומחיות רלוונטית לפגיעה שהוכרה
        ומזכיר/מזכירת ועדה.
        `,
        moreInfo: 'למידע נוסף',
        info2title: 'לקראת ועדה רפואית',
        info2:
          ' לפני שנקבע לך מועד לוועדה רפואית, אנו בודקים את המסמכים הרפואיים שהגשת - אם חסר מסמך או בדיקה כלשהי, אנו נשלח לך בקשה להשלמת החומר הרפואי או התחייבות (הפניה) לביצוע הבדיקה.',
        info3:
          'השלמת המסמכים והבדיקות מאפשרת לוועדה לקבוע לך אחוזי נכות בהתאם למצבך העדכני.',
        info4Title: 'טיפ חשוב, ',
        info4:
          'לפני הוועדה, מומלץ לכתוב מראש מה הקשיים הרפואיים והתפקודיים שלך בעקבות הפגיעה או המחלה. זה יעזור לך להציג את מצבך בוועדה מבלי לשכוח פרטים חשובים. את הדף שהכנת ניתן להגיש לוועדה.',
        info5title: 'הגעה לוועדה',
        info5: [
          'אנו נשלח לך זימון בדואר ובמסרון שיכלול את מועד הוועדה ואת מיקומה.',
          'אם לא תהיה לך אפשרות להגיע לוועדה בתאריך שייקבע לך, יש לעדכן אותנו בטלפון 8150* כדי שיתואם לך מועד אחר.',
          'חשוב לדעת, ',
          'באפשרותך לבקש שהוועדה תתקיים על סמך מסמכים בלבד - ללא הנוכחות שלך.',
        ],
      },
      step3: {
        name: 'החלטה',
        nameIfCurrent: 'המתנה להחלטה',
        listTitle:
          'הבקשה שלך להכרה בנכות הועברה לקצין התגמולים לצורך קבלת החלטה:',
        li1: 'אם הבקשה שלך תאושר, נודיע לך גם אילו פגיעות או מחלות הוכרו',
        li2: 'אם הבקשה שלך תידחה, באפשרותך להגיש ערעור על ההחלטה',
        info1:
          'משך הטיפול בשלב זה משתנה בהתאם לפגיעה ולמסמכים הקיימים, והוא יכול להימשך זמן.',
        info2: [
          'חשוב לדעת, ',
          'ההחלטה בשלב זה היא אם קיים קשר סיבתי בין הפגיעה לשירות שלך.',
        ],
        info3:
          ' ההחלטה בנוגע לזכויות, לטיפולים ולתגמולים תינתן בהתאם לאחוזי הנכות שתקבע הוועדה הרפואית בשלב הבא',
      },
      stepHaravotBarzel: {
        name: 'שיקום תחילה',
        info1:
          "כדי לאפשר לך להתמקד בתהליך השיקום וההחלמה, אגף השיקום הרכיב סל זכויות מיוחד לפצועי 'חרבות הברזל' שניתן למי שעדיין לא נקבעו אחוזי נכות בוועדה רפואית. סל זה נועד לתמוך בתהליך השיקום עד לקביעת אחוזי הנכות.",
        info2:
          "כשיחלו הוועדות הרפואיות לפצועי 'מלחמת התקומה' אנו נשלח לך זימון לוועדה.",
        linkMoreInfo: 'למידע נוסף על הזכויות',
        earlyCommitteeTitle: 'ועדה רפואית מוקדמת',
        earlyCommitteeInfo1:
          'אם ברצונך להתייצב בפני ועדה רפואית כבר בשלב זה, יש לפנות אלינו לבקשת ועדה רפואית מוקדמת.',
        earlyCommitteeInfo2:
          'הוועדה הרפואית תוכל לבדוק אותך אך ורק בפגיעות עליהן קיבלת אישור הכרה עקרוני. פגיעות שעדיין נמצאות בהליך בירור לא ייבדקו על ידי הוועדה.',
        linkCommitteeRequest: 'לפניה לבקשת ועדה',
        warningText:
          'לתשומת ליבך, אם הוועדה הרפואית תקבע 19% נכות ומטה, יופסק הטיפול הרפואי והנפשי במימון אגף השיקום ויהיה עליך להמשיך אותו מול קופת החולים שלך.',
      },

      step4: {
        name: 'ועדה רפואית',
        info1_line1:
          'לצורך המשך בדיקת הבקשה, נצטרך לקבל את חוות הדעת הרפואית של הרופאים',
        info1_line2:
          'המומחים המייעצים לנו, לגבי מצבך הרפואי, לבדיקת הקשר הסיבתי בין הפגיעה לשירות שלך.',
        info2_title: 'איך מתבצעת חוות הדעת הרפואית?',
        info2:
          'באחת מ-2 הדרכים האלה (אנחנו נעדכן אותך באזור האישי, איזו מהן תבוצע במקרה שלך):',
        note1:
          '1. ללא נוכחותך – במקרה וסוג הפגיעה והתיעוד הרפואי ששלחת מאפשרים זאת, ולא מחייבים בדיקה פיזית.',
        note2:
          '2. במפגש פיזי – במקרה זה יישלח לך מכתב התחייבות(הפניה) לתיקיה הדיגיטלית באזור האישי. המכתב יכלול את כל הפרטים לצורך תיאום מועד לבדיקה. יש לקבוע באופן עצמאי עם הרופא או הרופאה המומחים, כפי שיופיע במכתב. ',
        note3: `במפגש הפיזי, ישאלו אותך על המצב הרפואי שלך, ואם יהיה צורך תתבצע בדיקה גופנית. באפשרותך להגיע לפגישה עם מלווה מטעמך (למשל, בן משפחה, חבר, חונך, עורך דין).
`,
        note4: `במקרה של בדיקה פסיכיאטרית - לא תתאפשר נוכחות עורך דין בזמן הבדיקה, אלא אם ניתן אישור מראש מהגורם המומחה, על פי שיקול הדעת המקצועי, על מנת שלא לפגוע בבדיקה.
`,
        update: 'עדכון:',
        updateText:
          'לצורך המשך בדיקת הבקשה שהגשת, שלחנו לך בדואר התחייבות(הפניה) לבדיקת רופא או רופאה מומחים. עליך לתאם את מועד הבדיקה באופן עצמאי.',
        requiredFromYouTitle: 'מה נדרש ממך?',
        requiredFromYou: 'עליך לתאם מועד לחוות דעת רפואית.',
        info2more:
          'באפשרותך לקבל את הפרטים גם במוקד הטלפוני 8150* (שלוחה 7 לפניות בנושא תביעות)',
        title: 'חשוב לדעת,',
        subTitle: 'במקרה שיהיה עליך להגיע פיזית לבדיקה, המסמכים הנדרשים הם:',
        li1: 'תעודה מזהה',
        li2: 'אם יש לך מסמכים עדכניים שלא הגשת, חשוב להביא אותם לבדיקה.',
        info3_line1: 'בבדיקה הרופא/הרופאה ישאלו אותך על המצב הרפואי שלך,',
        info3_line2:
          'ואם יהיה צורך תתבצע בדיקה פיזית - ניתן להגיע ביחד עם מלווה.',
        info4: 'בתום הבדיקה הרופא יעביר אלינו את חוות הדעת הרפואית.',
      },
      step5: {
        name: 'קביעת אחוזי נכות',
        info1: 'הוועדה הרפואית העבירה אלינו את החלטתה.',
        info2:
          'אנו בודקים שהוועדה התייחסה לכל הפגיעות שלך ושההחלטה בפרוטוקול מנומקת וברורה.',
        info3:
          'לאחר הבדיקה אנחנו נעדכן אותך מה אחוזי הנכות שנקבעו ונשלח לך את פרוטוקול הוועדה.',
      },
      rejection: {
        name: 'הבקשה נדחתה',
        info1:
          'אנו מצטערים לבשר לך כי בתום הבדיקה החלטנו לדחות את בקשתך להכרה בפגיעה זו. שלחנו לך מכתב בדואר רשום עם פרטי ההחלטה.',
        info2title: 'לתשומת ליבך, ',
        info2:
          'ניתן להגיש ערעור על ההחלטה לוועדת הערעורים בבית משפט השלום תוך 60 ימים מקבלת מכתב ההחלטה.',
        extraDetails: {
          text: 'מידע נוסף על הערעור אפשר',
          hrefText: 'לקרוא פה',
          href: 'recognition/request/appeal',
        },
      },
      pause: {
        name: 'הטיפול בבקשה הופסק',
        info1: 'הטיפול בבקשה להכרה בפגיעה זו הופסק.',
        info2: 'סיבת הפסקת הטיפול: ',
        info3:
          'בכל שאלה ניתן לפנות למוקד הטלפוני 8150* (שלוחה 7 לפניות בנושא תביעות)',
      },
      recognition: {
        name: 'הטיפול הסתיים',
        info1: 'הטיפול בבקשה שלך הסתיים.',
        info2_line1: 'שלחנו לך בדואר רשום מכתב מפורט עם המידע המלא על ההחלטה,',
        info2_line2: 'אחוזי הנכות שנקבעו לך ופרוטוקול הוודעה.',
        info3title: 'ערעור על ההחלטה',
        info3_line1: 'אם תהיה לך השגה כלשהיא על החלטת הוועדה הרפואית,',
        info3_line2: 'אפשר להגיש ערעור על כך בתוך 45 יום מקבלת המכתב.',
        info3_line3: 'על הערעור תדון ועדה רפואית עליונה בהרכב מורחב של רופאים',
        info3_line4:
          'ורופאות מומחים, שלהם יש סמכות לשנות את החלטת הוועדה הרפואית.',
        info4:
          'קצין התגמולים רשאי לערער על ההחלטה, אם נפל לטעמו פגם בהחלטת הוועדה הרפואית. גם במקרה זה היא תיבחן בוועדה רפואית עליונה.',
      },
    },
    Recognition: {
      title: 'הטיפול הסתיים',
      subtitle: 'עבור',
      date: (date?: string) => `עדכון מתאריך ${date}:`,
      info: 'הטיפול בבקשה שלך הסתיים.',
      info2:
        'שלחנו אליך בדואר את פירוט אחוזי הנכות שנקבעו לך, ואת פרוטוקול הוועדה הרפואית.',
    },
    Pause: {
      title: 'לצערנו,',
      subtitle: 'הטיפול בבקשה הופסק',
      date: (date?: string) => `עדכון מתאריך ${date}:`,
      info: 'לצערנו הטיפול בבקשה הופסק, שלחנו לך בדואר רשום מכתב עם פרטי ההחלטה המלאים. למידע נוסף יש לפנות למוקד הטלפוני במספר 8150* (שלוחה 7 לפניות בנושא תביעות).',
      goodToKnow: 'חשוב לדעת',
      info2:
        'ניתן להגיש ערעור על ההחלטה שלנו לוועדת הערעורים בבית משפט השלום תוך 60 ימים מקבלת מכתב ההחלטה.',
      btnTitle: 'בידיים טובות',
      btnUrl: 'https://femi.com/service/mod/',
    },
    Rejection: {
      label: 'הבקשה נדחתה',
      title: 'סליחה,',
      subtitle: 'הבקשה שלך להכרה ב',
      subtitle2: 'נדחתה',
      date: (date?: string) => `עדכון מתאריך ${date}:`,
      info1:
        'לצערנו, לאחר בדיקת כל הנתונים, החלטנו לדחות את בקשתך להכרה בפגיעה זו.',
      info2: 'שלחנו לך בדואר רשום מכתב עם פרטי ההחלטה.',
      p1: 'חשוב לדעת',
      p2: 'ניתן להגיש ערעור על ההחלטה שלנו לוועדת הערעורים בבית משפט השלום תוך 60 ימים מקבלת מכתב ההחלטה (ניתן לקבל הארכה מבית המשפט).',
    },
    Objection: {
      label: 'הבקשה נמצאת בערעור',
      date: (date?: string) => `עדכון מתאריך ${date}:`,
      p1: 'הבקשה נמצאת בתהליך משפטי של ערעור מול בתי המשפט.',
      p2: 'מידע נוסף בנושא ערעורים ',
      p3: 'ניתן לקרוא פה',
    },
    FurtherReference: {
      label: 'הבקשה בעיון נוסף',
    },
  },

  [DICTIONARY.MedicationsAndPrescriptionsLobby]: {
    toBuyPrivately: '(לרכישה באופן עצמאי)',
    contactUs1: 'יש לך שאלות על המרשמים ? נשמח לענות בטלפון',
    phoneNumber: '077-8885325',
    exitAndReturnToMedicationsAndPrescriptionsLobby:
      'סגירה וחזרה לעמוד תרופות ומרשמים',
    yourRequestWillBeTreatedLikeSoDesktop: 'הבקשה שלך למרשם תטופל באופן הזה:',
    yourRequestWillBeTreatedLikeSoMobile: 'איך אנחנו מטפלים בבקשה שלך למרשם?',
    aDoctorWillCheckYourRequest: 'רופא או רופאה מחוזיים יבדקו את הבקשה שלך',
    ifApprovedYouWillBeNotified:
      'אם היא תאושר, ניצור לך מרשם במערכת ונעדכן אותך על כך במסרון ובאיזור האישי.',
    youWillBeAbleToOrderHere: 'תפתח לך האפשרות להזמין את התרופה כאן באתר',
    prescriptionDenied: 'המרשם נדחה',
    prescriptionDeniedNextStep: 'לצערנו, כרגע אין אפשרות לספק את המרשם שביקשת',
    openedInSystem: 'פתיחה במערכת',
    startDate: 'תאריך תחילת טיפול',
    inTreatmentInDepartment: 'בטיפול באגף',
    title: 'תרופות ומרשמים',
    subTitle:
      'אילו תרופות להזמין לך הפעם? יש לסמן את אלה שברצונך להזמין וללחוץ על כפתור המשך להזמנה  שבסוף הרשימה',
    subTitleLink: 'היסטוריית התרופות שלך',
    newUserTitle: 'הזמנת תרופות ומרשמים',
    askForPrescription: 'בקשת מרשם לתרופה',
    contactUsOnPhone: ['בכל שאלה באפשרותך לפנות למוקד הטלפוני בטלפון', '8150*'],
    canAskForNewPrescription: 'באפשרותך לבקש מרשם לתרופה חדשה',
    canAskForPrescription: 'באפשרותך לבקש מרשם לתרופה',
    newUserSubTitle:
      'הגעת למערכת הזמנת התרופות של אגף השיקום, כרגע עדיין אין לך תרופות קבועות מאושרות להזמנה.',
    ifHasRegularMedications: 'אם יש לך תרופות שאושרו',
    canOrderMedsnow: 'באפשרותך להזמין אותן כבר עכשיו',
    requestNewMedication: 'בקשת תרופה חדשה',
    requestRegularMedications: 'הזמנת תרופות קבועות',
    userHasNoRegularMedicationsSubTitle:
      'כרגע עדיין אין לך תרופות קבועות מאושרות להזמנה.',
    ifNoApprovedMedications: 'אם עדיין אין לך תרופות שאושרו',
    canRequestNewPrescription: 'באפשרותך לבקש מרשם לתרופה חדשה',
    howWeTakeCareOfYourRequest: 'איך אנחנו מטפלים בבקשה שלך למרשם?',
    alertDialogOrdersTitle: 'רק רגע בבקשה',
    alertDialogOrdersButton: 'הזמנה נוספת',
    checkAll: 'בחירת הכל',
    whatMedicationsDoYouWantToOrder: 'אילו תרופות להזמין לך הפעם?',
    youChoseNumberOfMedicationsDesktop: (number: number) =>
      `בחרת ${number} תרופות`,
    youChoseNumberOfMedicationsMobile: (number: number) =>
      `בחרת להזמין ${number} תרופות`,
    thereAreNumberOfIssuesThatNeedsYourAttention: (number: number) =>
      `יש ${number} נושאים שמחייבים את תשומת ליבך`,
    whatWouldYouLikeToDo: 'מה ברצונך לעשות?',
    pickupChoose: 'איך נוח לך לקבל את המרשמים?',
    selfPickup: 'איסוף עצמי מהמחוז',
    importantToKnow: [
      'חשוב לדעת: ',
      'את כל המרשמים שברצונך לקבל לרכישה באופן עצמאי',
      'ניתן לקבל באותה דרך לבחירתך: קבלת מרשם בדואר או איסוף מרשם מהמחוז.',
    ],
    medicineLineLabel: 'באזור תרופות ומרשמים',
    theMedicationYouOrder: 'התרופה שביקשת,',
    currentlyMissing: 'חסרה זמנית במלאי',
    outOfStock: 'תרופות חסרות זמנית במלאי',
    weAreSorry: 'לצערנו אין צפי לקבלת התרופה בקרוב',
    selfPurchaseMedications: (number: number) =>
      `בחרת ברכישה עצמאית של   ${number} תרופות:`,
    summaryAndApproveRegularOrder: 'סיכום ההזמנה לפני שליחה',
    youChoseToOrderNumberOfMedications: (number: number) =>
      `בחרת להזמין  ${number} תרופות`,
    infoBeforeFutureOrder:
      'הזמנה לתקופה זו מחייבת אישור רופא המחוז (לצורך הגנה על בריאותך) ולא מאושרת אוטומטית',
    infoBeforeOrder:
      'לפני שליחת ההזמנה, מומלץ לעבור על הפרטים בה כדי לוודא שלא חסר לך כלום',
    nameOfTheMedication: 'שם התרופה',
    currentPrescriptionValidity: 'תוקף המרשם הנוכחי',
    prescriptionsStatus: 'ההזמנות שלך',
    ordersYouMade: 'הבקשות שהגשת באתר',
    createdDate: 'תאריך תחילת טיפול',
    updateDateLabel: 'תאריך עדכון',
    prescriptionCode: 'מספר הזמנה',
    medicationsAmount: 'מספר פריטים',
    status: 'מצב הטיפול',
    moreInfo: 'למידע נוסף',
    aboutOrderFrom: 'על הזמנה מתאריך',
    duplicateOrder: 'שכפול הזמנה',
    toThePersonalArea: 'לאיזור האישי',
    updateDate: 'תאריך העדכון',
    toAllPrescriptions: 'הזמנות קודמות',
    seeLess: 'ראה פחות',
    toShow: 'לצפייה',
    toHide: 'לסגירה',
    noMedicationsSelectedError: 'יש לבחור תרופה אחת לפחות',
    pleaseSelectAnOption: 'כדי להתקדם בתהליך, צריך לבחור באחת האפשרויות',
    prescriptionsTabDescription: `כאן אפשר לעקוב אחר הטיפול בתרופות שהזמנת או שהוזמנו עבורך מהמרפאה במחוז שלך.
    לתשומת ליבך, יייתכן שחלק מההזמנות שלך מפוצלות למספר מרשמים שונים, אנחנו עושים את זה מסיבות תפעוליות.`,
    prevOrdersTabDescription:
      'פה מרוכזות כל התרופות שביקשת דרך האתר: תרופות קבועות, תרופות חדשות וכן חידושי מרשמים',
    toOrderDetails: 'צפייה בהזמנה',
    prescription: 'מרשם',
    commingSoon: 'ייקבע בהמשך',
    dosageText: 'מינון',
    pill: 'יחידה',
    notes: 'הערות',
    emptyNotes: 'אין הערות',
    notInStock: 'התרופה חסרה במלאי',
    sendByPost: 'נשלח אלייך את המרשם בדואר',
    sendReplacement: 'נשלח לך תרופה חלופית',
    selfPurchase: 'בחרת לרכוש עצמאית ולאסוף את המרשם מהמחוז',
    prescriptionMedicationsAmount: (amount: number) =>
      `תרופות במרשם (${amount})`,
    dosageDetails: (
      dosage?: number,
      doseperday?: number,
      severalDays?: number,
    ) => `${dosage === 1 ? 'יחידה אחת' : `${dosage} יחידות`} 
    ${
      doseperday === 1 ? 'פעם ביום' : `${doseperday} פעמים ביום`
    } למשך ${severalDays} ימים`,
    doseperday: 'פעם ביום',
    doseperdays: 'פעמים ביום',
    doseperweek: 'פעם בשבוע',
    units: 'יחידות',
    dosageTitle: 'מינון',
    dosageLabel: "מס' פעמים",
    prescriptionStatus: 'מצב הטיפול במרשם',
    orderComments: 'הערות להזמנה',
    AddOrderComments: 'הוספת הערות להזמנה',
    orderCommentsPlaceHolder:
      'בקשות מיוחדות או מידע שחשוב לך להוסיף, ניתן לכתוב כאן',
    outOf: ' מתוך ',
    successOrderTitle: 'קיבלנו את ההזמנה ונטפל בה בהקדם',
    successOrderSubTitle: 'מה צפוי עכשיו?',
    successOrderFirstItem: `הבקשה שלך מיד תופיע תחת רשימת הזמנות אחרונות בדף ראשי של איזור "תרופות ומרשמים"`,
    successOrderSecondItem:
      'אנחנו נעבור על הפרטים. במידת הצורך, ניצור איתך קשר להשלים את הטיפול בהזמנה',
    successOrderThirdItem:
      'מרגע אישור הבקשה, תיפתח עבורך במערכת הזמנה חדשה בתוך כ- 48 שעות',
    successOrderThirdItemPartOne: 'מרגע אישור הבקשה, נפתח עבורך במערכת מרשם ',
    successOrderThirdItemPartTwo: 'בתוך 48 שעות',
    successOrderFourthItem:
      'בחלק מהמקרים נפצל את ההזמנה למספר הזמנות, בגלל סיבות תפעוליות',
    successOrderFifthItemMobile:
      'לאחר פתיחת המרשם, יופיע סטטוס הטיפול בדף "לובי תרופות ומרשמים"',
    successOrderFifthItemDesktop:
      'לאחר פתיחת המרשם, יופיע סטטוס הטיפול תחת רשימת הזמנות אחרונות',
    successOrderRightButton: 'חזרה לתרופות ומרשמים',
    successOrderLeftButton: 'צירוף מסמך/חידוש מרשם',
    importantThereIsANeedToRenewPrescription:
      'חשוב: יש צורך בצירוף מסמך/חידוש מרשם עבור התרופות',
    forYourInformationSomePrescriptionsNeedRenewing:
      'לידיעתך, יש צורך בחידוש מרשם/מסמך לתרופות:',
    superPharmSupport: 'יש לך שאלות על האספקה? מוקד סופר פארם לשירותך בטלפון',
    haveQuestionsAboutSupply: 'יש לך שאלות על האספקה?',
    superPharmForYourSupport: 'מוקד סופר פארם לשירותך בטלפון',
    superPharmPhone: '077-8885325',
    moreInfoSuperPharm: 'מידע שימושי נוסף - ',
    moreInfoSuperPharmLinkTitle: 'באתר סופר פארם',
    moreInfoSuperPharmLinkUrl: 'https://shop.super-pharm.co.il/mod',
    personalZone: 'אגף השיקום משרד הביטחון אזור אישי',

    dosage: (dosage?: number, dosagePerDay?: number, severalDays?: number) =>
      `${dosage === 1 ? 'יחידה אחת' : dosage + ' יחידות'} ${
        dosagePerDay === 1 ? 'פעם אחת ביום' : dosagePerDay + ' פעמים ביום '
      } למשך ${severalDays} ימים`,

    haveQuestionsOnPrescriptions: 'יש לך שאלות על ההזמנה?',
    willBeHappyToHelp: 'המוקד הארצי לשירותך בטלפון',
    toBeDetermined: 'ייקבע בהמשך',
    manualSupplyPhone: '8150*',
    manualSupplyPhoneTel: '*8150',
    prescriptionCreatedDateInSystem: (date: string) =>
      `תאריך פתיחה במערכת ${date}`,
    prescriptionCreatedDateInSystemMobile: `תאריך פתיחה במערכת:`,
    prescriptionValidity: (date: string) => `תוקף ${date}`,
    Immediate: 'מיידי',
    Validity: 'תוקף',
    until: 'עד',
    ImmediateValidity: 'תוקף מיידי',
    prescriptionWasCreatedInSystem: 'המרשם נפתח במערכת',
    prescriptionNextStageIsWingHandling:
      'השלב הבא: בדיקת המרשם באגף לקראת אספקה',
    prescriptionIsInWingHandling: 'המרשם בבדיקה וטיפול של האגף',
    prescriptionNextStageIsSupply: 'השלב הבא: אספקת מרשם',
    prescriptionNextStageIsTransferToSuperPharm:
      'השלב הבא: העברה לטיפול הסופר פארם במועד תחילת התוקף',
    yourPrescriptionIsReady: 'המרשם שלך מוכן',
    prescriptionWillBeDeliveredTheWayYouChosen:
      'השלב הבא: הוא יימסר לך בדרך שבחרת',
    prescriptionWasTransferredToSuperPharm:
      ' המרשם הועבר להמשך טיפול בסופר פארם',
    referralRequest: 'בקשת הפניה',
    thereAreNumberOfMedicationsThatRequiresYourAttention: (number: number) =>
      `יש ${number} תרופות בהן נדרש המשך טיפול`,
    thereAreNumberOfMedicationsThatRequiresYourAttentionHeader: (
      number: number,
    ) => `תרופות שתוקפן עתיד לפוג (${number})`,
    thereAreNumberOfMedicationsThatRequiresYourContinuingCare: (
      number: number,
    ) => `יש ${number} תרופות בהן נדרש המשך טיפול`,
    attachingDocumentsThatAreRelevantWillHelpUsTakeCareOfYourRequestsFaster:
      'צירוף מסמכים רלוונטים בזמן, יאפשר לנו לטפל מהר יותר בבקשות שלך העדכון לא קורה מיד. לאחר צירוף קובץ או מרשם, המידע ייקלט במערכת ויופיע פה לאחר האישור',
    updateDelayAfterAttachingFile:
      'העדכון לא קורה מייד. לאחר צירוף קובץ או מרשם, המידע ייקלט במערכת ויופיע פה לאחר אישור',
    prescriptionName: 'שם המרשם',
    validityCurrentPrescription: 'תוקף המרשם הנוכחי',
    expired: 'פג תוקף',
    days: 'ימים',
    endPeriod: 'לסיום תוקף מרשם התרופה',
    leftMore: `נשארו עוד`,
    for: 'למשך',
    numberOfDaysAgo: (number: number) => `לפני ${number} ימים`,
    constMedications: 'תרופות קבועות',
    prevOrdersTabButton: 'לכל הבקשות',
    supplied: 'הפריט סופק',
    notSupplied: 'הפריט לא סופק',
    readMore: '... קרא עוד',
    readLess: ' הסתר טקסט',
    medHistory: 'הסטוריית תרופות',
    returnToHome: 'חזרה למסך הראשי',
    exportToPDF: 'הורדת דוח ניפוק תרופות',
    orderDefaultStatus: 'ממתין לפתיחה במערכת',
    forYourAttention: 'לתשומת ליבך!',
    forMoreDetails: 'לפרטים נוספים',
    doYouHaveQuestionsAboutThePrescriptions: 'יש לך שאלות על המרשמים?',
    weWillAnswerAtNumber: 'נשמח לענות במוקד האגף בטלפון',
    orderSummary: 'סיכום הזמנה',
    attentionOrderingOutOfStockMedicationsViaMail: [
      'לתשומת ליבך!',
      'בחרת לקבל את המרשם בדואר.',
      'אם ברצונך לקבל מרשם נוסף לרכישה עצמית עבור תרופה אחרת, יש לבחור באותה האפשרות.',
      'לא ניתן לפצל את הבחירה (ולבחור איסוף עצמי מהמחוז).',
    ],
    attentionOrderingOutOfStockMedicationsViaCounty: [
      'לתשומת ליבך!',
      'בחרת לקבל את המרשם במחוז.',
      'אם ברצונך לקבל מרשם נוסף לרכישה עצמית עבור תרופה אחרת, יש לבחור באותה האפשרות.',
      'לא ניתן לפצל את הבחירה (ולבחור לקבל את המרשם בדואר).',
    ],
    attentionOrderingReplacementMedications: [
      'לתשומת ליבך!',
      'אישור התרופה החלופית יבוצע בהתאם לשיקול הדעת של הרופא או הרופאה המחוזיים.',
    ],
    createOrder: {
      title: 'הזמנת תרופות קבועות',
      subtitle:
        'אילו תרופות להזמין לך הפעם? יש לסמן את אלה שברצונך להזמין וללחוץ על כפתור המשך להזמנה שבסוף הרשימה',
      breadcrumbs: 'חזרה לתרופות ומרשמים',
      orderPeiod: 'תקופת ההזמנה',
      orderPeriodInfo: 'לאיזו תקופה היית רוצה להזמין את התרופות?',
      oneMonth: 'לחודש אחד',
      threeMonths: 'ל-3 חודשים',
      oneMonthSummery: 'למשך תקופה של חודש',
      threeMonthsSummery: 'למשך תקופה של 3 חודשים',
      isSplitOrder: 'לחלק את התרופות לחודשים או לספק הכל יחד?',
      split: 'התרופות יסופקו כל חודש בהתאם למרשם',
      supplyAll: 'לספק את כל התרופות יחד באותו משלוח',
      longPeriodNote:
        'הזמנה לתקופה זו מחייבת אישור של רופאי המחוז (לצורך הגנה על בריאותך) ולא מאושרת אוטומטית',
    },

    breadcrumbs: 'חזרה לתרופות ומרשמים',

    futureOrdersAccordionTitle: 'הזמנות לאספקה עתידית',
    futureOrdersAccordionSubTitle: 'תרופות שהוזמנו ויסופקו בחודשיים הקרובים',
    inProgressOrdersAccordionTitle: 'הזמנות בתהליך טיפול',
    inProgressOrdersAccordionSubTitle:
      'תרופות שהוזמנו וממתינות להשלמת הטיפול בהזמנה',
    pastOrdersAccordionTitle: 'הזמנות קודמות',
    pastOrdersAccordionSubTitle: 'תרופות שהוזמנו בעבר והטיפול בהזמנתן הסתיים',
    noOrdersFound: 'אין כרגע הזמנות שביצעת ולא טופלו. הזמנות חדשות יופיעו כאן',
  },
  [DICTIONARY.General]: {
    totalFileSizeError: 'גודל כלל הקבצים לא יכול לעלות על 20MB',
    invalidFileError: 'הקובץ לא חוקי/מוגן בסיסמה',
    previewNotAvailable: 'לא ניתן להציג תצוגה מקדימה לקובץ מסוג זה',
    otpIssUrl: 'privatearea-api.azurewebsites.net',
    universalRequestUrl: '/universalRequest',
    flyingCarpetUrl: 'https://flying-shikum.co.il',
    eshetTursUrl: 'https://eshetapollodt.azurewebsites.net',
    cancelChanges: 'ביטול שינויים',
    reset: 'איפוס',
    resetSelection: 'איפוס בחירה',
    prefix: 'קידומת',
    required: '(שדה חובה)',
    advancedSearch: 'חיפוש מתקדם',
    noOptions: 'אין תוצאות',
    openOrClose: 'פתיחה או סגירה',
    continue: 'המשך',
    continueToOrder: 'המשך להזמנה',
    return: 'חזרה',
    sendOrder: 'שליחת הזמנה',
    editOrder: 'עריכת הזמנה',
    noDataOffer: 'מה נוכל להציע לך עכשיו?',
    close: 'סגירה',
    clearSearch: 'נקה חיפוש',
    open: 'פתיחה',
    info: 'מידע',
    exit: 'יציאה',
    searchResults: 'תוצאות סינון',
    result: 'תוצאות',
    showResults: 'הצגת תוצאות',
    toShowResults: 'הצג תוצאות',
    popupAlertErrorMsg:
      'לא ניתן לפתוח את הקובץ, נא לבדוק חסימה של חלונות קופצים',
    noAdvancedSearchResults: 'לא מצאנו את מה שחיפשת',
    allowPopups: 'יש לאפשר חלונות קופצים לצפייה בקובץ',
    downloadFileError: 'שגיאה בהורדת הקובץ. אנא נסו שנית',
    tapToSaveFile: 'לחצו לשמירת הקובץ',
    saveFile: 'שמירת קובץ',
    fileNotFound: 'הקובץ לא נמצא. אנא נסו שנית מאוחר יותר',
    changeFilter: `כדאי לשנות את אפשרויות הבחירה בסינון,
    כדי לחפש תוצאות נוספות`,
    tryChangingSearch: 'אפשר לנסות לחפש ביטוי אחר',
    found: 'נמצאו',
    youHaveUnreadNotifications: (unredNotifications: number) =>
      `יש לך ${unredNotifications} עדכונים שלא נקראו`,
    menuClose: 'סגירת תפריט',
    closeWindow: 'לחיצה לסגירת החלון',
    warning: 'אזהרה',
    prescriptionDetails: 'צפייה בפרטי מרשם',
    imposter: 'מעבר למשתמש',
    search: 'חיפוש',
    accept: 'אישור',
    hideImpersonationTooltip: 'הסתר רכיב מעבר למשתמש על מנת לצפות בעמוד כלקוח',
    hideImpersonation: 'הסתר',
    searchById: 'תעודת זהות',
    searchByCaseNumber: 'מספר תיק',
    idNumber: 'מספר ת.ז',
    caseNumber: 'מספר תיק',
    fakeIds: 'fakeIds',
    none: 'ללא',
    finish: 'סיום',
    phone: 'טלפון',
    medicine: 'תרופה',
    medicineList: 'רשימת תרופות',
    document: 'מסמך',
    duplicate: 'שכפול',
    leftArrow: 'חץ שמאלה',
    rightArrow: 'חץ ימינה',
    downArrow: 'חץ למטה',
    background: 'רקע',
    delete: 'מחיקה',
    deleteFile: 'מחיקת קובץ',
    watch: 'צפייה',
    returnToMain: 'חזרה למסך הראשי',
    deleteModalConfirmTitleGeneral: 'האם ברצונך למחוק פריט זה?',
    deleteModalCancelButton: 'לא למחוק',
    deleteModalConfirmButton: 'כן, אפשר למחוק',
    deleteModalFirstParagraph: 'רק שניה בבקשה...',
    navigateTo: 'נווט אל',
    deleteModal: {
      title: 'התכוונת למחוק את הקובץ?',
      cancel: 'לא למחוק',
      confirm: 'כן, למחוק',
      many: 'התכוונת למחוק את הקבצים?',
      applies: 'התכוונת למחוק את הפניה?',
      appliesMany: 'התכוונת למחוק את הפניות?',
    },
    fileUploadLabel: 'העלאת קובץ',
    addAdditionalFile: 'צירוף קובץ נוסף',
    fileErrorNew:
      'הקובץ לא תקין. אפשר לצרף קובץ עד משקל 20Mb עם אחת מהסיומות: doc, docx, jpg, png, pdf, tif',
    selectDescription:
      'לבחירת ערך הקש על מקש Enter פעמיים והשתמש בחיצי המקלדת - למעלה או למטה. לאחר בחירת הערך אשר את בחירתך באמצעות מקש Enter',
    autocompleteDescription:
      'לבחירת ערך, התחל לכתוב את היישוב והשתמש בחיצי המקלדת - למעלה או למטה. לאחר בחירת הערך, אשר את בחירתך באמצעות מקש Enter',
    skipToSiteContent: 'דלג לתוכן האתר',
    new: 'חדש',
    downloadShort: 'להורדה',
    watchShort: 'הורדה',
    toDownload: 'להורדת',
    noData: {
      submitNewRequest: 'שליחת פנייה לאגף',
      submitReferral: 'שליחת פנייה לאגף לפי נושא',
      medicalReferrals: 'התחייבויות (הפניות)',
      contact: 'יצירת קשר',
      compassRights: 'מצפן זכויות',
      notSelected: 'לא נבחר',
    },
    watchFile: 'לצפייה בקובץ',
    select: 'בחר',
    noDataFound: 'לא נמצא מידע',
    newRequestText: 'שליחת פנייה לאגף',
    newRequestHref: '/universalRequest/1/5/15',
    medicalReferalsText: 'התחייבויות (הפניות)',
    medicalReferalsHref: '/medicalConfirmed',
    personalTeamText: 'יצירת קשר',
    personalTeamHref: '/personal-team',
    compassRightsText: 'מצפן הזכויות',
    compassRightsHref: '/compass-rights',
    documentsHref: '/documents',
    back: 'חזרה',
    errors: {
      requiredField: 'שדה חובה',
      invalidName: 'שם לא תקין',
      invalidID: 'תעודת זהות לא תקינה',
      invalidPhone: 'מספר לא תקין',
      invalidEmail: 'אימייל לא תקין',
    },

    sidebar: {
      hello: 'שלום, ',
      birthday: 'יש לך יום הולדת החודש, שפע ברכות מאיתנו',
      notifications: 'העדכונים שלך',
      privateDetails: 'הפרטים שלך',
      home: 'דף הבית',
      lawyerHome: 'רשימת המיוצגים שלך',
      gotoInformationWebsite: 'לאתר המידע',
      signout: 'התנתקות',
      new: 'חדש',
      reduce: 'צמצום תפריט',
    },

    activityGuard: {
      stayLoggedIn: 'להשאיר אותך באזור האישי?',
      noticedInactivity: 'שמנו לב שלא ביצעת פעולה בדקות האחרונות.',
      autoLogoutReasoning:
        'מטעמי פרטיות והגנת המידע שלך, המערכת מתנתקת אוטומטית לאחר 30 דקות ללא פעילות.',
      continueActivity: 'המשך פעילות',
      logout: 'יציאה מהאזור האישי',
      closeModal: 'סגירת חלון',
      reconnectAgain: 'לחבר אותך שוב לאזור האישי?',
      inactivityLogout: 'זיהינו חוסר פעילות וניתקנו אותך מהאזור האישי,',
      reconnectAgainAfterLogout: 'כדי לשמור על הפרטיות שלך. לחבור אותך שוב?',
      connect: 'התחברות לאזור האישי',
      toHomePage: 'לאתר המידע',
    },

    fromDate: 'מתאריך',
    toDate: 'עד תאריך',
    addToCalendar: 'הוספה ליומן',
  },
  [DICTIONARY.MedicationsHistory]: {
    ministryOfDefenseRehabilitationCenter: 'אגף שיקום משרד הביטחון',
    title: 'היסטוריית התרופות שלך',
    subTitle: 'פה מופיעות כל התרופות שקיבלת דרך אגף השיקום בשנתיים האחרונות',
    titleLink: 'חזרה לתרופות ומרשמים',
    searchMedicationByName: 'חיפוש לפי שם התרופה',
    constMedication: 'תרופה קבועה',
    prescriptionValidity: 'תאריך סוף תוקף תרופה',
    openDate: 'הפקת מרשם',
    prescriptionNumber: 'מספר מרשם',
    note: 'הערה',
    status: 'מצב הטיפול',
    treatmentCondition: 'מצב טיפול',
    dosage: 'מינון',
    dosageFullDescription: (
      dosage?: number,
      doseperday?: number,
      fornumberdays?: number,
    ) =>
      `${dosage === 1 ? 'יחידה אחת' : `${dosage} יחידות`} 
       ${
         doseperday === 1 ? 'פעם ביום' : `${doseperday} פעמים ביום`
       } למשך ${fornumberdays} ימים`,
    deleteFromList: 'מחיקה מהרשימה',
    attachDocument: 'צירוף מסמך / חידוש מרשם',
    exportToPDF: 'הורדת דוח ניפוק תרופות',
    close: 'סגירה',
    open: 'פתיחה',
    info: 'מידע',
    exit: 'יציאה',
    closeWindow: 'לחיצה לסגירת החלון',
    warning: 'אזהרה',
    prescriptionDetails: 'צפייה בפרטי מרשם',
    medicineName: 'שם התרופה',
    frequency: 'תדירות',
    validity: 'תוקף המרשם',
  },
  [DICTIONARY.Header]: {
    logoTitle: 'משרד הביטחון - אגף השיקום',
    logoMobile: 'אגף השיקום',
    logoSubtitle: 'מתחילים בדרך חדשה',
    myTeam: 'הצוות שלך',
    search: 'חיפוש',
    shikum: 'אגף השיקום',
    mobileMenuAriaControl: 'פתיחה וסגירת תפריט',
    ministryOfDefense: 'משרד הביטחון',
    preProdText: 'סביבת בדיקות PRE PROD',
    preProdTextMobile: 'PP',
    toPrivateArea: 'לאזור האישי',
    personalButton: {
      title: 'הפרטים שלך',
      menuItems: {
        viewPersonalDetails: { label: 'צפייה בפרטים שלך' },
        updatePersonalDetails: { label: 'עדכון הפרטים שלך' },
        viewDisabledVeteranCertificate: { label: 'צפייה בתעודת נכה' },
        signout: { label: 'התנתקות' },
      },
    },
  },
  [DICTIONARY.ContentHeader]: {
    title: 'פנייה לאגף השיקום',
    subTitle: 'כדי להתקדם, נצטרך מספר פרטים',
    successPageOTP: 'פנייתך התקבלה בהצלחה',
    successPage: 'פנייתך התקבלה בהצלחה',
    back: 'חזרה למסך הקודם',
  },
  [DICTIONARY.Notifications]: {
    title: 'עדכונים ומסמכים',
    updatesSubTitle: 'כאן יופיעו עדכונים ומסמכים מטעם האגף.',
    documentsSubTitle: [
      'פה נעדכן אותך על כל מה שחשוב לדעת.',
      'עדכונים יופיעו פה למשך חודש ולאחר מכן יימחקו, אבל המסמכים שלך שמורים פה, לנוחיותך',
    ],
    updates: 'עדכונים',
    documentsAndMail: 'מסמכים',
    didNotRead: 'לא נקראו',
    allDocuments: 'כל המסמכים',
    sortBy: 'מיון לפי',
    noNewUpdates: 'אין עדכונים חדשים עבורך ',
    whenNewUpdate: 'כשיהיה עדכון חדש עבורך, הוא יופיע פה',
    whenNewDocument: 'כשיהיה מסמך חדש עבורך, הוא יופיע פה',
    whatCanWeOfferYouNow: 'מה נוכל להציע לך עכשיו?',
    rightsCompass: 'מצפן הזכויות',
    newRequest: 'הגשת בקשה חדשה',
    makeContact: 'יצירת קשר',
  },
  [DICTIONARY.Applies]: {
    allYourApplies: 'לכל הפניות שלך',
    noApplies: 'אין פניות חדשות',
    whenNewApplyDesktop1:
      'כל פנייה ממך, שנקלטה דרך המוקד או האתר החל מ-22.10.2023, תופיע פה לנוחיותך.',
    whenNewApplyDesktop2: 'מידע על פניות קודמות, ניתן לקבל במוקד',

    whatCanWeOfferYouNow: 'מה נוכל להציע לך עכשיו?',
    rightsCompass: 'מצפן הזכויות',
    makeNewRequest: 'שליחת פנייה לאגף',
    appliesForSelectedFilters: 'בקשות לסינון שבחרת',
    applies: 'פניות',
    openedByWing: 'הזמנה זו נפתחה לבקשתך על ידי האגף',
    openedByRep: 'הפנייה נפתחה על ידי המייצג המשפטי שלך',
    found: 'נמצאו',
    filterResults: 'תוצאות סינון',
    yourRequests: 'ריכוז פניות לאגף',
    adminYourRequests: 'מחיקת פניות לאגף',
    errorStatusMessage: 'סליחה, הייתה תקלה. מומלץ לשלוח שוב',
    forNewRequest: 'שליחת פנייה חדשה',
    hereAreAllTheRequestsYouAppliedToTheSector:
      'כאן נמצאת רשימת פניות לאגף שקיבלנו ממך, דרך האתר או בטלפון - וכן מידע על כל פנייה',
    applicationNumber: 'מספר פנייה',
    status: 'מצב טיפול',
    applicationOpeningDate: 'תאריך פתיחת הבקשה',
    statusUpdateDate: 'תאריך עדכון',
    betweenDates: 'בין תאריכים',
    byYear: 'לפי שנה',
    year: 'שנה',
    fromDate: 'מתאריך',
    toDate: 'עד תאריך',
    onlineApplication: 'פנייה באתר',
    phoneApplication: 'פנייה טלפונית',
    initiatedByDepartment: 'פנייה יזומה מהאגף',
    selfReferral: 'פנייה באתר',
    onlineApplicationFilter: 'פנייה באתר',
    phoneApplicationFilter: 'פנייה טלפונית',
    initiatedByDepartmentFilter: 'פנייה מהאגף',
    applyOpenDate: 'תאריך פתיחה במערכת:',
    toBeDetermined: 'ייקבע בהמשך',
    phoneRequestOpened: 'פנית אלינו בטלפון בנושא',
    webRequestOpened: 'פנית אלינו באתר בנושא',
    requestOpened: 'הוגשה בקשה בנושא ',
    newRequestOpened: 'הוגשה בקשה חדשה',
    newRequest: 'פנייה חדשה',
    byRequestTitle: 'לפי נושא פנייה',
    byRequestNumber: 'לפי מספר פנייה',
    byRequestStatus: 'לפי מצב הטיפול',
    byRequestType: 'לפי סוג פנייה',
    requestOpenDate: 'תאריך פתיחה במערכת',
    sendUniversalRequest: 'לשליחת תשובה לאגף',
    universalRequestInitiatedByDepartmentDescription: (reqNumber: string) =>
      `מענה לפניה יזומה מס' ${reqNumber}`,
    noResults: 'אין תוצאות',
    noResultsFilter:
      'כדאי לשנות את אפשרויות הבחירה בסינון, כדי לחפש תוצאות נוספות',
    clear: 'איפוס בחירה',
    ariaLabelRest: 'איפוס שדות החיפוש',
    showResults: 'הצגת תוצאות',
    from: 'מ',
    to: 'עד',
    updateDate: 'תאריך עדכון',
    rehabilitationDepartment: 'אגף השיקום',
    applyOpened: (applicationTitle: string) =>
      `קיבלנו ממך פנייה בנושא ${applicationTitle} והיא נפתחה במערכת. נעדכן אותך פה לגבי המשך הטיפול`,
    subjectAndDate: (subject: string, date: string) =>
      `נושא הפניה: ${subject}. מתאריך: ${date}`,
    yourRequestWasTransferred:
      'רצינו לעדכן אותך שבדקנו את פנייתך והיא הועברה לגורם המקצועי המתאים',
    replyDetails: 'פירוט המענה:',
    noReplyDetails: 'אין פירוט',
    earlierRequests: 'פניות קודמות לאגף',
    delete: 'מחיקה',
    closeList: 'צמצום רשימה',
    documentToDownload: 'מסמך להורדה',
    medicalRefferalAttached: 'הי, מצורפת ההפניה שביקשת. יום טוב',
    yourMedicalRefferal: 'ההפניה שלך מצורפת פה לבקשתך:',
    downloadYourFile: 'להורדת ההפניה',
    selfReferralDownload: 'הורדת התחייבות',
    allMedicalRefferal: 'לכל ההפניות שלך',
    partialHandling:
      'טיפלנו באחד מהנושאים בפנייה שלך. אם יהיו עדכונים נוספים הם יופיעו פה',
    moreInfoInPaymentsPage: 'עוד מידע בפירוט תשלומים וניכויים',
    benefitsText: (subject: string, amount: number) =>
      `אושר לך החזר הוצאות בנושא ${subject.trim()}${
        amount ? ', בסכום של ' : ''
      }`,
    nis: 'ש"ח',
  },

  [DICTIONARY.Requests]: {
    prefix: 'קידומת',
    title: 'זכויות שעשויות להתאים לך',
    continue: 'המשך',
    back: 'חזרה',
    upload: 'העלאת קובץ',
    additionalFileAttachment: 'צירוף קובץ נוסף',
    submit: 'שליחת בקשה',
    requiredAttachments: 'קבצי חובה',
    optionalAttachments: 'קבצי בחירה',
    requiredDoc: '(מסמך חובה)',
    required: '(חובה)',
    requiredOneOf: (amount: number) =>
      `עליך לצרף קובץ לבחירתך מבין ${amount} האפשרויות הבאות`,
    stepperSrLabel: (currentStep: number, stepsLength: number) =>
      `שלב ${currentStep} מתוך ${stepsLength}`,
    updateBankDetails: 'עדכון חשבון בנק',
    updatePersonalDetails: 'עדכון פרטים אישיים',
    expenseClaim: 'בקשת החזרי נסיעות',

    Step1: {
      title: 'צירוף קבצים',
      subTitle: 'יש לצרף את הקבצים הנדרשים',
      bankDetailsSubtitle: 'כדי לעדכן את חשבון הבנק, נצטרך לקבל ממך את הקבצים:',
      list1:
        'ניתן לצרף קבצים בגודל של עד 20MB עם הסיומות הבאות: png, jpg, doc, docx pdf, tif.',
      list2: 'שמות הקבצים צריכים להכיל אותיות בעברית ובאנגלית בלבד.',
      list3: 'העלאת הקבצים עשויה לקחת מספר דקות.',
      list4: 'קבצים המסומנים ב* הינם קבצי חובה להעלאה',
    },

    Step2: {
      title: 'הוספת הערות',
      subTitle: 'זה המקום להוסיף פרטי מידע שחשוב לך שנדע',
      requestNotes: 'פרטי הבקשה',
      requestNotesPlaceholder:
        'בקשות מיוחדות? משהו שלא ציינת בבקשה? אפשר לכתוב כאן',
      phoneNumber: 'טלפון שבו נוכל להשיג אותך, במידת הצורך',
      phone: 'טלפון',
      prefix: 'קידומת',
      errorPhone: 'יש למלא טלפון עם 7 ספרות ולבחור קידומת',
      phonePrefixError: 'יש לבחור קידומת',
    },

    successDialog: {
      altTitle: 'הבקשה שלך נשלחה',
      title: (formName: string) => `הבקשה שלך ל${formName} נשלחה`,
      info: 'ניצור איתך קשר בהמשך להשלמת פרטים, במידת הצורך',
      expenseClaimInfo: 'הבקשה שלך הוגשה בהצלחה והועברה לטיפול באגף השיקום',
      requestId: 'מספר בקשה:',
      date: 'תאריך הגשת הבקשה:',
      newRequest: 'הגשת בקשה נוספת',
      finish: 'סיום',
      linkInfo: {
        general: 'אפשר לעקוב אחר הבקשה באזור',
        updatePersonalDetails: 'אם הבקשה תאושר, העדכון יופיע באזור',
        updateBankDetails: 'אפשר לעקוב אחרי מצב הבקשה',
      },
      linkText: {
        general: 'ריכוז פניות',
        updatePersonalDetails: 'הצגת פרטים אישיים',
        updateBankDetails: 'כאן',
        expenseClaim: 'לצפייה בבקשה שהגשת',
      },
      requestsLobbyUrl: `/applies`,
      personalAreaUrl: `/personal-details`,
      expenseClaimUrl: `/applies`,
    },

    deleteFile: {
      deleteModalFirstParagraph: 'רק שניה בבקשה...',
      deleteModalConfirmButton: 'כן, אפשר למחוק',
      deleteModalCancelButton: 'לא למחוק',
      deleteModalConfirmTitleGeneral: 'האם ברצונך למחוק פריט זה?',
      deleteModalExitAlt: 'סגור חלונית מחיקת קובץ',
    },
    noFileAttached: 'לא צורף קובץ לפנייה',
    sendWithoutFile: 'שליחה ללא הקובץ',
  },

  [DICTIONARY.Equipment]: {
    title: 'ציוד מתכלה',
    orderEquipment: 'הזמנת ציוד',
    requestEligibilityForNewEquiupment: 'בקשת זכאות לציוד',
    requestRefund: 'בקשת החזר כספי',
    breadcrumbs: 'חזרה לציוד מתכלה',
    RecentOrders: {
      title: 'הזמנות אחרונות',
      date: 'תאריך הזמנה',
      productsCount: 'מספר פריטים',
      orderId: 'מספר הזמנה',
      yourProducts: 'הפריטים שהזמנת',
      status: 'מצב הטיפול',
      orderDetails: 'פרטי ההזמנה',
      duplicateOrder: 'שכפול הזמנה',
      orderPeriodInfo: (numberOfMonths: number, endDate: string) => {
        if (numberOfMonths === 1) {
          return `הוזמן ציוד לחודש, עד ${endDate}`;
        } else if (numberOfMonths === 2) {
          return `הוזמן ציוד לחודשיים, עד ${endDate}`;
        } else {
          return `הוזמן ציוד ל-${numberOfMonths} חודשים, עד ${endDate}`;
        }
      },
      moreInfo: 'למידע נוסף',
      aboutOrderFrom: 'על הזמנה מתאריך',
      loadMoreOrders: 'טעינת הזמנות נוספות',
      moreOrders: 'הזמנות נוספות',
      lastOrderDate: 'הזמנה אחרונה בוצעה ב-',
      showMoreOrders: 'להזמנות קודמות שלך',
      duplicateLink: '/Equipment/createOrder/',
      accessibilityInfo: 'על ידי לחיצה ניתן לקבל מידע נוסף על הזמנה זו ',
    },
    orderDialog: {
      orderNum: 'מספר הזמנה',
      createdInSystemDate: 'תאריך פתיחה במערכת',
      validity: 'תוקף ההזמנה',
      itemName: 'שם הפריט',
      quantity: 'כמות',
      notes: 'הערות',
      orderNotes: 'הערות להזמנה',
      status: 'מצב הטיפול',
      statusTitle: 'מצב הטיפול במרשם',
      willBeSettledLater: 'ייקבע בהמשך',
      immediateValidity: 'תוקף מיידי',
      isSupplied: 'הפריט סופק',
      isNotSupplied: 'הפריט לא סופק',
      returnToEquipment: 'וחזרה לעמוד ציוד מתכלה',
    },
    orderSummaryDialog: {
      closeDialog: 'סגירה וחזרה לעמוד ציוד מתכלה',
      title: 'סיכום ההזמנה לפני שליחה',
      subtitle:
        'מומלץ לעבור על פרטי ההזמנה ולוודא שלא חסר לך כלום, לפני שליחת ההזמנה',
      summaryOrderItems: 'בחרת להזמין',
      items: 'פריטים',
      forPeriod: 'לתקופה של',
      packages: 'חבילות',
      editOrder: 'עריכת הזמנה',
      submitOrder: 'שליחת הזמנה',
      orderNote: 'הערות להזמנה',
      itemNote: 'הערות פריט',
      quantityNote: 'הסבר להגדלת כמות',
    },
    successOrderDialog: {
      title: 'קיבלנו את ההזמנה ונטפל בה בהקדם',
      subtitle: 'אפשר לעקוב אחר מצב הטיפול באזור ציוד מתכלה',
      date: 'תאריך:',
      youOrder: 'הזמנת',
      items: 'תרופות',
      orderStatus: 'ניתן להתעדכן במצב טיפול ההזמנה',
      thisLink: 'בקישור הבא',
      whatNext: 'אז מה קורה עכשיו?',
      list1: 'נעבור על פרטי ההזמנה, ובמידת הצורך ניצור איתך קשר לבירורים',
      list2: 'אחרי שנאשר אותה, היא תעבור לטיפול סופר-פארם',
      list3: 'יגיע אליך עדכון לגבי מועד המסירה',
      finish: 'סיום',
      over30Items: 'בהתאם לכמות הפריטים שהזמנת, ההזמנה שלך תפוצל לשתי הזמנות',
      medicinePage: 'באזור תרופות ומרשמים',
      followOrderHere: [
        'אפשר לעקוב אחר מצב הטיפול בהזמנות',
        'באזור ציוד מתכלה',
      ],
      followOrderHereMobile: [
        'אפשר לעקוב אחר מצב הטיפול',
        'באזור ציוד מתכלה',
        'באזור ציוד מתכלה',
      ],
    },
    existingOrderDialog: {
      title: 'לפני ההזמנה, חשוב לדעת',
      info1: 'קיימת במערכת הזמנה עבורך, שהתקבלה בתאריך ',
      info2: 'אפשר להתעדכן במצב הטיפול שלה דרך רשימת ״הזמנות אחרונות״ ',
      info3: '"ציוד מתכלה"',
      info4: ', דרך רשימת הזמנות אחרונות.',
      submit: 'ביצוע הזמנה נוספת',
      back: 'חזרה',
      medicineLine: 'אפשר לעקוב אחר מצב הטיפול',
      medicineLineLabel: 'באזור תרופות ומרשמים',
    },
    hereYouOrderConsumableEquipment: 'כאן מזמינים ציוד מתכלה',
    whatIsConsumableEquipment: 'מה זה ציוד מתכלה?',
    medicalEquipmentWillBeProvidedInAccordanceWithTheMedicalRecommendations:
      'ציוד רפואי, כמו מזרקים, תחבושות, קטטרים ועוד. הציוד יסופק לך באופן שוטף לצורך הטיפול הרפואי, בהתאם להמלצות הרפואיות ',
    forYourAttention: 'לתשומת ליבך,',
    youHaveNotBeenApprovedYetToOrderEquipmentYouMustRequestEligibility:
      'אין לך ציוד מתכלה מאושר להזמנה.',
    howDoYouRequestEligibilityForConsumableEquipment:
      'איך מגישים בקשה לציוד מתכלה?',
    step1ObtainingAMedicalRecommendation: 'שלב 1 – קבלת המלצה רפואית',
    youMustContactYourDoctorToGetAMedicalRecommendationForEquipment:
      'יש לפנות לרופא או הרופאה שלך, ולקבל המלצה רפואית לציוד הנדרש לצורך הטיפול הרפואי',
    step2SubmittingAnApplication: 'שלב 2 – הגשת בקשה',
    youMustSubmitAnApplicationAndAttachTheMedicalRecommendationYouReceived:
      'יש להגיש בקשה למרפאה במחוז שלך ולצרף את ההמלצה הרפואית שקיבלת',
    youAlreadyHaveAMedicalRecommendationToReceiveEquipment:
      'כבר יש לך המלצה רפואית לקבלת ציוד?',
    ifYouReceivedRecommendationSubmitRequestForEquipment:
      'באפשרותך להגיש אותה כאן באתר',
    submissionOfARequestForEligibilityForEquipment: 'הגשת בקשה לציוד מתכלה',
    otherWaysToSubmitTheApplication: 'דרכים נוספות להגיש את הבקשה',
    byPhone: 'בטלפון 8150*',
    byFax: 'בפקס 03-4454554',
    afterSubmittingTheApplicationTheTreatmentWillPassIntoOurHands:
      'אחרי הגשת הבקשה, הטיפול יעבור לידיים שלנו',
    weWillCreateAnEligibilityCardForYouWhichWillIncludeTheItemsApprovedForYou:
      'אם היא תאושר אנו נעביר התחייבות (הפניה) לסופר-פארם',
    aDistrictDoctorWillExamineYourApplicationAndForwardARecommendationToTheDepartment:
      'רופא או רופאה מחוזיים יבדקו את הבקשה שלך',
    weWillIssueAnInitialReferralToSuperPharm:
      'נוציא התחייבות (הפניה) ראשונית לסופר-פארם',
    asSoonAsTheReferralIsReceivedBySuperPharmWeWillSendYouATextMessage:
      'לאחר שההפניה תתקבל בסופר-פארם, אנו נעדכן אותך על כך במסרון',
    superfarmWillDeliverToYourHome: 'סופר-פארם יספקו את הציוד ישירות לביתך',
    forQuestionsContactTheHotlineOnTheWebsiteOrByPhone: [
      'בכל שאלה ניתן לפנות למוקד הטלפוני 8150*',
      ' נשמח לעזור במוקד הארצי',
      '*8150',
      '8150*',
      'בכל שאלה ניתן לפנות למוקד הטלפוני',
    ],
    contactComponent: [
      'יש לך שאלות על ההזמנה?',
      'המוקד הארצי לשירותך בטלפון',
      '*8150',
      '8150*',
    ],
    orderStatus: {
      '1': 'ממתין לפתיחה במערכת',
      '2': 'אספקה חלקית',
      '3': 'הזמנה נדחתה',
      '5': 'הזמנה סופקה',
    },
    orderNotes: 'הערות להזמנה',
    createOrder: {
      addOrderComments: ' הערות ',
      title: 'הזמנת ציוד',
      subTitle:
        'ברשימה מופיעים כל הפריטים שאושרו לך. יש לסמן את אלה שברצונך להזמין וללחוץ על כפתור המשך להזמנה שבסוף הרשימה ',
      headerNote: 'הכמות המוצגת לכל פריט, מבוססת על ההזמנות הקודמות שלך',
      periodOrder: 'הציוד צריך להספיק ל...',
      periodOrderTitle: 'תקופת ההזמנה',
      periodOrderLabel: 'לכמה זמן הציוד שיוזמן צריך להספיק לך?',
      month1: 'חודש',
      month2: 'חודשיים',
      month3: '3 חודשים',
      month6: 'חצי שנה',
      selectAllItems: 'סימון כל הפריטים',
      orderNote: 'הערות ',
      orderNotePlaceholder: 'בקשות או הערות על הפריט הזה, ניתן לכתוב כאן',
      quantity: 'כמות',
      noteInfoError: 'כמויות בפריטים שונות מהממוצע החודשי',
      attention: 'לתשומת ליבך',
      quantityNote:
        'בחרת כמות גדולה מזו שאושרה לך, וייתכן שניצור איתך קשר לבירור השינוי, טרם יציאת ההזמנה',
      quantityNotePlaceholder: 'לטיפול מהיר, כדאי להסביר למה הגדלת את הכמות',
      oldItems: 'פריטים שהזמנת לפני יותר משנה',
      continue: 'המשך להזמנה',
      chooseXItems: (x: number) => `בחרת להזמין ${x} פריטים`,
      chooseItem: 'בחירת פריט',
      increaseQuantity: 'הגדלת כמות',
      decreaseQuantity: 'הקטנת כמות',
      errorSelectItem: 'חובה לבחור פריט אחד לפחות',
      insertUpTo100Chars: 'יש להכניס עד 100 תווים',
      itemUnavailable: 'הפריט אינו זמין יותר',
      contactDoctorForAlternativeItem:
        'ניתן לפנות לרופא או הרופאה שלך, ולקבל המלצה לפריט חלופי',
    },
  },
  [DICTIONARY.UpdateBankDetails]: {
    title: 'פירוט הבקשה',
    subTitle: 'לאיזה חשבון בנק (שרשום על שמך) להעביר את התשלומים?',
    bankDetails: 'פרטי חשבון בנק',
    inputLabel1: 'שם הבנק (חובה)',
    inputLabel2: 'קוד הסניף (חובה)',
    inputLabel3: 'מספר חשבון בנק (חובה)',
    inputLabel4: 'אני הבעלים של החשבון הזה',
    errorMessage:
      'הפרטים שהקלדת, הם הפרטים שכבר קיימים במערכת, לכן אין צורך לעדכן',
    bankDescription:
      'לבחירת ערך, התחל לכתוב את שם הבנק והשתמש בחיצי המקלדת - למעלה או למטה. לאחר בחירת הערך, אשר את בחירתך באמצעות מקש Enter',
    branchDescription:
      'לבחירת ערך, התחל לכתוב את קוד הסניף והשתמש בחיצי המקלדת - למעלה או למטה. לאחר בחירת הערך, אשר את בחירתך באמצעות מקש Enter',
  },
  [DICTIONARY.UpdatePersonalDetails]: {
    title: 'עדכון פרטים אישיים',
    subTitle:
      'פה מרוכז המידע שיש לנו עליך, כפי שהוא מופיע במערכות שלנו. אפשר לעדכן או לתקן את הפרטים',
    contactDetails: {
      title: 'פרטי התקשרות',
      subtitle: 'עדכון מספר טלפון או דואר אלקטרוני',
      inputLabel1Prefix: 'קידומת טלפון',
      inputLabel1Number: 'מספר טלפון',
      inputLabel2Prefix: 'קידומת טלפון נוסף',
      inputLabel2Number: 'מספר טלפון נוסף',
      inputLabel3: 'דואר אלקטרוני',
      reset: 'איפוס פרטי התקשרות',
    },
    maritalStatus: {
      title: 'מצב משפחתי',
      subtitle: 'עדכון המצב המשפחתי שלך',
      inputLabel1: 'מצב משפחתי',
      inputPlaceholder1: 'מצב משפחתי חדש',
      inputLabel2: 'תאריך שינוי מצב משפחתי',
      spouseDetails: {
        title: 'פרטי בן או בת הזוג ',
        inputLabel1: 'תעודת זהות',
        inputLabel2: 'שם פרטי',
        inputLabel3: 'שם משפחה',
        inputLabel4: 'תאריך לידה',
        inputLabel5: 'מגדר',
      },
      reset: 'איפוס מצב משפחתי',
    },
    address: {
      title: 'כתובת מגורים',
      subtitle: 'עדכון כתובת מגורים וכתובת למשלוח דואר',
      inputLabel1: 'מדינה',
      address: {
        title: 'כתובת',
        mailAddressOrMailBox: 'כתובת למשלוח דואר או תא דואר',
        mailAddress: 'כתובת למשלוח דואר',
        mailBox: 'תא דואר',
        inputLabel1: 'ישוב (חובה)',
        inputLabel1Abroad: 'מדינה',
        inputLabel2: 'רחוב',
        inputLabel2Abroad: 'ישוב',
        inputLabel3: 'מספר בית',
        inputLabel4: 'מספר דירה',
        mailBoxInputLabel4: 'תא דואר',
        inputLabel5: 'מיקוד',
        cityDescription:
          'לבחירת ערך, התחל לכתוב את שם הישוב והשתמש בחיצי המקלדת - למעלה או למטה. לאחר בחירת הערך, אשר את בחירתך באמצעות מקש Enter',
        countryDescription:
          'לבחירת ערך, התחל לכתוב את שם המדינה והשתמש בחיצי המקלדת - למעלה או למטה. לאחר בחירת הערך, אשר את בחירתך באמצעות מקש Enter',
      },
      reset: 'איפוס כתובת מגורים',
      locateZipCode: 'לאיתור המיקוד באתר הדואר',
      shippingAddressIsDifferent: 'הכתובת למשלוח דואר שונה מכתובת המגורים',
      israel: 'ישראל',
      otherCountry: 'מדינה אחרת',
      findZipCodeLink:
        'https://israelpost.co.il/%D7%A9%D7%99%D7%A8%D7%95%D7%AA%D7%99%D7%9D/%D7%90%D7%99%D7%AA%D7%95%D7%A8-%D7%9E%D7%99%D7%A7%D7%95%D7%93/',
    },
    addChild: {
      title: 'הוספת ילד או ילדה',
      subTitle: 'במקרה של לידה, אימוץ או פונדקאות',
      childList: 'רשימת ילדים',
      childNumber: 'ילד מספר ',
      child: {
        addChild: (childNumber: number) => `הוספת ילד מספר ${childNumber}`,
        inputLabel1: 'מגדר',
        inputLabel2: 'שם פרטי',
        inputLabel3: 'שם משפחה',
        inputLabel4: 'תאריך לידה',
        inputLabel5: 'תעודת זהות',
        boy: 'בן',
        girl: 'בת',
        male: 'זכר',
      },
      addAnotherChild: 'הוספת ילד נוסף',
      idNumber: 'תעודת זהות',
      dob: 'תאריך לידה',
      delete: 'מחיקה',
      edit: 'עריכה',
      reset: 'איפוס ילדים',
    },
    contactUs: 'רוצה לעדכן פרטים אחרים?',
    happyTohelp: 'נשמח לעזור לך במוקד הארצי',
    needToEdit:
      'לא עדכנת פרטים חדשים. יש לעדכן כדי להמשיך לשלב הבא, או לצאת מהמסך',
    mailBox: 'תיבת דואר',
    landLine: 'מספר נייח',
    extraPhone: 'מספר טלפון נוסף',
    representatives: {
      title: 'ייצוג משפטי - בתהליכי הכרה בנכות ובוועדות הרפואיות',
      waitingForApprovalTitle: 'יש לך בקשה לייצוג משפטי, האם לאשר?',
      waitingForApprovalSubtitle:
        'עורכי הדין שיאושרו על ידך יוכלו לצפות במידע באזור האישי ולבצע פעולות בשמך',
      name: 'שם המייצג',
      license: 'מספר רישיון',
      phone: 'מספר טלפון',
      submit: 'אישור',
      reject: 'סירוב',
      approveTitle: 'האם לרשום את',
      rejectTitle: 'האם לסרב לרישום של',
      removeTitle: 'האם להסיר את הרישום של',
      asYourLawyer: 'כמשרד עורכי דין המייצג אותך?',
      yes: 'כן, לרשום',
      no: 'לא, לחזור',
      yesRemove: 'כן, להסיר',
      noRemove: 'לא להסיר',
      back: 'חזרה',
      toReject: 'לסרב',
      remove: 'הסרה',
      youRemovedYourLawyer: 'ביצעת הסרה למייצג זה. בקרוב המידע יתעדכן באתר',
      yourLawyerRemovedYou: 'המייצג ביקש להפסיק את הייצוג שלך ולכן הוסר',
    },
  },
  [DICTIONARY.BurgerMenu]: {
    menuAriaLabel: 'תפריט ראשי',
    closeMenuAriaLabel: 'סגור תפריט ראשי',
    openMenuAriaLabel: 'פתח תפריט ראשי',
  },
  [DICTIONARY.TestMenu]: {
    title: 'בדיקות של אישורי נכות',
    DisabilityConfirmation: 'אישור נכה צה״ל במשרד הביטחון',
    DisabilityConfirmationWithDetails:
      'אישור נכה צה״ל במשרד הביטחון עם פרטי פגיעות',
    DisabilityConfirmationForAbroadInfo:
      'החזרי הוצאות עבור טיפולי רפואי בחו״ל בנסיעה פרטית קצרה',
    DisabilityConfirmationForAbroad:
      'אישור - החזר הוצאות עבור טיפול רפואי בחו״ל בנסיעה פרטית קצרה',
    DisabilityConfirmationDiscountPurchaseTax: 'אישור - הנחה בתשלום מס רכישה',
    DisabilityConfirmationFreeExemption:
      'אישור - עבור פטור מתשלום אגרת רישום משכנתה',
    DisabilityConfirmationPropertyTaxReduction: 'אישור - הנחה לארנונה',
    DisabilityConfirmationConsentFee: 'אישור - פטור מתשלום דמי הסכמה',
    equipment: 'ציוד מתכלה',
    recognitionStatus: 'סטטוס הכרה',
    notifications: 'עדכונים ומסמכים',
    applies: 'בקשות',
    generalError: 'אירעה שגיאה - לא ניתן ליצור את הקובץ',
    errorCreatingFile: 'לא ניתן ליצור את הקובץ - למשתמש חסרים פרטי פגיעות',
    errorForbidden: 'לא ניתן ליצור את הקובץ - למשתמש אין מעמד נכות מתאים',
    requestsForms: 'טפסי בקשות',
    updatePersonalDetails: 'עדכון פרטים אישיים',
    updateBankAccount: 'עדכון חשבון בנק',
    tofes106: 'טופס 106',
    expenseClaim: 'החזר הוצאות נסיעה',
    directLinks: 'הורדת טפסים דרך כתובת ישירה',
    viewPersonalDetails: 'הצגת פרטים אישיים',
    personalTeam: 'הצוות האישי שלך',
    compassRights: 'מצפן הזכויות',
    medicalReferrals: 'התחייבויות (הפניות)',
    paychecks: 'תלושי תגמולים וטפסי 106',
    treatment: 'הזמנת הבראה וחמי מרפא',
    confirmBenefits: 'תשלומים וניכויים',
    documents: 'המסמכים שלי',
    otpLogin: 'התחברות OTP',
    universalRequest: 'פנייה אוניברסלית',
    disabilityConfirmations: 'אישורי נכות',
    B2C: 'B2C תבניות HTML',
    B2CMatrixLogin: 'התחברות B2C סביבת מטריקס',
    redirectsCodes: 'יצירת קוד ספקים',
    eshetTurs: 'אשת טורס',
    flyingCarpet: 'השטיח המעופף',
    redirectError: 'לא הצלחנו לייצר קוד',
  },
  [DICTIONARY.Confirmations]: {
    title: 'אישורי נכות',
    downloadWillStartAuto:
      'הורדת קובץ האישור תחל באופן אוטומטי לתיקיית ההורדות בדפדפן',
  },
  [DICTIONARY.PersonalDetails]: {
    personalStatus: 'מצב אישי',
    title: 'פרטים אישיים',
    noData: 'אין מידע',
    subTitle:
      'פה מרוכז כל המידע עליך, כפי שהוא מופיע במערכות שלנו. אם מצאת טעות, אפשר לעדכן פרטים',
    userGeneralInformation: {
      title: 'המידע שלך',
      fullName: 'שם מלא',
      id: 'תעודת זהות',
      caseNumber: 'מספר תיק',
      familyStatus: 'מצב משפחתי',
      single: 'רווק/ה',
      married: 'נשוי/אה',
      divorced: 'גרוש/ה',
      widower: 'אלמן/ה',
    } as { [key: string]: string },
    contactInformation: {
      title: 'פרטי התקשרות',
      phone: 'טלפון ',
      mobilePhone: 'נייד',
      homePhone: 'נייח',
      email: 'כתובת דואר אלקטרוני',
      noEmail: 'חסרה כתובת דואר אלקטרוני',
    },
    representativesTitle: 'ייצוג משפטי - בתהליכי הכרה בנכות ובוועדות הרפואיות',
    familyStatus: {
      title: 'מצב משפחתי',
      male: 'בן',
      female: 'בת',
      couple: 'זוג',
      partnerInformation: 'פרטי בן או בת זוג',
      childrenInformation: 'פרטי ילדים',
    },
    addressInformation: {
      title: 'כתובת',
      homeAddress: {
        town: 'יישוב',
        street: 'פרטי כתובת',
        zipCode: 'מיקוד',
      },
      postOffice: {
        title: 'כתובת למשלוח דואר',
        town: 'יישוב',
        zipCode: 'מיקוד',
      },
    },
    bankInformation: {
      title: 'חשבון בנק',
      bankName: 'שם הבנק',
      branch: 'סניף',
      accountNumber: 'מספר חשבון',
    },
    disabilityInformation: {
      title: 'סעיפי נכות',
      disabilityStatsPercent: 'אחוז נכות משוקלל: ',
      healthState: 'תיאור הפגיעה',
      disabilityPercent: 'אחוזי נכות',
      dateValidity: 'בתוקף עד',
      disabilityPercentPrevious: 'אחוזי נכות שלא הוכרו',
      bubbleInfo: `נתון זה מתייחס לאחוזי הנכות שלך, שאינם חלק מהפגיעה שעברת
      בשירות הבטחוני ועליה קיבלת הכרה.
      כלומר, פה מוצג אחוז נכות שאנחנו מודעים אליו בקשר אליך,
      אבל אינו חלק מהשקלול המלא של ההכרה.
      לדוגמה: אם עברת פגיעה בגב במהלך שירות, וגם פריצת דיסק באזרחות,
      אז פריצת הדיסק תיחשב כאחוזי נכות שלא הוכרו.`,
    },
    links: {
      updateBankDetails: 'לעדכון חשבון בנק',
      updateContact: 'לעדכון פרטי התקשרות',
      updateFamilyStatus: 'לעדכון מצב משפחתי',
      updateAddress: 'לעדכון כתובת',
      disabilityStatsInformation: 'למידע על שקלול אחוזי נכות',
      disabilityCertificate: 'לאישור נכות',
      detailedDisabilityCertificate: 'לאישור נכות מורחב',
    },
    MessagePreferences: {
      preferences: 'העדפות',
      updatePreference: 'איך נוח לך לקבל עדכונים מהאתר?',
      preferenceOption1: 'הודעה לנייד (למספר ישראלי בלבד)',
      preferenceOption2: 'דואר אלקטרוני',
      preferenceOption3: 'שניהם',
    },
  },
  [DICTIONARY.PersonalTeam]: {
    title: 'הצוות האישי שלך',
    district: 'במחוז',
    formNA: 'תיאום תור בפנייה ישירה בלבד',
    districtBox: {
      district: 'להלן פרטי הצוות המטפל בך',
      address: 'כתובת',
      navigation: 'ניווט למחוז',
      phoneContact: 'פרטי התקשרות',
      appointmentNotice: 'השירות ניתן בתיאום מראש בלבד',
      createTicket: 'הזמנת תור במערכת My Visit',
      moreDetails: 'למחלקות המחוז ולפרטים נוספים',
    },
    contactInfoAriaLabelLink: 'יצירת קשר טלפון או אימייל',
    formApp: 'שליחת פנייה באתר',
    generalInfo1: 'חשוב לדעת',
    generalInfo2: 'בשלב זה מעודכנים לך בפרטי הקשר של חבר צוות אחד בכל תחום.',
    generalInfo3:
      'אם יש חברי צוות נוספים שמטפלים בך ולא מופיעים כאן, באפשרותך לראות את פרטי הקשר שלהם כאן:',
    links: {
      generalTLVDistrict: 'לכלל המחלקות במחוז ',
      generalDistricts: 'לכלל מחוזות האגף',
    },
    contactBoxes: [
      {
        title: 'מוקד טלפוני ארצי',
        subtitle:
          'מוקד השירות הטלפוני פעיל בימים ראשון עד חמישי מ-08:00 עד 18:00 במספר 8150*',
        img: CallCenterLogo,
        href: 'https://shikum.mod.gov.il/ContactUs',
      },
      {
        title: 'זימון תור למחוז',
        subtitle: 'הזמנת תור במערכת My Visit לקבלת קהל במחוזות אגף השיקום',
        img: AppointmentLogo,
        href: 'https://myvisit.com/#!/home/signin/',
      },
      {
        title: 'קו תמיכה נפשית',
        subtitle:
          'אין צורך להתמודד לבד, אנחנו כאן בשבילך בכל יום ובכל שעה במספר 8944*',
        img: SupportCenterLogo,
        href: 'https://shikum.mod.gov.il/ContactUs/helpline',
      },
      {
        title: 'תלונות הציבור',
        subtitle: 'הגשת תלונה לפניות הציבור באגף השיקום',
        img: ComplaintsCenterLogo,
        href: 'https://shikum.mod.gov.il/contactus/pages/pniottzibur.aspx',
      },
    ],
  },
  [DICTIONARY.Paychecks]: {
    title: 'תלושי תגמולים וטפסי 106',
    subtitle: {
      lineOne: 'פה אפשר לצפות בתלושי התגמולים החודשיים ובטפסי 106 השנתיים שלך',
      linkText: 'מה זה טופס 106?',
      paychecksLinkText: 'איך לקרוא את תלוש התגמולים',
    },
    paychecks: 'תלושים',
    tofes106: 'טפסי 106',
    month: 'חודש',
    year: 'שנה',
    yearHe: 'שנת',
    recentTofes106: 'טפסי 106 אחרונים',
    recentPaychecks: 'תלושי תגמולים אחרונים',
    resetFilter: 'איפוס בחירה',
    watchFile: 'להורדת הקובץ',
    downloadForm: 'הורדה',
    downloadPaycheck: 'הורדה',
    slip: 'תלוש תגמולים',
    watchAccessibilityFile: 'הורדת תלוש נגיש',
    accessibilityFileNotAvailable:
      'קבצים בפורמט נגיש זמינים החל מחודש מרץ 2017',
    previousPaychecks: 'תלושי תגמולים קודמים',
    previousTofes106: 'טפסי 106 קודמים',
    toggleClose: 'צמצום הרשימה',
    paychecksFileName: 'תלוש-תגמולים',
    tofes106FileName: 'טופס-106',
    accessibility: 'נגיש',
    noDataPayslipsTitle: 'אין לך תלושים עדיין',
    noDataTofes106Title: 'אין לך טפסים עדיין',
    noDataPayslipsSubtitle: 'כשיהיה תלוש חדש עבורך, הוא יופיע כאן',
    noDataTofes106Subtitle: 'כשיהיה טופס חדש עבורך, הוא יופיע כאן',
    noDataOfferTitle: 'מה נוכל להציע לך עכשיו?',
    noDataOffer1: 'שליחת פנייה לאגף',
    noDataOffer2: 'יצירת קשר',
    noDataOffer3: 'פירוט תשלומים וניכויים',
    noResultSuggestion:
      'כדאי לשנות את אפשרויות הבחירה בסינון, כדי לחפש תוצאות נוספות',
  },
  [DICTIONARY.CompassRights]: {
    title: 'מצפן זכויות',
    agreementModal: {
      closeModal: 'כפתור סגור וחזרה לדף בית',
      title: 'שלום לך!',
      paragraph1:
        'רכזנו עבורך את הזכויות וההטבות שיתכן ומגיעות לך בהתאם לסוג הפציעה שלך ולמצבך.',
      paragraph2:
        'אפשר למצוא כאן מענקים חד פעמיים וקבועים, הלוואות, סיוע במצבי חיים שונים, תגמולים ועוד.',
      paragraph3:
        'אנו מזמינים אותך לקרוא על כל אחת מהזכויות שמוצגות לך, ואם מצאת משהו שמעניין אותך אפשר לקרוא עליו עוד באתר ההסברתי או לפנות לאגף לבדיקת הזכאות.',
      checkboxLabel: 'קראתי והבנתי',
      sendRequestAgreement: 'לרשימת הזכויות',
      errorMsg: 'יש לאשר כי קראת והבנת את ההצהרה',
    },
    compassRightsHeader: {
      title: 'מצפן הזכויות',
      lastUpdated: 'מעודכן לתאריך: ',
      printForm: 'להורדה והדפסה',
    },
    introBubbleInfo: {
      lineOne:
        'לפניך זכויות והטבות שיתכן ומגיעות לך בהתאם לסוג הפציעה שלך ולמצבך.',
      lineTwo: 'מצאת משהו שמעניין אותך? נשמח לבדוק עבורך זכאות',
      lineOneMobile:
        'לפניך רשימת הזכויות שעשויות להתאים לך. מצאת משהו שמעניין אותך?',
      lineTwoMobileOb: {
        partOne: 'אפשר להגיש ',
        request: 'בקשה באתר',
        partTwo: ' או לפנות למוקד הטלפוני במספר ',
        number: '8150* ',
      },
      lineThreeMobile: 'אנו נשמח לעזור לך במיצוי הזכויות.',
    },
    filterTitle: 'סינון תוצאות לפי נושאים',
    selectedFilterTitle: 'תוצאות סינון',
    clearSelection: 'איפוס בחירה',
    clearSingleSelection: 'נקה מסנן',
    search: 'חיפוש זכות',
    cleanSearch: 'אפס חיפוש זכויות',
    everything: 'הכל',
    validRights: 'הפניות בתוקף',
    filterByCategory: 'סינון לפי קטגוריות',
    noResults: 'לא נמצאו תוצאות',
    noSearchResults: 'לא נמצאו זכויות מתאימות',
    rightsExplained: 'הסבר הזכאות',
    filters: {
      welfare: 'רווחה תגמולים והטבות',
      medical: 'שירותים רפואים',
      medicalFix: 'לשירותים רפואיים',
      social: 'שירותים סוציאלים',
      employment: 'תעסוקה',
      rightsTypes: 'סוגי זכאויות',
    },
    filtersShortName: {
      welfare: 'רווחה',
      medical: 'רפואה',
      social: 'שיקום',
      employment: 'תעסוקה',
    },
    accessibilityFoundResults: {
      found: 'נמצאו',
      results: 'תוצאות',
    },
    removeFilter: 'הסר סינון',
    entitlements: {
      generalInfo: 'תיבת מידע על הזכאות',
      lastUsageDate: 'תאריך מימוש אחרון:',
      nextDateUse: 'מועד המימוש הבא: ',
      lastPage: 'חזרה',
      extraInfo: 'מידע נוסף',
      extraInfoAria: 'מידע נוסף על',
      entitlementOrigin: 'מקור זכאות בהוראה',
      conditions: 'תנאי הזכאות',
      additionalTerms: 'תנאים נוספים',
      watchPDFile: 'צפייה בקובץ PDF',
      operatingConcept: 'תפיסת הפעלה',
      linksAriaLabel: 'לינקים להורדת PDF',
      automatic: 'אוטומטית',
      singleUse: 'חד פעמית',
      belongToCategory: 'הטבה זו שייכת לתחומים',
      type: 'סוג זכאות',
      contact: (contact: string) => `גורם מטפל: ${contact}`,
    },
    resultsFound: (amount: number) => `נמצאו ${amount} זכאויות`,
  },
  [DICTIONARY.MedicalReferrals]: {
    title: 'ההתחייבויות שלך (הפניות)',
    titleInfo: 'כאן אפשר למצוא את כל הבקשות להתחייבות שהגשת לאגף',
    startOfValidity: 'תחילת תוקף ההפניה',
    endOfValidity: 'סיום תוקף ההפניה',
    noData: {
      labels: {
        title: 'אין לך התחייבויות עדיין',
        subtitle: 'כשיהיו לך התחייבויות חדשות הן יופיעו כאן',
      },
      redirects: [
        {
          text: 'מצפן זכויות',
          href: '/Compass-rights',
        },
        {
          text: 'יצירת קשר',
          href: '/Personal-Team',
        },
        {
          text: 'פנייה למרפאה במחוז שלך',
          href: '/universalRequest/2/2',
        },
      ],
    },
    newMedicalRequest: 'הפקת התחייבות',
    search: {
      searchFilter: 'חיפוש לפי נושא הפניה',
      clearSearchFilter: 'נקה חיפוש לפי נושא',
      advancedSearch: {
        title: 'חיפוש מתקדם',
        close: 'סגירה',
        ariaLabelClose: 'סגירת חיפוש מתקדם',
        accordingToRequestState: 'לפי מצב הטיפול',
        accordingToRequestNumber: 'לפי מספר הבקשה',
        accordingToProviderName: 'לפי שם הספק',
        accordingToRequestDate: 'לפי תוקף ההפניה',
        reset: 'איפוס בחירה',
        ariaLabelRest: 'איפוס שדות החיפוש',
        chosen: 'נבחרו',
        showResults: 'הצג תוצאות',
        openRequestDate: 'תאריך פתיחת בקשה',
        ariaLabelOpenRequestDate: 'תאריך פתיחת בקשה בין תאריכים או לפי שנה',
        dateRange: 'בין התאריכים',
        accordingToYear: 'לפי שנה',
        fromDate: 'מתאריך',
        toDate: 'עד תאריך',
        year: 'שנה',
        options: {
          approved: 'אושרה',
          review: 'בבדיקה',
          denied: 'נדחתה',
          cancelled: 'בוטלה',
          opened: 'הבקשה נפתחה',
          valid: 'הפניות בתוקף',
          invalid: 'הפניות לא בתוקף',
          future: 'הפניות עתידיות',
        },
        noResult: 'אין תוצאות',
      },
    },
    validReferrals: 'הפניות בתוקף',
    otherReferences: 'הפניות נוספות',
    filteredReferences: 'תוצאות סינון',
    noResults: 'לא נמצאו תוצאות',
    showAll: 'הפניות קודמות',
    closeList: 'צמצום רשימה',
    result: {
      found: 'נמצאו',
      results: 'תוצאות',
      chosenFilter: 'לסינון שבחרת',
      notFound: 'לא מצאנו את מה שחיפשת',
      changeFilter:
        'כדאי לשנות את אפשרויות הבחירה בסינון, כדי לחפש תוצאות נוספות',
    },
    filterTags: {
      approved: 'אושרו',
      review: 'בבדיקה',
      denied: 'נדחו',
      cancelled: 'בוטלו',
      valid: 'בתוקף',
      invalid: 'לא בתוקף',
      future: 'עתידי',
      reset: 'איפוס בחירה',
      filterTitle: 'סינון התחייבויות',
    },
    chosenFilter: 'לסינון שבחרת',
    referral: {
      subject: 'נושא',
      requestDate: 'תאריך פתיחה',
      requestState: 'מצב טיפול',
      validToDate: 'סיום תוקף הפניה',
      validToDateFull: 'תאריך סיום תוקף ההפנייה',
      validFromDate: 'תחילת תוקף ההפניה',
      validFromDateFull: 'תאריך תחילת תוקף ההפנייה',
      watchFile: 'הורדה',
      ariaLabelDownload: 'לצפייה בקובץ בחלון חדש',
      watchFileFull: 'לצפייה בקובץ',
      requestNumber: 'מספר בקשה',
      providerName: 'שם ספק',
      treatmentStatusDate: 'תאריך עדכון',
      decideLater: 'ייקבע בהמשך',
      furtherInquiry: 'בהמשך לפנייה שלך',
      inquiries: {
        furtherInquiry: 'בהמשך לפנייה שלך',
        furtherInquiries: 'בהמשך לפניותך',
        concentrationOfInquiries: 'מאזור ריכוז פניות לאגף',
      },
      status: {
        approved: 'אושרה',
        review: 'בבדיקה',
        opened: 'הבקשה נפתחה',
        postponed: 'נדחתה',
        reject: 'בוטלה',
      },
      dateStatus: {
        valid: 'התחייבות בתוקף',
        future: 'התחייבות עתידית',
        invalid: 'התחייבות לא בתוקף',
      },
    },
  },
  [DICTIONARY.DisabledVeteran]: {
    metaTitle: 'צפייה בתעודת נכה',
    title: 'תעודת נכה',
    subtitle: 'צה"ל וכוחות הביטחון',
    subtitle2: 'Disabled Veteran',
    permanent: 'לצמיתות',
    permanentEn: 'Permanent',
    watchCard: 'לצפייה בתעודת נכה',
    he: {
      name: 'שם',
      id: 'מספר תעודת זהות',
      caseNumber: 'מספר תיק',
      expiration: 'תוקף',
    },
    en: {
      name: 'NAME',
      id: 'ID NUMBER',
      caseNumber: 'DIS NUMBER',
      expiration: 'EXPIRATION DATE',
    },
    modal: {
      title: 'לא ניתן לצפות בתעודת נכה',
      info1: 'נראה שאין לך זכאות לקבלת תעודה ',
      info2: 'מידע על תנאי הזכאות אפשר',
      info3: 'למצוא פה',
      info3url:
        'https://shikum.mod.gov.il/Payments/Welfare/Pages/Certificate.aspx',
    },
  },
  [DICTIONARY.Treatment]: {
    title: 'חמי מרפא',
    metaTitle: 'הזמנת הבראה וחמי מרפא',
    info: 'הטיפול הרפואי כולל בין היתר, שהייה במלון לצורך הבראה וטיפולים בחמי מרפא, בבתי מלון ברחבי הארץ.',
    infoLinkTitle: 'כל המידע בנושא מפורט בקישור הזה',
    infoLinkUrl:
      'https://shikum.mod.gov.il/medical/relaxation/hotel-accesability',
    extraEntitlementsDaysPrevYear: `נותרו לך ימי זכאות משנת 2023? 
לאור המצב, ניתן לגרור אותם ולממש בשנת 2024`,
    entitlement: 'זכאויות למימוש',
    entitlementType: 'סוג זכאות',
    entitlementCatalogNumber: (catalogNumber: string) =>
      `מקט: ${catalogNumber}`,
    entitlementPeriod: 'תקופת הזכאות',
    entitlementPeriodDates: (startDate: string, endDate: string) =>
      `${startDate} עד ${endDate}`,
    entitlementNights: 'יתרת לילות',
    entitlementNightsBalance: (entitlementDays: number, daysBalance: number) =>
      `${daysBalance} (מתוך ${entitlementDays})`,
    entitlementAttendants: 'מספר מלווים',
    entitlementEndingDate: 'סוף תקופת הזכאות',
    permanently: 'לצמיתות',
    entitlementRestrictionText1:
      'אם יש לך זכאות לימי הבראה בשל מחלת האסטמה וגם לטיפול בחמי מרפא, יש לממש אותם באותו המועד.',
    entitlementRestrictionText2: 'כמות הימים לא נצברת אלא מאוחדת',
    treatmentSupplier: {
      title: 'ביצוע הזמנה',
      subtitle:
        'באפשרותך להזמין הבראה וחמי מרפא דרך אחת מחברות התיירות המטפלות.',
      info: 'כל חברת תיירות מאפשרת הזמנה לבתי מלון שונים. מומלץ להתחיל בבחירת מלון בהתאם לצרכים שלך, ואז לראות איזו חברה מטפלת בהזמנות אליו.',
      info2Label: 'רשימת בתי המלון המלאה נמצאת כאן',
      info2Url:
        'https://shikum.mod.gov.il/medical/relaxation/hotel-accesability',
      watchTutorial: 'לצפייה בסרטון הדרכה',
      eshetVideo: 'https://youtu.be/Lcfw1Al5rWc',
      shatiahVideo: 'https://youtu.be/QumFeXRM5Zs',
      order: 'להזמנה',
    },
    recentOrders: {
      title: 'ההזמנות האחרונות שלך',
      labelFilter: 'לפי שנה',
      chooseYear: 'בחירת שנה',
      orderNumber: 'מספר הזמנה',
      supplierName: 'שם ספק',
      startDate: 'תאריך התחלה',
      nightsNumber: 'מספר לילות',
      attendantsNumber: 'מספר מלווים',
      infoAboutCancelation: 'מידע נוסף על תנאי ביטול והחזרים',
      infoAboutCancelationUrl:
        import.meta.env.VITE_APP_MARKETING_SITE_URL +
        'medical/relaxation/cancellation',
      cancelOrderLabel: 'ההזמנה בוטלה',
      lateCancelation: 'ביטול מאוחר',
      penalty: 'הופחת יום אחד מהזכאות',
      noPanalty: 'לא הופחתו ימי זכאות',
      noData: 'אין לך עדיין הזמנות לתקופה זו',
      noDataSubtitle: 'ניתן לגשת לאתרי חברות התיירות ולבצע הזמנה',
      eshetTours: 'אשת טורס',
      flyingCarpet: 'השטיח המעופף',
    },
    notEntitled: {
      labels: {
        title: 'סליחה, אין לך אפשרות להזמין כרגע',
        subtitle1: 'כשיהיה שינוי בזכאות שלך, אפשר לחזור ולהזמין כאן',
        subtitle2: 'ניתן לגשת לאתרי חברות התיירות ולבצע הזמנה',
      },
      redirects: [
        {
          text: 'מצפן זכויות',
          href: `/compass-rights`,
        },
        {
          text: 'יצירת קשר',
          href: `/personal-team?Contact=1`,
        },
        {
          text: 'פנייה למרפאה במחוז שלך',
          href: '/universalRequest/2/2',
        },
      ],
    },

    status: {
      cancelled: 'הזמנה בוטלה',
      previous: 'הזמנה קודמת',
      future: 'הזמנה עתידית',
    },
  },
  [DICTIONARY.PaymentsDeductions]: {
    title: 'פירוט תשלומים וניכויים',
    subTitle:
      'כאן מרוכזים כל הבקשות למימוש הטבות, החזרי הוצאות וניכויים שונים בחשבון שלך',
    reimbursementRequest: 'בקשת החזר הוצאות',
    noData: {
      labels: {
        title: 'אין לך תשלומים וניכויים',
        subtitle1: 'אין לך תשלומים וניכויים עדיין',
        subtitle2: 'כשיהיו לך הטבות, החזרי הוצאות וניכויים שונים זה יופיע כאן',
      },
    },
    paymentDeductionCard: {
      paymentAmount: 'סכום לתשלום',
      deductionAmount: 'סכום לניכוי',
      noDecision: 'טרם נקבע',
      requestNumber: 'מספר בקשה',
      lastUpdateDate: 'תאריך עדכון מצב טיפול',
      paymentFor: 'התשלום עבור',
      deductionFor: 'הניכוי עבור',
      numberOfMonths: 'מספר החודשים לתשלום',
      paymentDate: 'מועד קבלת התשלום',
      deductionDate: 'מועד הניכוי',
      until: 'עד',
      treatmentMode: 'מצב טיפול',
      setSoon: 'טרם נקבע',
      notYetDetermined: 'טרם נקבע',
      statusCode: {
        opened: 'נפתחה במערכת',
        review: 'בבדיקה',
        done: 'הסתיים',
      },
      groupStatus: {
        payment: 'תשלום',
        deduction: 'ניכוי',
        refund: 'החזר הוצאות',
      },
      deductionType: {
        once: 'חד פעמי',
        permanent: 'לצמיתות',
        installmentsPlan: 'בחלוקה לתשלומים',
      },
      regardingYourApply: 'בהמשך לפנייה שלך',
      regardingYourApplies: 'בהמשך לפניותך',
      fromAppliedLobby: 'מאזור ריכוז פניות לאגף',
      appliesList: 'רשימת הקבלות/חשבוניות שהגשת',
      importantToKnow:
        'תשלום זה מחושב ומבוצע פעם בחודש, בהתאם למועד קבלת התשלום שמופיע פה. מידע זה לא יוצג לך כאן שוב',
      importantToKnowDeduction:
        'ניכוי זה מחושב ומבוצע פעם בחודש, בהתאם לתקופה שמופיעה פה. מידע זה לא יוצג לך כאן שוב',
      refferalApply: 'בהמשך לפנייתך מאזור ריכוז פניות לאגף: ',
    },

    search: {
      accordingToState: 'לפי מצב טיפול',
      accordingToNumber: 'לפי מספר בקשה',
      accordingToType: 'לפי סוג בקשה',
      options: {
        opened: 'נפתחה במערכת',
        review: 'בבדיקה',
        done: 'הסתיים',
      },
      chosen: 'נבחרו',
      groupStatus: {
        payment: 'תשלום',
        deduction: 'ניכוי',
        refund: 'החזר הוצאות',
      },
      updateDateAndState: 'תאריך פתיחה במערכת',
      dateRange: 'בין תאריכים',
      accordingToYear: 'לפי שנה',
      fromDate: 'מתאריך',
      toDate: 'עד תאריך',
      year: 'שנה',
      reset: 'איפוס בחירה',
      showResults: 'הצגת תוצאות',
      searchFilter: 'חיפוש לפי נושא',
      cleanSearch: 'נקה שורת חיפוש',
      noResult: 'אין תוצאות',
    },
    pagination: 'תשלומים וניכויים קודמים',
    closeList: 'צמצום רשימה',
  },
  [DICTIONARY.Documents]: {
    title: 'המסמכים שלך',
    documentsToDelete: 'מסמכים למחיקה',
    noDocuments: 'אין לך מסמכים עדיין',
    noResults: {
      line1: 'לא מצאנו מסמכים שמתאימים לחיפוש הזה.',
      line2: 'כדאי לדייק את מילות החיפוש או מאפייני המסמך',
    },
    noData: 'חסר מידע',
    subNoDocuments: 'כל מסמך חדש ששלחת באתר או קיבלת מהאגף, יופיע כאן',
    subTitle: `כאן מופיעים המסמכים ששלחת באתר 
וקיבלת מהאגף`,
    subTitleNoteDesc:
      'כל מסמך אחר שחיפשת ולא נמצא פה (כמו הפניות, תלושי תגמולים והחזרי הוצאות וכדומה) כנראה מופיע באזור המיועד לו',
    searchFilter: 'חיפוש לפי שם מסמך או נושא',
    clearSearchFilter: 'ניקוי תיבת חיפוש',
    filterByType: 'פילטור לפי סוגי מסמכים',
    documentsDisplayed: 'מסמכים מוצגים',
    mobileDocumentsDisplay: (amount: number) => `מציג ${amount} מסמכים`,
    download: 'הורדה',
    downloadSuccess: 'הקובץ הורד בהצלחה',
    watch: 'צפייה',
    resetChoice: 'איפוס בחירה',
    showResults: 'הצגת תוצאות',
    receivedDoc: 'מסמך שקיבלת',
    sentDoc: 'מסמך ששלחת',
    new: 'חדש',
    timePeriods: {
      today: 'היום',
      thisWeek: 'השבוע',
      thisMonth: 'החודש',
      thisYear: 'השנה',
    },
    receiveDate: 'קיבלת בתאריך',
    sentDate: 'שלחת בתאריך',
    requestNumber: 'מספר פנייה',
    linkedRequest: 'מקושר לפנייה',
    fileType: 'סוג הקובץ',
    receivedDocuments: 'מסמכים שקיבלת',
    receivedDocumentsMobile: 'קיבלת',
    sentDocuments: 'מסמכים ששלחת',
    filterSort: 'מיון וסינון',
    sentDocumentsMobile: 'שלחת',
    sentReceived: 'קיבלת/שלחת',
    allDocuments: 'הכול',
    filterBy: 'סינון לפי',
    filterBySubject: 'סינון לפי נושא',
    docName: 'שם המסמך',
    sortDocs: 'מיון מסמכים',
    downloadDoc: 'להורדת הקובץ',
    subjectType: 'נושא/סוג',
    datePeriod: 'תאריך/תקופה',
    dateRange: 'טווח תאריכים',
    prevYearsDocs: 'מסמכים משנית קודמות',
    docType: 'מסמך מסוג',
    multiSubject: (amount: number) => `נבחרו ${amount} נושאים`,
    multiDatePeriods: (amount: number) => `נבחרו ${amount} תאריכים`,
    newOld: 'מהחדש לישן',
    oldNew: 'מהישן לחדש',
    datePeriodOptions: [
      'ביום האחרון',
      'בשבוע האחרון',
      'בחודש האחרון',
      'בשנה האחרונה',
    ],
    previousYears: 'שנים קודמות',
    noPreviousYearsDocuments: 'אין מסמכים עבור שנה זו',
    noPreviousYearsFilteredDocs: (isSent: boolean | null) =>
      `אין מסמכים ${isSent ? 'שקבלת' : 'ששלחת'} עבור שנה זו`,
    noDocFoundFilter: 'לא מצאנו מסמכים שמתאימים לחיפוש הזה',
    adjustFilter: 'כדאי לדייק את מילות החיפוש או מאפייני המסמך',
    sortBySubject: 'סינון לפי נושא מסמך',
    ariaDescriptionSubjectSort: 'ניתן לבחור כמה נושאים ',
    moreDetailsSubject: 'מידע מורחב ופעולות נוספות בנושא הזה, אפשר למצוא באזור',
    moreDetailsSubjects:
      'מידע מורחב ופעולות נוספות בנושאים אלו, אפשר למצוא באזורים הייעודים:  ',
    chooseDateRange: 'בחירת טווח תאריכים',
    fromDate: 'מתאריך',
    toDate: 'עד תאריך',

    foundDocuments: (count: number) => `מציג ${count} מסמכים`,
    sort: (isOldFirst: boolean) =>
      `מיון: ${isOldFirst ? 'מהישן לחדש' : 'מהחדש לישן'}`,
    previousDocuments: 'מסמכים נוספים',
    delete: 'מחיקה',
    reduceDocuments: 'צמצום רשימה',
    document: {
      name: 'שם המסמך',
      title: 'מסמך בנושא',
      uploadDate: 'תאריך העלאה',
      documentTitleNameTransformation: (fileName: string) =>
        fileName.replace('קיבלת מסמך בנושא ', ''),
      noDocumentsTitle: 'אין לך מסמכים עדיין',
      noDocumentsSubtitle: 'כשיהיה מסמך חדש עבורך, הוא יופיע כאן',
      noDocumentsOffer1: 'שליחת פנייה לאגף',
      noDocumentsOffer2: 'התחייבויות (הפניות)',
      noDocumentsOffer3: 'יצירת קשר',
    },
    searchBarPlaceholder: 'חיפוש מסמך',
    noResultsText: 'אפשר לנסות לחפש ביטוי אחר',
    searchBarLabel: 'לפי שם מסמך',
    filterTitle: 'סינון לפי הנושא שמעניין אותך',
    filterReset: 'איפוס בחירה',
    clearSearch: 'מחק חיפוש',
    documentTitleReplace: 'קיבלת מסמך בנושא',
    expand: 'הצג יותר',
    shrink: 'הצג פחות',
    sortAriaDescription: 'ניתן ללחוץ על מנת להפוך לשנות את המיון',
    searchBarAriaDescription:
      'כאשר תוצאות החיפוש זמינות, יש להשתמש בכפתורי חיצי למעלה ומטה בשביל לעבור על התוצאות וכפתור האנטר בשביל לבצע בחירה. ',
  },
  [DICTIONARY.OTP_Login]: {
    metaTitle: 'פנייה לאגף השיקום',
    metaTitleStep: {
      stepOne: 'שלב 1: אופן התחברות',
      stepTwo: 'שלב 2: פרטים אישיים',
      stepThree: 'שלב 3: אופן אישור זיהוי',
      stepFour: 'שלב 4: אישור קוד חד פעמי',
    },
    invalidUserDialog: {
      title: 'אין אפשרות להגיש פנייה',
      subtitle:
        'לא הצלחנו לאמת אחד או יותר מהפרטים שהקלדת. מומלץ לחזור ולוודא שהם נכונים',
      helpLineText: 'נשמח לעזור טלפונית, במוקד',
      helpLineNumber: '8150*',
      backToEdit: 'חזרה לעריכת פרטים',
      toPersonalArea: 'לאזור האישי',
      moreWaysToContact: 'עוד דרכים ליצירת קשר',
      findHere: 'אפשר למצוא פה',
    },
    loginInformation: {
      title: 'הכי מהיר באזור האישי',
      subTitle: '  עדיף לשלוח פנייה באזור האישי, זה תהליך מהיר ויעיל יותר',
      personalArea: 'התחברות לאזור האישי',
      personalAreaAccess: 'אין לך גישה לאזור האישי? לא נורא',
      requestAbilityWithValidation: 'ניתן לשלוח פנייה בעזרת אימות פרטים',
      continueValidation: 'המשך לאימות פרטים',
      noUserFile:
        'הפנייה מיועדת למי שהוכרו באגף השיקום או הגישו בקשה להכרה בנכות',
      happyToHelp: 'בכל מקרה אחר, נשמח לעזור טלפונית במוקד ',
    },
    personalDetailsForm: {
      formName: 'טופס פרטים אישיים',
      personalDetailsTitle: ['פרטים אישיים', ' של האדם עבורו מיועדת פנייה זו '],
      firstName: 'שם פרטי (חובה)',
      lastName: 'שם משפחה (חובה)',
      idNumber: 'תעודת זהות (חובה)',
      contactDetails: 'פרטי התקשרות כפי שנרשמו באגף',
      phoneNumber: 'מספר טלפון נייד (חובה)',
      phonePrefix: 'קידומת טלפון נייד',
      email: 'דואר אלקטרוני',
      backwards: 'חזרה',
      forward: 'המשך',
      error: 'יש למלא את כל שדות החובה',
      emailNotMandatory:
        'אין חובה למלא דואר אלקטרוני - אבל זה יאפשר לנו לשלוח אליך אישור שפנייתך התקבלה',
      invalidPhone: 'מספר טלפון שגוי (טלפון נייד בלבד)',
    },
    phoneEmailValidation: {
      title: 'אימות פרטי ההתקשרות שלך',
      closeModal: 'סגור',
      subTitle: {
        lineOne: 'כדי לוודא שמדובר בך,',
        lineTwo: 'נצטרך לאמת את פרטי ההתקשרות, ולשלוח קוד חד פעמי',
      },
      sendCodeTo: 'שלחו לי קוד ל:',
      missingMail: [
        'נראה שלא הזנת דואר אלקטרוני.',
        'כדי לקבל את הקוד בדואר אלקטרוני, יש לחזור לשלב הקודם ולהקליד את הפרטים',
      ],
      willBeSentTo: 'הקוד ישלח ל   ',
      phone: 'נייד',
      email: 'דואר אלקטרוני',
      backwards: 'חזרה',
      forward: 'שליחה',
      whatCode: 'מה הקוד שקיבלת?',
      codeTimer: 'הקוד תקף ל',
      codeTimerEnd: 'תם קוף הקוד',
      didntGetCode: 'לא קיבלתי קוד, ',
      sendAgain: 'שלחו שוב',
      wrongCode: 'הקוד שהוקלד לא נכון',
      blocked: 'יותר מדי ניסיונות כושלים, אנא נסה שוב עם קוד חדש',
      codeSentAgain: 'הקוד נשלח מחדש',
      autoCompleteFail: 'השלמה אוטומטית נכשלה, אנא הקלד את הקוד באופן ידני',
      otpCode: 'קוד חד פעמי 4 ספרות',
      weSendingYouCode: 'שלחנו לך קוד למספר ',
    },
    requiredField: 'שדה חובה',
  },
  [DICTIONARY.UniversalRequest]: {
    optionsTitle: 'פנייה לאגף בנושא ',
    choseBy: ['נושא הפנייה', 'גורמים מטפלים', 'תצוגה מורחבת'],
    selectBy: 'בחירה לפי:',
    approvalRecommendationDescription:
      'במקום לשלוח פנייה, אפשר להוריד את האישור בעצמך',
    approvalRecommendationLinkLabel: 'התחברות לאזור האישי',
    title: 'פנייה לאגף השיקום',
    metaTitleStepOne: 'בחירת נושא או מחלקה',
    metaTitleStepTwo: 'בחירת קטגוריה',
    metaTitleStepThree: 'טופס פנייה',
    subtitle: 'באיזה נושא הפנייה שלך?',
    secondSubtitle: 'יש להקליד בתיבת החיפוש, או לבחור מהרשימה',
    tab1: 'לפי נושא',
    tab2: 'לפי גורם מטפל',
    whatsTheSubject: 'באיזה נושא נוכל לעזור?',
    whichDepartment: 'לאיזה מחלקה רצית לפנות?',
    inWhatMatter: 'באיזה עניין?',
    screenReaderInstructions: 'בעת בחירה נעביר אותך לטופס פנייה',
    subject: 'בנושא',
    subject2: 'אל',
    about: 'באיזה עניין',
    getSupplierNote: (supName: string, supId: string) =>
      `ברצוני לבקש התחייבות (הפניה) ל${supName} ${supId}\n`,
    about2: 'פנייה בנושא',
    otherDocument: 'מסמך אחר',
    approvalsTitle: 'אישורים ותעודות',
    otherApprovals: 'אישורים רשמיים ותעודות אחרות',
    disabledVeteranCertificate: 'תעודת נכה צה"ל',
    otherSubject: 'נושא אחר',
    noAvailableDisabilityConfirmations: 'אין לך אישורים זמינים',
    documentSearch: 'חיפוש לפי נושא שיחה או גורם מטפל',
    mayInterestYou: 'יכול לעניין אותך',
    recentRequests: 'פניות אחרונות שהגשת',
    allRequests: 'לכל הפניות שלך באגף >',
    searchDescription:
      'לבחירת ערך, התחל לכתוב את נושא הפנייה והשתמש בחיצי המקלדת - למעלה או למטה. לאחר בחירת הערך, אשר את בחירתך באמצעות מקש Enter',
    selectParentDescription: 'לחיצה על Enter תעביר אותך לנושא הנבחר',
    personalAreaRecommendation: {
      title: 'רק רגע... יש תהליך מהיר יותר',
      downloadTitle: 'לגבי האישור הזה...',
      subtitle:
        'בנושא הזה, קיים תהליך מובנה באזור האישי ובו המידע הרלוונטי לך מוצג בצורה נוחה והטיפול יעיל יותר',
      linkText: 'התחברות לאזור האישי לתהליך מותאם',
      linkURL: '/',
      continueFromHere:
        'אפשר להמשיך גם מפה, אם יותר נוח לך למלא את כל הפרטים בעצמך',
      DownloadContinueFromHere: 'או לשלוח לנו פנייה לגביו, דרך הטופס למטה',
    },
    uploadFile: {
      notePlaceholder: 'זה המקום לפרט את תוכן הדברים, במילים שלך',
      note: 'איך נוכל לעזור?',
      noteFor300:
        'לצורך קבלת תשלום דמי מחלה נודה לאישורך את ההצהרה המופיעה מטה',
      inputFor300: 'אני רוצה לאשר, שבזמן שליחת הפנייה הזו אני לא עובד או עובדת',
      addFiles: 'צירוף קבצים',
      addFilesSubtitle: 'מומלץ לצרף כל קובץ שיסייע לנו לקדם את הטיפול בפנייה',
      addFilesSubtitleOpen:
        'מומלץ לצרף כל קובץ שיסייע לנו לקדם את הטיפול בפנייה. רשימת הקבצים הרלוונטית עבור פנייה זו, מופיעה תחת "בחירת נושא קובץ"',
      fileType: 'נושא הקובץ',
      addFile: 'הוספת קובץ',
      didNotAddFile: 'לא צירפת קבצים',
      file: 'קובץ',
      dragFilesHere: 'ניתן לגרור לכאן קובץ',
      or: 'או',
      chooseFiles: 'העלאת קובץ',
      watch: 'צפייה',
      uploadedSuccessfully: 'המסמך צורף בהצלחה',
      delete: 'הסרה',
      deleteFile: 'מחיקה',
      addFileButton: 'צירוף קובץ (לא חובה)',
      addFileOtherSubject: 'צירוף קובץ בנושא שונה (לא חובה)',
      fileInfo:
        'ניתן לצרף קבצים בגודל של עד 20MB עם הסיומות הבאות: png, jpg, doc, docx pdf, tif.',
      back: 'חזרה',
      clearSelection: 'נקה בחירה',
      unknown: 'לא ידוע',
      duplicateFileError: (fileName: string) =>
        `הקובץ ${fileName} כבר קיים בסוג מסמך זה`,
      submit: 'שליחה',
      submitApply: 'שליחת הבקשה',
      remove: 'הסרה',
      externalLinkLabel: 'לדף המידע',
      closeLabel: 'סגירה',
      extendLabel: 'הרחבה בנושא זה',
      errorMsg: 'רק רגע, צריך לבחור את נושא הקובץ',
      noteErrorMsg: 'חובה למלא את תיאור הפנייה ',
      fileErrorMsg: 'חובה להעלות קובץ עבור שדה זה',
      serverErrorMsg: 'סליחה, הייתה תקלה. מומלץ להעלות את הקובץ שוב',
      doNotHaveFile: (name: string) => `אין ברשותך טופס ״${name}״?`,
      downloadFile: 'להורדה',
      dragFileHere: 'אפשר לגרור לכאן קובץ',
      uploadFile: 'להעלות קובץ',
      requiredFieldsLabel: 'לפנייה מסוג זה חובה לצרף את הקבצים:',
      optionalFieldsLabel: 'ניתן לצרף קבצים נוספים במידת הצורך (לא חובה)',
      attachedFilesTitle: 'צירוף מסמכים',
      invoiceDocumentLabel: 'חשבונית',
      alertBannerIconAriaLabel: 'הודעה חשובה',
      attachedFilesSubtitle:
        'אם יש מסמכים שיעזרו לנו לטפל בפנייה - חשוב לצרף אותם',
      attachedFilesInfo: 'מומלץ לצרף קבצים שיסייעו לנו בקידום הטיפול.',
      missingFileAlert: 'חלון אזהרה על חוסר קובץ מצורף',
      missingFileClose: 'סגירת חלון אזהרה',
      missingFileSubject: (subjectName: string) =>
        `לא צורף קובץ לפנייה בנושא ${subjectName}`,
      applyWithoutFile: 'לא צורף קובץ לפנייה',
      youMissingFile: (subjectName: string) =>
        `נראה ששכחת לצרף קובץ בנושא ${subjectName}`,
      sendWithoutFile: 'שליחה ללא הקובץ',
      whichDocuments: 'איזה מסמכים רצית לצרף?',
      wantToAttachAnother: 'רוצה לצרף מסמך נוסף?',
      allDocumentsSelected: 'כל סוגי המסמכים כבר נבחרו',
      noMoreDocuments: 'אין סוגי מסמכים נוספים זמינים',
      filesCount: (count: number) => `${count} קבצים`,
      uploadedFiles: 'קבצים שהועלו',
      attachDocument: (name: string) => `צירוף ${name}`,
      attachDocumentGeneric: 'צירוף מסמך',
      attachOneOrMore: 'לחצו או גררו קובץ לכאן',
      attachOneOrMoreMobile: 'אפשר לצרף קובץ אחד או יותר',
      selectFiles: 'בחר קבצים',
      documentAttachedSuccessfully: 'המסמך צורף בהצלחה',
      uploading: 'מעלה...',
      uploadError: 'שגיאה בהעלאה',
      removeAllDocuments: (docType: string) => `להסיר את כל מסמכי ${docType}?`,
      filesWillBeDeleted: (count: number) => `${count} הקבצים שצירפת יוסרו`,
      yesRemove: 'כן, להסיר',
      cancel: 'ביטול',
      deleteConfirmation: 'אישור מחיקה',
      documentDeleted: (docType: string) => `המסמך ${docType} נמחק`,
      fileDeleted: (fileName: string) => `הקובץ ${fileName} נמחק`,
      undoDelete: 'ביטול מחיקה',
      close: 'סגור',
      open: 'פתח',
      addAnother: (docType: string) => `צירוף ${docType} נוסף +`,
      fileTooLarge: (maxSize: number) =>
        `הקובץ גדול מדי (מקסימום ${maxSize}MB)`,
      fileSizeExceedsLimit: (maxSize: number) =>
        `גודל הקובץ חורג מהמותר (מקסימום ${maxSize}MB)`,
      unsupportedFileType: 'סוג קובץ לא נתמך',
      unsupportedFileTypeDetailed:
        'סוג קובץ לא נתמך. אנא העלה קובץ מסוג: doc, docx, jpg, jpeg, png, pdf, tif, tiff',
      uploadFailed: 'שגיאה בהעלאת הקובץ',
      deleteAlt: 'מחיקה',
      uploadSuccessAlt: 'הועלה בהצלחה',
      errorAlt: 'שגיאה',
      uploadingAlt: 'מעלה',
      uploadFilesAlt: 'העלאת קבצים',
      selectFilesAriaLabel: 'בחר קבצים להעלאה',
      releaseFilesHere: 'שחרר את הקבצים כאן',
      requiredFieldMissing: (fieldLabel: string) =>
        `שדה חובה חסר: ${fieldLabel}`,
      deleteFileAriaLabel: (fileName: string) => `מחק קובץ ${fileName}`,
      deleteDocumentTypeAriaLabel: (subjectName: string) =>
        `מחק ${subjectName}`,
      closePreview: 'סגירת תצוגה מקדימה',
      zoomOut: 'הקטנה',
      zoomIn: 'הגדלה',
      previewNotAvailable: 'תצוגה מקדימה אינה זמינה עבור סוג קובץ זה',
    },
    successDialog: {
      title: 'סיכום הפנייה ששלחת',
      requestNumber: 'פנייה מספר ',
      name: 'שם',
      subject: 'נושא',
      userId: 'תעודת זהות',
      phone: 'מספר טלפון',
      noteContent: 'תוכן פנייתך',
      filesName: 'קבצים מצורפים',
      backToHomepage: 'חזרה לדף הבית',
      sendMoreRequest: 'שליחת פנייה נוספת',
      uploadMoreFile: 'קובץ נוסף מסוג זה',
      uploadMoreFileOfType: (type: string) => `קובץ נוסף מסוג ${type}`,
      headerTitle1: 'בקרוב נשלח לך דואר אלקטרוני עם הפרטים',
      headerTitle2: ' ניתן לצפות בפנייה באזור האישי',
      headerTitleOTP: ' ניתן לצפות בפנייה באזור האישי',
      headerTitleUrlLabel: 'בפניות לאגף',
      headerTitleUrlLabelOTP: 'בריכוז פניות',
      headerTitleUrl: '/applies',
    },
  },
  [DICTIONARY.Footer]: {
    shikum: 'אגף השיקום',
    ministryOfDefense: 'משרד הביטחון',
    rights: 'אגף השיקום - משרד הביטחון',
    rightsSymbol: '©',
    yourTeam: 'הצוות שלך',
    contactButton: 'יצירת קשר',
    callButton: '8150*',
    mobileLinksTitle: 'הפרטים שלך',
    mobileLinks: [
      {
        label: 'עדכון פרטים אישיים',
        href: '/requests/update-personal-details/8/18',
      },
      { label: 'צפייה בתעודת נכה', href: '/disabled-veteran' },
    ],
    links: {
      contact: {
        title: 'הפרטים שלך',
        redirects: [
          {
            label: 'עדכון פרטים אישיים',
            href: '/requests/update-personal-details/8/18',
          },
          { label: 'צפייה בתעודת נכה', href: '/disabled-veteran' },
        ],
      },
      about: {
        title: 'כללי',
        redirects: [
          {
            label: 'מדיניות פרטיות',
            href: `${import.meta.env.VITE_APP_MARKETING_SITE_URL}about/privacy`,
          },
          {
            label: 'תנאי שימוש',
            href: `${
              import.meta.env.VITE_APP_MARKETING_SITE_URL
            }about/termsofuse`,
          },
          {
            label: 'הצהרת נגישות',
            href: `${
              import.meta.env.VITE_APP_MARKETING_SITE_URL
            }about/accessibility`,
          },
        ],
      },
    },
  },
  [DICTIONARY.Error]: {
    title: 'סליחה, קרתה פה תקלה',
    subtitle: [
      'אם ניסית לבצע פעולה, המידע כנראה לא נשמר',
      'כדאי לנסות שוב מאוחר יותר',
    ],
    contactUsText: 'תמיד אפשר ליצור קשר עם המוקד, במספר',
    manualSupplyPhone: '8150*',
    error: 'תקלה',
  },
  [DICTIONARY.ExpenseClaim]: {
    stepperLabel: (currentStep: number) => `שלב ${currentStep} מתוך 3`,
    pageTitle: 'בקשה להחזר נסיעות',
    title: 'פירוט הנסיעות',
    cardTitle: 'פירוט הנסיעה',
    subtitle: 'עליך לפרט את הנסיעות עליהן רצית לקבל החזר',
    minimizeForm: 'מזעור טופס',
    tripDate: 'תאריך נסיעה',
    tripDetails: 'פרטי הנסיעה',
    usedPublicTransport: 'נסעתי באמצעות תחבורה ציבורית',
    tripCost: 'סכום לתשלום',
    yes: 'כן',
    no: 'לא',
    origin: 'מוצא',
    destination: 'יעד',
    duplicate: 'שכפול נסיעה',
    addExpense: 'הוספת נסיעה',
    declaration: 'כל הנתונים שמסרתי פה נכונים',
    getFileName: (origin: string, destination: string) =>
      `נסיעה מ - ${origin} אל - ${destination}`,
    editModalInitialData: {
      subtitle: 'האם ברצונך לערוך פריט זה?',
      approveButtonText: 'כן, אפשר לערוך',
      declineButtonText: 'לא לערוך',
    },
    mustFillOneForm: 'חובה למלא טופס אחד לפחות',
    mustCheckCheckbox: 'חובה לסמן את התיבה',
  },
  [DICTIONARY.Home]: {
    title: 'עמוד הבית',
    birthdaySubtitle: 'יש לך יום הולדת החודש, שפע ברכות מאיתנו',
    subtitle: 'איך נוכל לעזור לך היום?',
    serverErrorMsg: 'סליחה, קרתה פה תקלה',
    serverErrorMsg2: 'אנחנו עובדים על זה, כדאי להיכנס שוב מאוחר יותר',
    helloName: (name: string) => `שלום ${name}`,
    userClaimEvents: {
      title: 'שלב הטיפול בבקשה להכרה',
      allClaimEvents: 'לשלב הטיפול בכל הבקשות להכרה',
    },
    userRecommendations: {
      title: 'רצינו להזכיר לך...',
      deleteBtnAlt: 'מחיקת המלצה',
      deleteRecommendation: 'התכוונת למחוק את התזכורת?',
      delete: 'כן, למחוק',
      dontDelete: 'לא למחוק',
      requestReferral: 'בקשת הפניה',
      claimedLongTermEquipment: 'הציוד שמגיע לך',
      uploadNewPrescription: 'העלאת מרשם חדש',
      requestPrescription: 'בקשת מרשם',
      newOrder: 'הזמנה חדשה',
      duplicateOrder: 'הזמנות קודמות',
      duplicatePrev: 'שכפול קודמת',
      requestMedicalRefferal: 'בקשת הפניה',
      yourEquipment: 'הציוד שמגיע לך',
      yourTreatments: 'הזכאויות שלך',
      treatmentsInfo: 'מידע על הזכאות שלך',
      applyForRentAssistance: 'סיוע בשכר דירה',
      additionalInfo: 'מידע נוסף',
      renewTuitionExpenses: 'לחדש סיוע לילדך בלימודים',
      renewForeignWorker: 'שליחת ויזה',
      daysRemaining: (daysRemaining: number) => `נותרו ${daysRemaining} ימים`,
      openList: 'רשימת התרופות',
      closeList: 'צמצום הרשימה',
      date: 'מעודכן לתאריך:',
      close: 'סגור',
    },
    userUpdates: {
      pageTitle: 'דף הבית',
      noDataTitle: 'עדיין אין עדכונים',
      noDataSubtitle: 'כשיהיו עדכונים חדשים עבורך, הם יופיע פה',
      title: 'עדכונים עבורך',
      date: 'תאריך',
      new: 'חדש',
      toDownload: 'להורדה',
      allUpdates: 'לכל העדכונים',
      download: 'להורדה',
      allDocuments: 'לכל המסמכים',
      allPayslips: 'לכל השכר',
      allForms106: 'לכל טופס 106',
      allPaymentAndDeductions: 'לפירוט תשלומים וניכויים',
      allMedicalReferrals: 'לכל ההפניות',
      applyStatus: 'לצפייה במצב הטיפול',
      applyCommitmentIssuance: 'לאיתור ההתחייבות',
      moreInfo: 'לפרטים נוספים',
      allMedicationOrders: 'לתרופות ומרשמים',
      allPrescriptions: 'לכל המרשמים',
      allRequests: 'לכל הבקשות',
      allEquipments: 'לכל הציוד',
      recognitionStatus: 'סטטוס הכרה',
      downloadFile: 'להורדת הקובץ',
      navigateTo: 'לחצו למעבר לדף ',
      downloadMedicalReferrals: 'הפניות להורדה',
      toDownloadMedicalReferrals: 'להורדת ההפניות',
      closeList: 'צמצום הרשימה',
      medicalReferralsApproved: 'התחייבויות (הפניות) שאושרו',
      allMedicalReferralsLabel: 'לכל ההפניות',
      toSuperPharm: 'לאתר סופר-פארם',
      medicineOrderList: 'לרשימת התרופות בהזמנה',
      equipment: 'לציוד מתכלה',
      equipmentOrder: 'לרשימת ציוד בהזמנה',
      digitalFolder: 'לתיקייה הדיגיטלית',
      licenseNumber: 'מספר רישיון',
      representativeName: 'שם המייצג',
      phoneNumber: 'מספר טלפון',
      reject: 'סירוב',
      approve: 'אישור',
      commitmentDownloadFileName: (
        selfReferralId: number,
        downloadedAtMs: number,
      ) => `התחייבות ${selfReferralId} ${downloadedAtMs}`,
    },
    userRights: {
      title: 'יש זכויות שעוד לא הכרת?',
      subTitle: {
        found: 'מצאנו',
        rights: 'זכויות שעשויות להתאים לך. לפניך',
        locationAt: 'מתוכן, כל היתר נמצאות',
      },
      subtitle: (totalRights: number, displayCount: number) =>
        ` מצאנו ${totalRights} זכויות שעשויות להתאים לך. לפניך ${displayCount} מתוכן, כל היתר נמצאות`,
      compassRights: 'במצפן הזכויות',
      toCompassRights: 'למצפן הזכויות',
      moreInfo: 'למידע נוסף',
      moreInfoMobile: 'ספרו לי עוד',
    },
    remindYou: {
      youMeantToDeleteTheReminder: 'התכוונת למחוק את התזכורת?',
      yesDelete: 'כן, למחוק',
      dontDelete: 'לא למחוק',
      closeRemindYouCard: 'אל תזכיר לי יותר',
      youHave: 'יש לך',
      medicationsToRenew: 'תרופות שצריך לחדש עבורן מרשם',
      daysRemaining: (daysRemaining: number) => `נותרו ${daysRemaining} ימים`,
      openList: 'רשימת התרופות',
      closeList: 'צמצום הרשימה',
      requestPrescription: 'בקשת מרשם',
      uploadNewPrescription: 'העלאת מרשם חדש',
      weWantedToRemindYou: 'רצינו להזכיר לך...',
    },
    commonActions: {
      title: 'פעולות נפוצות',
      buttonText: 'רשימת הפעולות המלאה',
      actionsLobbyUrl: 'activities-lobby',
      lastPaycheck: 'תלוש אחרון',
    },
    userPaychecks: {
      title: 'תלושי התגמולים שלך',
      noData: 'אין לך עדיין תלוש',
      noDataSubtitle: 'כאן יופיעו תלושי התגמולים שלך',
      showNumbers: 'הצגת סכומים',
      nextPaycheck: 'מעבר לתלוש הבא',
      prevPaycheck: 'מעבר לתלוש הקודם',
      total: 'סכום כולל',
      deductions: 'ניכויים',
      transferToYourAccount: 'הועבר לחשבון שלך',
      allPaychecks: 'לכל התלושים',
      downloadPaycheck: 'להורדת התלוש',
      paycheck: 'תלוש שכר',
      paychecksLinkText: 'איך לקרוא את תלוש התגמולים',
    },
  },
  [DICTIONARY.Updates]: {
    title: 'עדכונים עבורך',
    subtitle:
      'פה נמצאים כל העדכונים ששלחנו אליך במגוון נושאים: הפניות, תלושי תגמולים, מרשמים ועוד',
    noUpdatesSubtitle: 'אין עדכונים כרגע מהאגף כשיהיו לך הם יופיעו כאן',
    filterTitle: 'סינון לפי הנושא שמעניין אותך',
    filterCount: (count: number) => `מציג ${count} עדכונים`,
    filterCountResults: (count: number) => `מציג ${count} תוצאות`,
    previousUpdates: 'עדכונים קודמים',
    date: 'תאריך עדכון',
    redirect1: 'שליחת פנייה לאגף',
    redirect2: 'מצפן זכויות',
    redirect3: 'יצירת קשר',
    redirect4: 'ציוד מתכלה',
    filterLabels: {
      medicals: 'הפניות',
      docs: 'מסמכים',
      payments: 'החזרים',
      applies: 'פניות',
      recognition: 'הכרה',
      prescriptions: 'מרשמים',
      medications: 'תרופות',
      equipment: 'ציוד מתכלה',
      representatives: 'מייצגים',
    },
    deleteBtnAlt: 'מחיקת עדכון העדפות דיוור',
    cancel: 'ביטול',
    messageNotShownAnymore: 'ההודעה לא תוצג שוב',
  },
  [DICTIONARY.MobileMenu]: {
    yourDetails: 'הפרטים שלך',
    yourUpdates: 'העדכונים שלך',
    home: 'דף הבית',
    lawyerHome: 'רשימת המיוצגים שלך',
    fullActionList: 'לרשימת הפעולות המלאה',
    toInfo: 'לאתר המידע',
    disconnect: 'התנתקות',
  },
  [DICTIONARY.DisabilityApprovals]: {
    pageTitle: 'אישורי נכות',
    title: 'אישורים להורדה',
    subTitle: {
      lineOne: 'פה אפשר להפיק ולהוריד את האישורים שלך מאגף השיקום. ',
      lineTwo:
        'אם היה שינוי במצבך או בפרטים האישיים שלך, אפשר להפיק אישור חדש לפי הצורך',
    },
    forWhom: 'עבור מי להפיק את האישור?',
    isSomeoneMissing: 'חסר פה מישהו מהמשפחה?',
    weAreNotUpdated: 'אנחנו לא מעודכנים?',
    updateUs: 'עדכנו אותנו בטופס פרטים אישיים',
    updateUsUrl: 'requests/update-personal-details/8/18',
    canUpdate: 'אפשר לעדכן בטופס פרטים אישיים',
    download: 'הורדה',
    hebrewDownload: 'עברית',
    englishDownload: 'אנגלית',
    downloadAriaLabel: 'להורדת אישור',
    forDownload: 'להורדת',
    inEnglish: 'באנגלית',
    moreInfo: 'מידע נוסף',
    moreInfoAriaLabel: 'למידע נוסף אודות',
    moreApprovals: 'אישורים נוספים',
    noFamilyMembers: [
      'אין לנו פרטים על בן או בת זוג',
      'או ילדים בגילי 7 עד 30',
    ],
    medIssueReport: {
      title: 'הורדת דוח ניפוק תרופות',
      shortTitle: 'דוח ניפוק תרופות',
      description:
        'מרכז את כלל המרשמים והתרופות שהונפקו עבורך בשנה האחרונה ונדרש גם להוצאת רישיון לקנאביס רפואי',
    },
    noData: {
      labels: {
        title: 'אין לך אישורים עדיין',
        subTitle: 'כשיהיה אישור חדש עבורך, הוא יופיע כאן',
      },
      redirects: [
        {
          text: 'שליחת פנייה לאגף',
          href: '/applies',
        },
        {
          text: 'מצפן זכויות',
          href: '/Compass-rights',
        },
        {
          text: 'יצירת קשר',
          href: '/Personal-Team',
        },
      ],
    },
  },
  [DICTIONARY.ActivitiesLobby]: {
    pageTitle: 'לובי פעולות',
    title: 'רשימת הפעולות המלאה',
    subtitle: 'כל הפעולות וקיצורי הדרך לאזורים השונים באתר, במקום אחד',
    searchButton: 'חיפוש פעולה או אזור באתר',
    back: 'חזרה',
    popularSuggestions: 'הצעות פופולריות',
    whichActivity: 'לאיזו פעולה התכוונת?',
    lastPaycheck: 'תלוש אחרון',
    lastForm106: 'טפס 106 אחרון',
    missingPaycheckError: 'עדיין לא עודכן עבורך תלוש תגמולים החודש',
    missingForm106Error: 'עדיין לא עודכן עבורך טופס 106',
    missingEshetToursError: 'האתר לא זמין',
    missingFlyingCarpetError: 'האתר לא זמין',
    noReportError: 'עדיין לא עודכן עבורך. הדוח יעודכן לאחר הזמנת תרופות',
    noLaseEquipmentOrder: 'לא קיימת הזמנה קודמת',
    missingFileError: 'לא הצלחנו להוריד את הקובץ',
    application: 'פנייה',
    searching: 'מחפש...',
    searchHint: 'הקלד לפחות 2 תווים לחיפוש',
    searchInfoOrActions: 'ניתן לחפש מידע או פעולות',
    relatedActions: 'פעולות קשורות',
    noResults: {
      title: 'לא מצאנו את מה שחיפשת',
      subtitle: 'אפשר לחפש פה ביטוי שונה או פעולה אחרת, או לקרוא על נושא זה',
      websiteLabel: 'באתר המידע של האגף',
    },
    payments: {
      title: 'תשלומים ותגמולים',
      lastPaycheck: 'הורדת תלוש אחרון',
      allPaychecks: 'צפייה בכל התלושים',
      paymentsAndDeductions: 'אזור פירוט תשלומים וניכויים',
      last106: 'הורדת טופס 106 אחרון',
      all106: 'לצפייה בכל טפסי 106',
    },
    referrals: {
      title: 'התחייבויות (הפניות)',
      newReferral: 'בקשת התחייבות (הפניה) רפואית חדשה',
      serviceProviders: 'איתור ספקי שירות',
      allReferrals: 'צפייה בכל ההפניות הרפואיות',
    },
    contact: {
      title: 'יצירת קשר ופניות לאגף',
      contactWing: 'שליחת פנייה לאגף',
      contactTeam: 'הצוות האישי שלך',
      bookMeeting: 'זימון תור',
      summary: 'ריכוז פניות ומצב הטיפול',
    },
    treatments: {
      title: 'הבראה וחמי מרפא',
      flyingCarpet: 'לאתר השטיח המעופף',
      eshetTours: 'לאתר אשת טורס',
      accessibleHotels: 'לרשימת בתי מלון נגישים',
      toTreatments: 'לפירוט זכאות והזמנות',
    },
    compassRights: {
      title: 'הזכויות שלך',
      toCompassRights: 'מצפן הזכויות',
      toInfo: 'לאתר המידע של אגף השיקום',
      rightsCards: 'כרטיסי זכאויות',
      longTermSupplies: 'הזמנת ציוד ארוך טווח',
    },
    medicine: {
      title: 'תרופות ומרשמים',
      order: 'הזמנת תרופות קבועות',
      duplicate: 'שכפול הזמנת תרופות קודמת',
      newRecipe: 'שליחת מרשם חדש',
      report: 'דוח ניפוק תרופות',
      history: 'היסטוריית תרופות',
      allOrders: 'לכל ההזמנות והמרשמים',
    },
    equipment: {
      title: 'ציוד מתכלה',
      newOrder: 'הזמנת ציוד מתכלה',
      duplicate: 'שכפול הזמנת ציוד מתכלה קודמת',
      requestNew: 'בקשת זכאות לציוד מתכלה חדש',
      allOrders: 'לכל ההזמנות של ציוד מתכלה',
    },
    recognitionStatus: {
      title: 'מצב טיפול בבקשה להכרה',
      watchStatus: 'צפייה במצב הטיפול בבקשה להכרה',
      statusApplication: 'פנייה בנושא תהליך הכרה',
      committeeApplication: 'פנייה בנושא ועדות רפואיות',
    },
    approvals: {
      title: 'אישורים להורדה',
      veteran: `הורדת אישור נכה צה"ל`,
      detailedVeteran: `הורדת אישור נכה צה"ל מפורט`,
      abroadTreatment: `הורדת אישור נכות לקבלת טיפול רפואי בחו"ל`,
      propertyTexDiscount: 'הורדת אישור להנחה בארנונה',
      purchaseTexDiscount: 'להורדת אישור עבור הנחה בתשלום מס רכישה',
      mortgageFeeExemption: 'הורדת אישור לפטור מתשלום אגרת רישום משכנתה',
      realEstateExemption: 'להורדת אישור להנחה בתשלום דמי הסכמה בהעברת מקרקעין',
      toAllApprovals: 'לכל האישורים',
    },
    yourDetails: {
      title: 'הפרטים שלך',
      toYourDetails: 'צפייה בפרטים שלך',
      updateContact: 'עדכון פרטי התקשרות',
      updateMail: 'עדכון כתובת דואר אלקטרוני',
      updateBank: 'עדכון פרטי חשבון בנק',
      updateAddress: 'עדכון פרטי כתובת',
      updateStatus: 'עדכון פרטי מצב משפחתי',
      addChild: 'הוספת ילד ו/או ילדה',
      certificate: 'צפייה בתעודת נכה דיגיטלית',
      profilePicture: 'עריכת תמונת פרופיל',
    },
    documents: {
      title: 'עדכונים ומסמכים',
      yourUpdates: 'העדכונים שלך',
      yourDocuments: 'המסמכים שלך',
    },
  },
  [DICTIONARY.Suppliers]: {
    request: 'הפקת התחייבות',
    title: 'אגף שיקום - איתור ספקי שירות',
    mapDisplay: 'תצוגת מפה',
    singleSupplierTitle: 'ספק',
    findSuppliers: 'איתור ספקי שירות',
    requiredError: 'יש למלא מקצוע (שדה חובה)',
    expertiseRequiredError: 'יש לבחור מה סוג הטיפול (שדה חובה)',
    locationRequiredError: 'יש לבחור מיקום (שדה חובה)',
    treatmentMethodsDescription: 'ניתן לבחור כמה שיטות טיפול',
    onlineAppointmentTitle: 'קביעת תור און-ליין',
    digitalAppointmentLabel: 'קביעת תור דיגיטלי',
    referralDescription: (specialistName: string) =>
      `אפשר לקבל התחייבות (הפניה) לתור דיגיטלי עם מומחה ב${specialistName}, תוך `,
    xDays: '5 ימים',
    moreInfoButton: 'מידע נוסף',
    referralRequestButton: 'בקשת הפניה',
    doctorsReferralRequestUrl: `${ROUTES.UNIVERSAL_REQUEST}/1/1/77`,
    medicalEquipmentRequestUrl: `${ROUTES.UNIVERSAL_REQUEST}/1/2/3`,
    getTherapyRequestUrl: (name: string, id: string) =>
      `/universalRequest/0/1/80?suppName=${name}&suppId=${id}`,
    geoLocationErrors: {
      userDeny: 'לא ניתן לסנן לפי מיקום',
      positionError: 'תקלה באיתור המיקום שלך',
    },
    lobby: {
      title: 'איתור ספקי שירות וציוד רפואי',
      subTitle: 'מה תחום השירות הנדרש?',
      categories: {
        doctors: 'רופאים ורופאות',
        therapy: 'טיפול נפשי',
        additional: 'ספקים נוספים',
        paramedical: 'משלימים',
        medicalService: 'שירותים רפואיים',
        medicalEquipment: 'ציוד מתכלה',
        imagingInstitute: 'מכוני דימות',
        labTests: 'בדיקות',
        lawyers: 'עורכי דין',
      },
    },
    therapySearchForm: {
      chosen: 'נבחרו',
      title: 'חיפוש טיפול נפשי',
      reset: 'איפוס בחירה',
      resetProfession: 'איפוס מקצוע',
      resetSubSpecialization: 'איפוס תחום טיפול',
      resetLanguages: 'איפוס שפות',
      resetTherapistsName: 'איפוס שם',
      specialization: 'תחום טיפול',
      specializationSubtitle: 'כל הטיפולים הינם טיפולי פסיכותרפיה',
      subSpecialization: 'מה סוג הטיפול? (חובה)',
      specialty: 'התמחות',
      selectSpecialization: 'בחירת התמחות',
      therapistsName: 'לחפש מטפל או מכון מסוימים?',
      languages: 'שפות נוספות',
      otherLanguages: 'שפות אחרות',
      back: 'חזרה',
      location: 'איפה מתאים לך?',
      area: 'אזור בארץ',
      settlement: 'יישוב',
      county: 'מחוז',
      isAccessible: 'העדפות',
      yes: 'כן',
      no: 'לא משנה',
      male: 'מטפל',
      female: 'מטפלת',
      treatmentMethods: 'שיטת טיפול',
      treatmentFramework: 'מסגרת טיפול',
      privateTherapists: 'מטפלים פרטיים',
      viaInstituteTherapists: 'מטפלים דרך מכון',
      caregiverGender: 'מגדר',
      degree: 'הכשרה',
      extraDetails: 'פרטים נוספים',
      homeTreatment: 'מתן טיפול בביתך',
      accessibleClinic: 'קליניקה נגישה',
      noPreferences: 'אין לי העדפות',
      caregiverViaInstitute: 'מטפלים דרך מכון',
      all: 'כולם',
      viaInstitute: 'דרך המכון',
      notViaInstitute: 'לא דרך המכון',
      moreSearchOptions: 'אפשרויות חיפוש נוספות',
      lessSearchOptions: 'לראות פחות',
      search: 'חיפוש',
      showResults: 'הצגת תוצאות',
      specializationPlaceholder: 'בחירת תחום',
      subSpecializationPlaceholder: 'בחירת תחום טיפול',
      specialtiesPlaceholder: 'בחירת התמחות',
      areaPlaceholder: 'בחירת מחוז',
      cityPlaceholder: 'בחירת יישוב אחד או יותר',
      regionPlaceholder: 'בכל הארץ',
      namePlaceholder: 'שם מטפל, מטפלת או מכון',
      languagesPlaceholder: 'בחירת שפה',
      degreePlaceholder: 'בחירת הכשרה',
      professionDescription:
        'לבחירת ערך, התחל לכתוב את היישוב והשתמש בחיצי המקלדת - למעלה או למטה. לאחר בחירת הערך, אשר את בחירתך באמצעות מקש Enter',
      subSpecializationDescription:
        'לבחירת ערך, השתמש בחיצי המקלדת - למעלה או למטה. לאחר בחירת הערך, אשר את בחירתך באמצעות מקש Enter. ניתן לבחור כמה תחומי טיפול.',
    },
    therapyNote: {
      label: 'מצאת תקלה או מידע לא מדויק?',
      mailTo: 'נשמח לדעת',
    },
    reportErrorModal: {
      title: 'דיווח על תקלה',
      name: 'שם (חובה)',
      email: 'מייל (חובה)',
      phone: 'טלפון',
      messageLabel: 'על מה רצית לדווח? (חובה)',
      messagePlaceholder: 'זה המקום לפרט על התקלה',
      attachTitle: 'צירוף קבצים',
      attachSubtitle: 'נשמח לצילומי מסך או קבצים שיעזרו בהבנת התקלה',
      submit: 'שליחה',
      successTitle: 'דיווח התקבל בהצלחה',
      successDescription:
        'בקרוב נשלח לך דואר אלקטרוני עם הפרטים ניתן לצפות בפנייה באזור אישי בפניות לאגף',
      finish: 'סיום',
      errorTitle: 'יש בעיה עם שליחת הדיווח',
      errorDescription:
        'לא ניתן לצרף אותו. כנראה שהוא גדול מדי או שהסיומת שלו לא מתאימה למערכת',
      close: 'סגירה',
    },
    ParamedicalSearchForm: {
      requiredError: 'יש למלא תחום (שדה חובה)',
      caregiverGender: 'העדפה למטפל או מטפלת',
      no: 'לא משנה',
      male: 'מטפל',
      female: 'מטפלת',
      title: 'חיפוש טיפול משלים',
      isHomeTreatment: 'טיפול במכון או בבית',
      atInstitute: 'במכון',
      atHome: 'בבית',
      showBoth: 'תראו לי גם וגם',
      accessibility: 'נגישות',
      noPreferences: 'לא משנה',
      nameSearch: 'יש לך מטפל או מכון מועדף?',
      namePlaceholder: 'שם מטפל או מטפלת, או שם מכון',
      resetNameSearch: 'איפוס שם',
      isAccessible: 'העדפות',
      homeTreatment: 'טיפול בבית שלי',
      accessibleClinic: 'מרפאה נגישה',
      specialization: 'באיזה תחום מדובר? (חובה)',
      specializationPlaceholder: 'בחירת תחום',
      professionDescription:
        'לבחירת ערך, התחל לכתוב את התחום והשתמש בחיצי המקלדת - למעלה או למטה. לאחר בחירת הערך, אשר את בחירתך באמצעות מקש Enter',
      resetProfession: 'איפוס מקצוע',
      location: 'איפה נח לך?',
      reset: 'איפוס בחירה',
      cityPlaceholder: 'עיר או כתובת',
      moreSearchOptions: 'אפשרויות חיפוש נוספות',
      lessSearchOptions: 'פחות אפשרויות חיפוש',
      search: 'חיפוש',
    },
    MedicalEquipmentSearchForm: {
      title: 'חיפוש ציוד רפואי',
      nameSearch: 'יש לך חנות או ספק מועדפים?',
      namePlaceholder: 'חנות או ספק',
      resetNameSearch: 'איפוס שם',
      specialization: 'איזה ציוד נחוץ לך? (חובה)',
      specializationPlaceholder: 'בחירת סוג ציוד',
      professionDescription:
        'לבחירת ערך, התחל לכתוב את סוג הציוד והשתמש בחיצי המקלדת - למעלה או למטה. לאחר בחירת הערך, אשר את בחירתך באמצעות מקש Enter',
      resetProfession: 'איפוס סוג הציוד',
      location: 'איפה מתאים לך?',
      reset: 'איפוס בחירה',
      cityPlaceholder: 'עיר או כתובת',
      search: 'חיפוש',
    },
    MedicalServiceSearchForm: {
      title: 'חיפוש שירות רפואי/טיפולי',
      reset: 'איפוס בחירה',
      cityPlaceholder: 'עיר או כתובת',
      search: 'חיפוש',
      nameSearch: 'חיפוש לפי שם',
      namePlaceholder: 'שם הספק',
      resetNameSearch: 'איפוס שם',
      specialization: 'סוג השירות (שדה חובה)',
      specializationPlaceholder: 'בחירת סוג השירות',
      professionDescription:
        'לבחירת ערך, התחל לכתוב את סוג השירות והשתמש בחיצי המקלדת - למעלה או למטה. לאחר בחירת הערך, אשר את בחירתך באמצעות מקש Enter',
      resetProfession: 'איפוס סוג השירות',
      location: 'מיקום הספק',
    },
    imagingInstituteSearchForm: {
      requiredError: 'יש למלא סוג בדיקה (שדה חובה)',
      title: 'חיפוש מכוני דימות',
      reset: 'איפוס בחירה',
      cityPlaceholder: 'עיר או כתובת',
      search: 'חיפוש',
      nameSearch: 'לחפש מכון ספציפי?',
      namePlaceholder: 'שם מכון',
      resetNameSearch: 'איפוס שם',
      specialization: 'מה סוג הבדיקה? (חובה)',
      specializationPlaceholder: 'בחירת בדיקה',
      professionDescription:
        'לבחירת ערך, התחל לכתוב את סוג הבדיקה והשתמש בחיצי המקלדת - למעלה או למטה. לאחר בחירת הערך, אשר את בחירתך באמצעות מקש Enter',
      resetProfession: 'איפוס סוג בדיקה',
      location: 'איפה לחפש?',
      infoLabel: 'אפשר לקבל התחייבות לבדיקת הדמיה גם בבית חולים, בהתאם לזכאות.',
      infoLinkLabel: 'הפקת התחייבות באיזור האישי',
    },
    labTestsSearchForm: {
      requiredError: 'יש למלא סוג בדיקה (שדה חובה)',
      title: 'חיפוש בדיקה',
      reset: 'איפוס בחירה',
      cityPlaceholder: 'עיר או כתובת',
      search: 'חיפוש',
      nameSearch: 'חיפוש לפי שם',
      namePlaceholder: 'שם הבדיקה',
      resetNameSearch: 'איפוס שם',
      specialization: 'מה סוג הבדיקה? (חובה)',
      specializationPlaceholder: 'סוג בדיקה',
      professionDescription:
        'לבחירת ערך, התחל לכתוב את סוג הבדיקה והשתמש בחיצי המקלדת - למעלה או למטה. לאחר בחירת הערך, אשר את בחירתך באמצעות מקש Enter',
      resetProfession: 'איפוס סוג בדיקה',
      location: 'איפה נח לך?',
      treatmentFramework: 'מסגרת הטיפול',
      atInstitute: 'במכון',
      atHome: 'בבית',
      all: 'הכל',
      accessibility: 'נגישות',
      accessibleClinic: 'מכון נגיש',
      noPreferences: 'לא משנה',
      infoLabel: 'אפשר לקבל התחייבות לבדיקות גם בבית חולים, בהתאם לזכאות.',
      infoLinkLabel: 'להפקת התחייבות באיזור האישי',
    },
    doctorsSearchForm: {
      requiredError: 'יש למלא תחום מומחיות (שדה חובה)',
      title: 'חיפוש רופאים ורופאות',
      infoLabel: 'אפשר לקבל התחייבות לטיפול רפואי גם בבית חולים, בהתאם לזכאות.',
      infoLinkLabel: 'הפקת התחייבות באזור האישי',
      reset: 'איפוס בחירה',
      cityPlaceholder: 'עיר או כתובת',
      moreSearchOptions: 'אפשרויות חיפוש נוספות',
      lessSearchOptions: 'פחות אפשרויות חיפוש',
      search: 'חיפוש',
      therapistsName: 'מה שם הרופא או הרופאה?',
      namePlaceholder: 'שם רופא מועדף',
      resetTherapistsName: 'איפוס שם',
      specialization: 'מה תחום הטיפול? (חובה)',
      specializationPlaceholder: 'תחום',
      professionDescription:
        'לבחירת ערך, התחל לכתוב את היישוב והשתמש בחיצי המקלדת - למעלה או למטה. לאחר בחירת הערך, אשר את בחירתך באמצעות מקש Enter',
      resetProfession: 'איפוס מקצוע',
      location: 'איפה נח לך?',
      languages: 'שפות נוספות',
      languagesPlaceholder: 'בחירת שפה',
      chosen: 'נבחרו',
      otherLanguages: 'שפות אחרות',
      back: 'חזרה',
      resetLanguages: 'איפוס שפות',
      isAccessible: 'העדפות',
      homeTreatment: 'טיפול בבית שלי',
      accessibleClinic: 'מרפאה נגישה',
      noPreferences: 'אין לי העדפות',
      caregiverGender: 'העדפה לרופא או רופאה',
      yes: 'כן',
      no: 'לא משנה',
      male: 'רופא',
      female: 'רופאה',
    },
    resultPage: {
      loading: {
        fewMoments: 'כמה רגעים בבקשה...',
        pageLoading: 'העמוד בטעינה',
      },
      title: 'תוצאות חיפוש',
      profession: 'מקצוע',
      edit: 'עריכה',
      next: 'הבא',
      prev: 'הקודם',
      downloadAsFile: 'הורדה כקובץ',
      resetFilterChoice: 'איפוס בחירה',
      filterResults: 'להצגת תוצאות',
      allFilters: 'כל המסננים',
      allFiltersMobile: 'סינון',
      ariaDescribeAllFilters: 'טופס מתקדם מלא כלל המסננים',
      closeFilters: 'סגור כל המסננים',
      sortAndFilter: 'מיון וסינון',
      closestLocation: 'מיקום - הכי קרוב אליי',
      notActive: '( לא פעיל )',
      orderByAscendingAlphabet: 'סדר אלפבתי - א- ת',
      orderByDescendingAlphabet: 'סדר אלפבתי - ת- א',
      close: 'סגירה',
      sortBy: 'מיון תוצאות לפי',
      moreInfo: 'פרטים נוספים',
      noResults: 'אין תוצאות',
      preferences: 'העדפות',
      noPreferences: 'אין לי העדפות',
      gender: 'מגדר',
      chosenFilter: 'סננים נבחרו',
      textResult: {
        found: 'נמצאו',
        results: 'תוצאות',
        noResult: 'אפשר לנסות חיפוש אחר או לשנות את הסינון',
      },
      therapy: {
        banner: {
          title: 'רוצה עזרה בבחירת טיפול נפשי?',
          subtitle: 'אפשר לפנות למחלקת השיקום במחוז שלך',
        },
        expertise: 'תחומי טיפול',
        speciality: 'מתמחה ב:',
        chosen: 'נבחרו',
        subSpecialty: 'תחום טיפול',
        subSpecialties: 'תחומי טיפול',
        mastery: 'התמחות',
        masteries: 'התמחויות',
        location: 'יישובים',
        allCities: 'כל היישובים',
        title: 'טיפול נפשי',
        request: 'הפקת התחייבות',
        ariaShareButton: 'שיתוף ספק',
        copy: 'העתקה',
        mailShare: 'שיתוף למייל',
        whatsAppShare: 'שיתוף בWhatsApp',
        MsnAppShare: 'שיתוף בMassenger',
        sort: 'מיון',
        therapyMethods: 'שיטות טיפול',
        training: 'הכשרה',
        address: 'כתובת',
        extraAddress: 'כתובת נוספת',
        map: 'מפה',
        contactDetails: 'פרטי התקשרות',
        treatmentMethods: 'שיטות טיפול',
        languages: 'שפות',
        specialties: 'התמחויות',
        specialService: 'העדפות',
        moreLocations: 'מיקומים נוספים',
        moreInfo: 'פרטים נוספים',
        accessible: 'מרפאה נגישה',
        moreContactDetails: 'לדרכי התקשרות נוספות',
        homeTherapy: 'מתן טיפול בביתך',
        therapyFrame: 'מטפל במסגרת',
        noData: 'נתון חסר במערכת',
        noAddress: 'כתובת חסרה במערכת',
        foundSupplier: 'מצאתי ספק שירות שנמצא בהסדר עם משרד הביטחון:',
        telephone: 'טלפון',
        cellphone: 'נייד',
        email: 'אימייל',
        fullSupplierInfo: 'לפרטי הספק המלאים:',
        urlCopied: 'כתובת הועתקה',
        mentalSuppliersCsvFileName: 'ספקים טיפול נפשי',
        csv: [
          'שם',
          'התמחות',
          'תת התמחות',
          'כתובת 1',
          'טלפון 1',
          'טלפון 2',
          'אימייל',
          'מרפאה נגישה',
          'שיטות טיפול',
          'שפות',
          'הכשרה',
          'מטפל תחת מסגרת',
        ],
      },
      doctors: {
        title: 'רופאים רופאות',
        maleDoctor: 'רופא',
        femaleDoctor: 'רופאה',
        doctorSupplierCsvFileName: 'ספקים רופאים',
        csv: [
          'שם',
          'מומחיות',
          'כתובת 1',
          'טלפון 1',
          'טלפון 2',
          'אימייל',
          'מרפאה נגישה',
          'שפות',
        ],
      },
      paramedical: {
        title: 'ספקים פרא-רפואיים',
        paramedicalSupplierCsvFileName: 'ספקים פרא-רפואיים',
        specialty: 'תחום',
        homeVisit: 'טיפול בבית',
        clinicVisit: 'טיפול במכון',
        csv: [
          'שם',
          'תחומים',
          'כתובת 1',
          'טלפון 1',
          'טלפון 2',
          'אימייל',
          'מרפאה נגישה',
        ],
      },
      medicalService: {
        medicalServiceSupplierCsvFileName: 'ספקי שירותים רפואיים',
        csv: ['שם', 'סוגים', 'כתובת 1', 'טלפון 1', 'טלפון 2', 'אימייל'],
        title: 'ספקי שירותים רפואיים',
      },
      medicalEquipment: {
        medicalServiceSupplierCsvFileName: 'ספקי ציוד רפואי',
        csv: ['שם', 'סוגים', 'כתובת 1', 'טלפון 1', 'טלפון 2', 'אימייל'],
        title: 'ספקי ציוד רפואי',
      },
      imagingInstitute: {
        title: 'מכוני דימות',
        instituteServices: 'שירותי המכון',
        moreContactDetails: 'פרטי קשר נוספים',
        address: 'כתובת',
        extraAddress: 'כתובת נוספת',
        noAddress: 'כתובת חסרה במערכת',
        imagingInstituteSupplierCsvFileName: 'מכוני דימות',
        csv: ['שם', 'סוגי בדיקה', 'כתובת 1', 'טלפון 1', 'טלפון 2', 'אימייל'],
      },
      labTests: {
        title: 'בדיקות',
        instituteServices: 'שירותי המכון',
        moreContactDetails: 'פרטי קשר נוספים',
        address: 'כתובת',
        extraAddress: 'כתובת נוספת',
        noAddress: 'כתובת חסרה במערכת',
        labTestsSupplierCsvFileName: 'בדיקות',
        csv: ['שם', 'סוגי בדיקה', 'כתובת 1', 'טלפון 1', 'טלפון 2', 'אימייל'],
      },
      lawyers: {
        title: 'חיפוש ייצוג משפטי לוועדה הרפואית',
        searchPlaceholder: 'חיפוש לפי שם משרד',
        namePlaceholder: 'חיפוש שם משרד',
        nameReset: 'איפוס שם משרד',
        locationLabel: 'מיקום',
        cityPlaceholder: 'כל הארץ',
        allCountry: 'כל הארץ',
        showResults: 'הצגת תוצאות',
        banner: {
          title: 'ייצוג משפטי במחיר מסובסד',
          content:
            'אפשר לבחור משרד עורכי דין מתוך רשימת המייצגים, ולשלם השתתפות עצמית של 500 ש"ח בלבד.',
          moreInfo: 'מידע נוסף',
        },
        lawOffice: 'משרד עו"ד',
        contactDetails: 'פרטי קשר',
        additionalContactDetails: 'פרטי קשר נוספים',
        fax: 'פקס',
      },
      specialtyLabels: {
        psychiatry: 'פסיכיאטריה',
        orthopedics: 'אורטופדיה',
        ent: 'אף אוזן גרון',
        cardiology: 'קרדיולוגיה',
        pulmonology: 'רפואת ריאות',
        internal: 'רפואה פנימית',
        ophthalmology: 'עיניים',
        dermatology: 'עור',
        neurosurgery: 'נוירוכירורגיה',
        rheumatology: 'ראומטולוגיה',
      },
    },
  },
  [DICTIONARY.B2C]: {
    next: 'המשך',
    Landing: {
      logoTitle: 'אגף השיקום',
      title: `הגעת לאזור האישי של
      אגף שיקום נכים`,
      subTitle: `אזור זה מיועד לך אם הוכרת באגף השיקום
      או הגשת בקשה להכרה בנכות`,
      outro: 'לעזרה התקשרו למוקד 8150*',
    },
    UserContacts: {
      title: 'פרטי ההתקשרות שלך',
      subTitle: 'כפי שנרשמו באגף',
      email: 'דואר אלקטרוני',
      phone: 'טלפון',
      wrongInfo: 'הפרטים לא נכונים או מלאים?',
      updateHere: 'אפשר לעדכן אותם פה',
      noData: 'נתון חסר במערכת',
    },
    logo: 'אגף השיקום',
    title: 'הגעת לאזור האישי של אגף שיקום נכים',
    explanation:
      'אזור זה מיועד לך אם הוכרת באגף השיקום או הגשת בקשה להכרה בנכות',
    helpTextRight: 'לעזרה התקשרו למוקד 8150*',
    errorTitle: 'אחד מפרטי ההזדהות לא נכונים',
    errorTitleMobile: 'אחד מהפרטים שגוי',
    errorExplanation: {
      line1: 'לא ניתן להתחבר לאזור האישי.',
      line2: 'לצורך שמירה על פרטיות המידע שלך,',
      line3: 'כדאי לפנות למוקד בטלפון',
      phoneNumber: '8150*',
    },
    buttonLabel: 'חזרה',
    helpTextLeft: {
      line1: 'עדיין לא הגשת בקשה להכרה בנכות?',
      line2: 'כל המידע',
      link: 'נמצא כאן',
      line1Mobile:
        'אזור זה מיועד לך אם הוכרת באגף השיקום או הגשת בקשה להכרה בנכות',
    },
  },
  [DICTIONARY.Maintenance]: {
    title: 'אנחנו משפרים את האתר',
    subtitle: 'מתנצלים על אי הנוחות - דף זה יחזור לפעול בימים הקרובים',
    info: 'טוב לדעת: אתר המידע פועל כרגיל, עם מידע שימושי על זכויות והטבות',
    ctaLabel: 'לאתר המידע',
  },
  [DICTIONARY.Messages]: {
    linkLabel: 'למידע נוסף לחצו כאן',
  },
  [DICTIONARY.LongtermEquipment]: {
    title: 'ציוד ארוך טווח',
    subtitle: 'כאן נמצאת רשימת הציוד שמגיעה לך, כולל מידע על תקופת המימוש.',
    equipmentLinkLabel: 'חיפשת ציוד מתכלה? כדאי לבדוק פה',
    equipmentLinkUrl: '/equipment',
    exercisedFrom: 'ניתן לממש מתאריך',
    previousExercised: 'תאריך מימוש קודם',
    downloadPreviousReference: 'הורדת התחייבות (הפניה) קודמת',
    moreInfo: 'מידע נוסף',
    moreInfoAbout: 'מידע נוסף על',
    requestReference: 'בקשת הפניה',
    endOfExercisedPeriod: 'סוף תקופת המימוש',
    noUpdatesSubtitle:
      'אין לך כרגע זכאות לציוד ארוך טווח אם תהיה לך, היא תופיע פה',
    filterLabelTitle: 'סינון סוגי הציוד שלך',
    filterLabels: {
      available: 'זמין למימוש',
      availableSoon: 'מימוש בקרוב',
    },
    showMore: 'הצג עוד',
    showLess: 'הצג פחות',
  },
  [DICTIONARY.Reimbursements]: {
    title: 'בקשת החזר הוצאות',
    subtitle: 'על מה היית רוצה לבקש החזר?',
    titleCannabis: 'החזר הוצאות קנאביס רפואי',
    titleAlternativeMedicine: 'החזר הוצאות רפואה משלימה',
    titleFamilyMembers: 'החזר הוצאות טיפול נפשי לבני משפחה',
    addInvoice: 'צירוף חשבונית',
    addFiles: 'צירוף קבצים',
    gettingStarted1: 'על איזו חשבונית/קבלה רצית החזר?',
    gettingStarted2: 'אם יש לך כמה חשבוניות, נא לפצל אותן ולהעלות כל אחת בנפרד',
    dragFileHere: 'ניתן לגרור לכאן קובץ',
    familyMembersDragUpload: 'אפשר לגרור לכאן קובץ',
    or: 'או',
    familyMembersLabelBtn: 'להעלות קובץ',
    uploadInvoice: 'העלאת חשבונית/קבלה',
    uploadFile: 'העלאת קובץ',
    back: 'חזרה',
    invoice: 'חשבונית',
    uploadNoteLabel: 'עוד בנושא זה',
    uploadNote1: 'מה סוג הקבצים שאפשר לצרף?',
    privateTreatmentNote:
      'יש להעלות כל חשבונית/קבלה בקבצים נפרדים, ולוודא ששם המטופל/מטופלת מופיע',
    uploadNoteContent1:
      'ניתן לצרף קבצים בגודל של עד 20MB עם הסיומות הבאות: png, jpg, doc, docx pdf, tif.',
    uploadNote2: 'מה סכום ההחזרים?',
    uploadNoteContent2(totalPrice: number, price: number): string {
      return `סכום החזר מקסימלי לטיפול: ${price} ₪ כולל מע"מ, או ${totalPrice} ₪ למטפלים פטורים ממע"מ`;
    },
    caregiverCertificate: 'אישור מטפל/מטפלת',
    uploadCaregiverCertificate: 'העלאת אישור מטפל/מטפלת',
    uploadNoteCaregiverCertificate: 'מה זה אישור מטפל/מטפלת?',
    uploadNoteCaregiverCertificateContent:
      'כדי לקבל החזר על טיפול רפואה משלימה אצל מטפלים או מכונים פרטיים מורשים, יש לצרף אישור מקופת החולים.',
    uploadNoteCaregiverCertificateLink: 'דוגמה לאישור כזה, ניתן לראות פה ',
    fileErrorTitle: 'יש בעיה עם הקובץ הזה',
    fileErrorSubTitle:
      'לא ניתן לצרף אותו. כנראה שהוא גדול מדי או שהסיומת שלו לא מתאימה למערכת',
    number: 'מספר',
    supplierName: 'שם מלא של המטפל',
    licenseNumber: 'מספר רישיון של המטפל',
    date: 'תאריך',
    amount: 'סכום',
    edit: 'עריכה',
    delete: 'מחיקה',
    save: 'המשך',
    submit: 'המשך ושליחה',
    exit: 'יציאה',
    userId: 'ת.ז',
    allInvoicesByType: 'כאן מופיעים הקבצים שצורפו לבקשה לפי סוג טיפול',
    allInvoicesTitle: 'כאן מופיעים הקבצים שצורפו לבקשה',
    uploadAnotherInvoice: 'צירוף חשבונית',
    more: 'נוספת',
    totalAmount: 'סכום החשבוניות שהוגשו: ',
    nis: 'ש"ח',
    typeCannabis: 'קנאביס',
    cannabisLabel: 'קנאביס רפואי',
    typeAlternativeMedicine: 'רפואה משלימה',
    familyMembersTreatment: 'טיפולים למשפחה',
    notePlaceholder: 'זה המקום להוסיף עוד מידע במילים שלך (לא חובה)',
    yourPhone: 'במידה ויידרשו בירורים לאיזה מספר ברצונך שנחזור? ',
    phone: 'טלפון',
    prefix: 'קידומת',
    phoneNumber: 'מספר טלפון',
    errorPhone: 'יש למלא טלפון עם 7 ספרות ולבחור קידומת',
    phonePrefixError: 'יש לבחור קידומת',
    no: 'לא',
    yesDelete: 'כן, למחוק',
    deleteInvoice: 'התכוונת למחוק את החשבונית הזו?',
    didYou: 'התכוונת',
    toDelete: 'למחוק',
    thisInvoice: 'את החשבונית הזו?',
    selectedInvoice: 'החשבונית שהעלית',
    additionalDetailsTitle: 'הערות נוספות, במידת הצורך',
    treatmentType: 'סוג טיפול',
    treatmentFor: 'עבור מי הטיפול?',
    reimbursementsForKids: 'החזר טיפול לילדים',
    enterTreatmentTypeHere: 'פה אפשר להקליד את סוג הטיפול',
    treatmentTypeSubtitle:
      'ניתן לקבל החזר על טיפולים שעברת בעצמך עד 6,000 ש"ח בשנה, ',
    moreInfoHere: 'למידע נוסף בנושא',
    moreInfoHereLink: 'https://shikum.mod.gov.il/medical/treatment/alternative',
    receivedTreatmentYourself: ' קיבלת את הטיפול בעצמך?',
    errorMsgOtherCaregiver: 'יש למלא את התחום או המקצוע כדי להמשיך',
    yes: 'כן, הטיפול עבורי',
    continue: 'המשך',
    noAndMoreOptions: 'לא, עבור בני משפחתי',
    familyTreatmentSubtitle:
      'בנוסף לטיפול שמגיע לך, גם לילדים שלך מגיע לקבל החזר על טיפול נפשי ורפואה משלימה',
    familyTreatmentsLabel: 'טיפול נפשי לבני משפחה',
    familyTreatmentsMoreInfo: 'למידע נוסף על טיפול נפשי לבני משפחה',
    treatmentTypeDoYouReceive: 'בחירת סוג הטיפול',
    whatIsTheTreatmentType: 'מה שם הטיפול שעברת?',
    enterOtherTreatmentTypeHere: 'פה אפשר להקליד את התחום או המקצוע',
    caregiverProfession: 'מה התחום המקצועי של הגורם המטפל?',
    chooseFromTheOptionsOrType: 'אפשר להקליד או לבחור מרשימה',
    theTreatmentType: 'סוג הטיפול:',
    theOtherCaregiver: 'גורם מטפל: אחר',
    noOptions: 'אין אפשרויות',
    treatmentsDatesTitle: 'מהם תאריכי הטיפולים, הקשורים לחשבונית הזו?',
    treatmentsDatesNote: 'חשוב: לא ניתן להגיש החזר על טיפול עתידי',
    treatmentsDatesLabel: 'תאריך טיפול',
    treatmentsDatesAddBtn: 'תאריך טיפול נוסף',
    invoiceNumber: 'מספר חשבונית/קבלה',
    invoiceDate: 'תאריך החשבונית',
    treatmentsDates: 'תאריכי הטיפולים',
    addAnotherInvoice: 'עוד חשבונית כזו',
    caregiverName: 'שם הגורם המטפל',
    treatmentTypeLabel: 'גורם מטפל',
    treatmentOf: 'טיפולים של ',
    addOtherInvoiceOf: 'צירוף חשבונית אחרת של ',
    ocrLading: {
      title: 'צירוף חשבוניות',
      subtitle: 'ניקח כמה רגעים לסריקת החשבונית ונאשר מולך את הפרטים',
      scanningInvoice: 'אנחנו סורקים את החשבונית. מיד נאשר מולך את הפרטים',
      inputLabel: 'החשבונית שהעלית',
      titleFamilyMembers: 'צירוף חשבונית - טיפול נפשי לבני משפחה',
      subtitleFamilyMembers:
        'אנחנו סורקים את החשבונית. מיד נאשר מולך את הפרטים',
    },
    form: {
      title: 'צירוף חשבוניות',
      editTitle: 'עריכת חשבונית',
      alternativeMedicineFormTitle: 'רפואה משלימה',
      subtitle: 'אלו פרטי החשבונית שזיהינו, חשוב לוודא שאין טעויות:',
      editSubtitle: 'ניתן לערוך את פרטי החשבונית',
      invoiceNumber: 'מספר חשבונית/קבלה',
      supplierName: 'שם מלא של המטפל',
      fromDate: 'מתאריך',
      amountPaid: 'הסכום ששולם',
      selectedInvoice: 'החשבונית שהעלית',
      yourFiles: 'הקבצים שהעלית',
      view: 'צפייה',
      exit: 'יציאה',
      save: 'שמירה והמשך',
      editSave: 'שמירת שינויים',
      noDataError:
        'לא הצלחנו לסרוק את פרטי החשבונית. נבקש ממך למלא את הפרטים באופן ידני',
      missingDataError: 'לא הצלחנו לזהות את הנתונים, נא למלא ידנית',
      number: 'מספר',
      date: 'תאריך',
      amount: 'סכום',
      futureDateError: 'לא ניתן להגיש החזר על טיפול עתידי',
      pastDateError: 'תאריך לא חוקי',
      alternativeMedicineMaxDateError: 'אפשר לצרף חשבוניות עד 31.12.26 בלבד',
    },
    statement: {
      title: 'הצהרה',
      subtitleMobile: ' על אי קבלת תשלום מגורם אחר',
      subtitle: 'הצהרה על אי קבלת תשלום מגורם אחר',
      iStatement: 'ברצוני להצהיר כי:',
      i1: 'לא קיבלתי עבור ההוצאה שמוגשת בטופס הזה כל תשלום או החזר כספי מכל גורם אחר, ואין בכוונתי לפנות לגורם אחר לשם כך.',
      i2: 'בכוונתי לשמור את הקבלות המקוריות לתקופה של 90 יום ממועד שליחת הטופס הדיגיטלי לאגף השיקום. ידוע לי כי בתקופה זו יהיה רשאי משרד הביטחון לדרוש אותן לצורך בקרה.',
      i3: 'ידוע לי ומוסכם עלי כי במקרה ולא אציג את הקבלות המקוריות תוך 30 יום מבקשת המשרד – סכום ההחזר יראה כתשלום יתר ויקוזז מהתגמולים הקרובים.',
      i4: 'ידוע לי ומוסכם עלי כי במידה ואקבל תשלום או החזר כספי מגורם אחר עבור אותה מטרה, יהיה עלי להחזיר את הסיוע במלואו או בחלקו לאגף השיקום (כולל בדרך של קיזוז מהתגמול החודשי) בהתאם לתחשיב שיבוצע עבורי.',
      checkboxLabel: (firstName: string, lastName: string, id: string) =>
        `אני ${firstName} ${lastName}, ת.ז ${id} קראתי את ההצהרה וברצוני לאשר אותה`,
      checkboxError: 'יש לאשר את ההצהרה כדי להתקדם',
    },
    noEntitle: {
      cannabis: {
        title: 'אין לך זכאות להחזר קנאביס כרגע',
        subtitle: 'כשתהיה לך זכאות, יופיע פה תהליך החזר הוצאות לשימושך.',
        moreInfo: 'מידע על הנפקת רישיון אפשר למצוא פה',
        redirect1: 'פנייה למרפאה במחוז',
        redirect2: 'החזר הוצאות אחר',
      },
      alternativeMedicine: {
        title: 'אין לך אפשרות להגיש החזר לרפואה משלימה עבורך',
        subtitle:
          'תהליך זה מיועד להחזר עבור סל טיפולים למתמודדים עם פוסט טראומה, פגיעה נפשית או פגיעת ראש. ',
        moreInfo: 'מידע על הנפקת רישיון אפשר',
        moreInfoLabel: 'למידע נוסף על טיפולי רפואה משלימה',
        redirect1: 'פנייה ליחידת השיקום במחוז',
        redirect2: 'החזר הוצאות אחר',
      },
      familyMembers: {
        title: 'אין לך אפשרות להגיש החזר לטיפול נפשי לבני משפחה כרגע',
        subtitle: 'כשתהיה לך זכאות, יופיע פה תהליך החזר הוצאות לשימושך.',
        moreInfo: 'מידע על הנפקת רישיון אפשר',
        moreInfoLabel: 'למידע נוסף על טיפולים למשפחה',
        redirect1: 'פנייה ליחידת השיקום במחוז',
        redirect2: 'החזר הוצאות אחר',
      },
    },
    returnToMainDialog: {
      title: [
        'חזרה למסך הראשי בשלב הזה,',
        'תמחק את החשבוניות שצירפת ותבטל את התהליך',
      ],
      delete: 'מחיקה ויציאה',
      continue: 'המשך בתהליך',
    },
    cancelEditDialog: {
      title: 'לשמור את השינויים שעשית?',
      save: 'כן לשמור',
      goBack: 'לא לשמור',
    },
    SuccessDialog: {
      title: 'הבקשה שלך להחזר הוצאות קנביס הוגשה',
      titleAlternativeMedicine: 'הבקשה שלך להחזר הוצאות רפואה משלימה הוגשה',
      titleFamilyMembers: 'הבקשה שלך להחזר הוצאות טיפול נפשי לבני משפחה הוגשה',
      subtitle:
        'במידת הצורך, ניצור איתך קשר להשלמת פרטים,  ונעדכן אותך בסיום הטיפול',
      requestNumber: 'מספר בקשה:',
      requestDate: 'תאריך הגשת הבקשה:',
      numberOfInvoices: 'מספר חשבוניות/קבלות שהוגשו:',
      totalReimbursementSum: 'סך ההחזר המבוקש:',
      linkPreText: 'אם הבקשה תאושר, העדכון יופיע באזור',
      linkText: ' ריכוז פניות לאגף',
      linkUrl: '/applies',
      finish: 'סיום',
      anotherRequest: 'בקשה נוספת להחזר הוצאות',
      alternativeMedicineForm: {
        linkText: 'פירוט תשלומים וניכויים',
        linkUrl: '/payments&deductions',
      },
    },
    DuplicateFileDialog: {
      title: 'צירוף חשבונית',
      subtitle: 'נראה שהחשבונית הזו צורפה פעמיים, ניתן לבטל או להעלות קובץ חדש',
      number: 'מספר',
      date: 'תאריך',
      amount: 'סכום',
      delete: 'ביטול',
      newInvoice: 'העלאה מחדש',
    },
    MissingFileDialog: {
      title: 'לא ניתן לשלוח את הבקשה',
      subtitle: (count: number) =>
        count === 1
          ? 'יש חשבונית אחת עם קובץ פגום או חסר. יש להעלות מחדש את הקובץ לפני השליחה.'
          : `יש ${count} חשבוניות עם קבצים פגומים או חסרים. יש להעלות מחדש את הקבצים לפני השליחה.`,
      close: 'הבנתי',
      reuploadFile: 'העלה מחדש',
    },
    AlternativeMedicine: {
      allTreatments: 'כל הטיפולים',
      noTreatmentType: 'כדי להמשיך יש לבחור סוג טיפול',
      yourTreatments: 'הטיפולים הנפוצים שלך',
      chooseYourTreatment: 'אפשר להקליד או לבחור בטיפול מסוים או "אחר"',
      otherTreatment: 'טיפול אחר',
      other: 'אחר',
      oneMoment: 'רק רגע...',
      otherTreatment1: 'בחרת "טיפול אחר". ',
      otherTreatment2:
        'במקרה זה יאושרו רק טיפולים שקופות החולים בארץ מכירות בהם כטיפולי רפואה משלימה.',
      otherTreatment3:
        'חשוב לקחת בחשבון שמדובר בתהליך ארוך יותר, הכולל בדיקה שהטיפול מוכר בקופות החולים.',
      otherTreatmentNote:
        'כדאי לחזור לרשימת הטיפולים, ולבדוק אם הטיפול שעברת מופיע בה',
      goOn: 'הבנתי, אפשר להמשיך',
      backTreatmentList: 'חזרה לרשימת הטיפולים',
      introTitle: 'החזר על טיפולי רפואה משלימה',
      introText1Bold: 'מעכשיו ',
      introText1: 'קובעים טיפולי רפואה משלימה ומשלמים באפליקציית Shikum.Me.',
      introText2Bold: 'איך זה עובד? ',
      introText2:
        'בוחרים טיפול, קובעים תור ומשלמים במטבעות באפליקציה. בלי לשמור קבלות.',
      introText3Bold: 'יש גם תקופת הסתגלות',
      introText3:
        'אפשר להגיש החזרי הוצאות עד סוף שנת 2026, במסגרת תקופת הסתגלות, בתמורה להפחתת הסכום שנטען באפליקציה.',
      introText3Link: 'מידע נוסף',
      introDownloadBtn: 'הורדת אפליקציית Shikum.Me',
      introContinueBtn: 'המשך לבקשת החזר',
    },
    FamilyMembers: {
      allTreatments: 'כל הטיפולים',
      noTreatmentType: 'כדי להמשיך יש לבחור סוג טיפול',
      yourTreatments: 'הטיפולים הנפוצים שלך',
      introTitle: 'טיפול נפשי לבני משפחה',
      forYourAttention: 'לתשומת ליבך',
      introText1:
        'החזר משולם עבור טיפול נפשי שניתן על ידי מטפלים שהוסמכו באחד מהתחומים:',
      list1: 'פסיכיאטריה',
      list2: 'פסיכולוגיה',
      list3: 'עבודה סוציאלית',
      list4: 'תואר שני בטיפול באמנויות',
      introText2:
        'לילדים בגילאי 7 עד 18 ניתן להמיר את ההחזר על טיפול נפשי בהחזר על טיפול ברפואה משלימה (טיפול פעם בשבוע).',
      introText4:
        'נכי ונכות צה"ל בודדים או ללא עורף משפחתי, יכולים להגיש בקשה להחזר עבור אדם אחר שמסייע להם, אם הוא מוגדר "קרוב אחר" על ידי עובד או עובדת השיקום.',
      introContinueBtn: 'הבנתי, אפשר להמשיך',
      introBackBtn: 'חזרה',
      selectMember: 'עבור מי הטיפול?',
      whichTreatment: 'על איזה מהטיפולים רצית לבקש החזר?',
      mentalHealthCare: 'טיפול נפשי',
      physicalHealthCare: 'טיפול ברפואה משלימה',
      privateAlternativeTreatment: 'טיפול רפואה משלימה פרטי',
      spouse: 'בן או בת זוג',
      kids: 'ילדים',
      parents: 'הורים',
      kidsNote: 'החזר הוצאות לטיפול נפשי, אפשר להגיש עבור ילדים מגיל 7 עד 30',
      notFromList: 'בן משפחה שאינו ברשימה',
      otherMember: 'קרוב אחר',
      otherMemberNote: 'שאושר לך על ידי אגף השיקום ',
      caregiversTitle: 'גורם מטפל',
      caregiversLabel: 'מי הגורם שנתן את הטיפול?',
      otherCaregiver: 'גורם טיפולי אחר',
      otherCaregiverForChild: 'גורם טיפולי אחר (נפשי)',
      alternativeMedicineTreatment: 'טיפול ברפואה משלימה',
      alternativeMedicineTreatmentNote:
        'החזר הוצאות לטיפולי רפואה משלימה אפשר להגיש עבור ילדים מגיל 7 עד 18',
      specialTreatmentTitle: 'טיפול בעזרת בעלי חיים/רכיבה טיפולית',
      specialNote1:
        'החל מתאריך 01/01/2025 יינתן החזר רק עבור טיפול שהתקבל דרך חוות טיפוליות או מטפלים בעזרת בע"ח המוכרים בקופות החולים.',
      specialNote2:
        'אם החשבונית אינה מספק מוכר של קופת חולים, ייתכן שההחזר לא יאושר.',
      healthFunds: 'קופת חולים',
      otherFamilyMember: 'בן או בת משפחה שאינם ברשימה',
      otherFamilyMemberName: 'מה שם הקרוב?',
      otherFamilyMemberNamePlaceholder: 'הקלדת שם',
      otherFamilyMemberRelation: 'מה הקשר המשפחתי?',
      otherFamilyMemberRelationOption1: 'בן או בת זוג',
      otherFamilyMemberRelationOption2: 'ילד או ילדה',
      otherFamilyMemberNote: 'כדי להוסיף אדם זה באופן קבוע, יש לעדכן את ',
      otherFamilyMemberLabel: 'הפרטים האישיים באזור האישי',

      otherTreatment1: 'בחרת "טיפול אחר". ',
      otherTreatment2: `טיפול נפשי בהחזר כספי מאושר רק ע"י מטפל מוסמך לטיפול נפשי עם ההכשרות שצוינו, החל מתאריך 01/01/2026 לא יאושר החזר עבור מטפל 'אחר' שאינו עומד בקריטריונים, נא היערכותך.`,
      otherTreatment3:
        'לאיתור מטפל מוסמך המאושר להחזר ניתן לפנות למכונים לטיפול נפשי מתוך ',
      otherTreatmentTheList: 'הרשימה',
      otherTreatmentTheListUrl:
        'https://shikum.mod.gov.il/about/harvot-barzel/mental-treatment#12',
      otherTreatmentNote:
        'כדאי לחזור לרשימת הטיפולים, ולבדוק אם הטיפול שעברת מופיע בה',
      errorMsgNameField: 'חובה למלא את שם הקרוב',
      errorMsgRelationField: 'חובה לבחור את הקשר המשפחתי',
    },
  },
  [DICTIONARY.MedicalCommittees]: {
    title: 'ועדות רפואיות',
    subtitle:
      'כאן מופיע כל מה שחשוב לדעת על הוועדות הרפואיות שלך לקביעת אחוזי נכות',
    activeCommittees: 'ועדות פעילות',
    suggestionsForYou: 'הצעות עבורך',
    noData: {
      title: 'אין מידע שאפשר להציג כאן כרגע',
      subtitle:
        'אחרי קביעת אחוזי הנכות, יופיע כאן מידע על ועדות רפואיות שנקבעו לך.',
      subtitle2:
        'בשלב זה, המידע על תהליך ההכרה והוועדה הרפואית לקביעת אחוזי נכות, מופיע באזור',
      recognitionStatusLink: 'מצב הטיפול בבקשה להכרה',
      contactRecognitionUnit: 'פנייה ליחידת ההכרה',
      recognitionProcessInfo: 'מידע בנושא תהליך ההכרה',
    },
    protocolComingSoon: 'בקרוב: פרוטוקול הוועדה יעלה לכאן',
    currentStep: 'שלב נוכחי',
    youHave: 'יש לך',
    noDiscussionScheduled: 'טרם נקבע דיון לנושאים',
    unscheduledTopicsTitle: 'נושאים שטרם נקבעה להם ועדה',
    afterDateSet: 'לאחר שנקבע תאריך לדיון, נדאג לשלוח עדכון בנושא',
    yourClosedCommittees: 'הוועדות שלך שנסגרו',
    oldClosedCommittees: 'ועדות שנסגרו לפני 3 חודשים ומעלה',
    youHaveClosedCommittees: (count: number) => `יש לך ${count} ועדות שנסגרו`,
    lastCommitteeClosed: 'ועדה אחרונה נסגרה בתאריך:',
    recentlyClosedCommittee: 'ועדה שהסתיימה לאחרונה',
    awaitingBenefitsOfficerDecision: 'המתנה להחלטת קצין התגמולים',
    treatmentTransferredToBenefitsOfficerShort: 'הטיפול הועבר לקצין התגמולים',
    afterDecisionReceived: 'לאחר שתתקבל החלטה, אפשר לצפות בה',
    inYourDocumentsArea: 'באיזור המסמכים שלך',
    actionCard1: 'פנייה בנושא ועדות',
    actionCard2: 'בקשה לוועדת נכות מוסבת',
    actionCard3: 'בקשה לוועדת החמרה במצב',
    edit: 'עריכה',
    download: 'הורדה',
    committeeDetails: 'פרטי הוועדה',
    committeePage: 'דף הוועדה',
    stopSending: 'להפסיק לשלוח',
    no: 'לא',
    editContactTitle: 'עריכת איש או אשת קשר',
    addContactTitle: 'רוצה להוסיף איש או אשת קשר לקבלת עדכונים?',
    contactSubtitle:
      'נשלח להם עדכונים אוטומטיים מהאזור האישי בנוגע לוועדות הרפואיות שלך',
    existContactSubtitle:
      'עדכונים מהאזור האישי בנוגע לוועדות הרפואיות שלך נשלחים גם ל:',
    contactDetails: 'פרטי איש או אשת הקשר',
    firstNameLabel: 'שם פרטי',
    firstNameRequired: 'שם פרטי הוא שדה חובה',
    lastNameLabel: 'שם משפחה',
    lastNameRequired: 'שם משפחה הוא שדה חובה',
    emailLabel: 'כתובת אימייל',
    emailRequired: 'אימייל הוא שדה חובה',
    emailInvalid: 'כתובת אימייל לא תקינה',
    phonePrefixLabel: 'קידומת',
    phonePrefixRequired: 'קידומת היא שדה חובה',
    phoneNumberLabel: 'מספר טלפון נייד',
    phoneNumberRequired: 'מספר טלפון הוא שדה חובה',
    approvalLabel: 'אני רוצה שתשלחו עדכונים בנושא הוועדות הרפואיות שלי לאדם זה',
    approvalRequired: 'יש למלא שדה זה',
    confirmAndSave: 'אישור ושמירה',
    back: 'חזרה',
    submitErrorMessage: 'עקב תקלה הטופס לא נשלח',
    successTitle: 'איש הקשר נוסף בהצלחה',
    thanksForUpdate: 'תודה על עדכון הפרטים',
    nameLabel: 'שם',
    emailDisplayLabel: 'אימייל',
    phoneDisplayLabel: 'טלפון',
    finish: 'סיום',
    editDetails: 'עריכת פרטים',
    stopSendingContactUpdates: 'נפסיק לשלוח עדכונים לאדם שבחרת',
    cancel: 'ביטול',
    yesAdd: 'כן, להוסיף',
    stopSendingToContactPrompt: 'האם להפסיק לשלוח עדכונים לאיש קשר זה?',
    fullNameLabel: 'שם מלא',
    notAvailable: 'לא זמין',
    successPageTitle: 'הוספת איש קשר לעדכונים - הצלחה',
    successMainTitle:
      'נתחיל לשלוח עדכונים מהאזור האישי בנושא הוועדות שלך לאדם שבחרת',
    successEmailLabel: 'דואר אלקטרוני',
    successPhoneLabel: 'טלפון',
    successFinishButton: 'סיום',
    successEditDetailsButton: 'עריכת פרטים',
    yesStopSending: 'כן, להפסיק',
    discussionDetails: 'פרטי הדיון',
    location: 'מטה אגף השיקום. זבוטינסקי 94, פתח תקווה',
    participants: 'בדיון ישתתפו',
    doctors: 'רופאים ורופאות:',
    secretary: 'מזכיר או מזכירה רפואיים:',
    processStages: 'שלבי התהליך',
    scheduledDate: 'נקבע בתאריך:',
    moreInfo: 'מידע נוסף',
    modifiedDate: 'תאריך העלאה',
    discussionDate: 'תאריך הדיון',
    difficultyAttending: 'יש לך קושי להגיע לדיון?',
    allInformationInLink: 'בקשה לדחיית מועד או נוכחות מיוחדת',
    requestPostponementOrSpecialAttendance: 'בקשה לדחייה או נוכחות מיוחדת',
    possibleToRequestFromDepartment: 'אפשר לבקש מהאגף:',
    contactCommitteesUnit: 'פנייה ליחידת הוועדות',
    discussionWithLegalRepresentationOnly:
      'דיון בנוכחות הייצוג המשפטי שלך בלבד',
    discussionWithoutPhysicalPresence:
      'דיון ללא נוכחות פיזית (דיון ב-ZOOM או ללא נוכחות)',
    postponeDiscussionToAnotherDate: 'דחיית דיון למועד אחר',
    requestToCancelDiscussion: 'בקשה לביטול הדיון',
    subjects: 'נושאים',
    subjectsLabel: 'נושאים:',
    detailIfNeeded: 'פירוט אם יש צורך',
    doctorsInField: 'בדיון ישתתפו רופאים ורופאות מתחום:',
    additionalMedicalFactors:
      'ייתכן ובדיון ישתתפו גורמים רפואיים נוספים בהתאם להרכב הוועדה באותו היום',
    howToGetThere: 'איך להגיע?',
    mayInterestYouNow: 'יכול לעניין אותך עכשיו',
    continueReading: 'המשך קריאה',
    moreInfoForYou: 'עוד מידע עבורך',
    protocolAvailable: 'פרוטוקול הדיון זמין עבורך. ',
    downloadProtocol: 'להורדת הפרוטוקול',
    downloadProtocolLabel: 'הורדת הפרוטוקול',
    protocolAndRecordingAvailable: 'פרוטוקול והקלטת הדיון זמינים עבורך',
    recordingAvailableForYou: 'הקלטת הדיון זמינה עבורך',
    listenToRecording: 'האזנה להקלטה',
    protocol: 'פרוטוקול',
    recording: 'הקלטה',
    playRecording: 'השמעה',
    closedAt: 'נסגר בתאריך:',
    updatedAt: 'עודכן בתאריך',
    moreDetails: 'פרטים נוספים',
    treatmentTransferredToBenefitsOfficer: 'הטיפול הועבר לקצין התגמולים בתאריך',
    decisionWillAppearInDocuments: 'כשתהיה החלטה, היא תופיע',
    decisionWillAppearInDocumentsLink: 'באיזור המסמכים שלך',
    submitAppeal: 'הגשת ערעור',
    processStagesTitle: 'שלבי התהליך',
    subjectsDetails: 'פירוט הנושאים',
    whenDecision: 'כשתהיה החלטה',
    willAppearInDocuments: 'היא תופיע באזור המסמכים שלך',
    sendArrivalConfirmation: 'לשלוח אישור הגעה',
    sendConfirmation: 'שליחת אישור',
    attachMedicalOpinion: 'לצרף חוות דעת רפואית',
    upload: 'העלאה',
    uploadDocuments: 'העלאת מסמכים',
    action: 'פעולה',
    showMore: 'עוד',
    showLess: 'פחות',
    yourTasks: 'משימות לטיפול שלך',
    discussionHeldOnDate: 'הדיון התקיים בתאריך',
    completedCommittees: 'וועדות שהסתיימו',
    completedCommitteesSubtitle:
      'כאן מופיעות כל הוועדות שלך שהטיפול בהן הסתיים. אפשר לראות את אחוזי הנכות שנקבעו לך באזור פרטים אישיים',
    noCompletedCommittees: 'אין ועדות שהסתיימו',
    completedCommitteesCount: 'ועדות שהסתיימו:',
    recordingsLobby: 'הקלטות',
    recordingsLobbySubtitle:
      'כאן שמורות הקלטות של דיוני הוועדה בהם נכחת. את הפרוטוקולים של הדיונים אפשר למצוא בדף ועדה ',
    andInYourDocumentsArea: 'ובאזור המסמכים שלך',
    recordingsCount: 'הקלטות',
    committeeRecording: 'הקלטת ועדה',
    newRecording: 'הקלטה חדשה',
    committeeRecordingDescription: 'הקלטה של ועדה בנושא נכות כללית',
    loadingRecordings: 'טוען הקלטות...',
    noRecordingsAvailable: 'אין הקלטות זמינות',
    onDate: 'בתאריך:',
    notScheduled: 'לא נקבע',
    atTime: 'בשעה:',
    recordingsDiscussions: 'הקלטות דיונים',
    phoneNumberMustBeExactlyDigits: (digits: number) =>
      `מספר הטלפון חייב להיות בדיוק ${digits} ספרות`,
    mustApproveTerms: 'יש לאשר את התנאים',
    meetingWithLawyerOnlyReminder:
      'בהתאם לבקשתך הדיון יתקיים ללא הנוכחות שלך, אך בנוכחות הייצוג המשפטי שבחרת',
    meetingWithoutAttendanceReminder:
      'בהתאם לבקשתך, הדיון יתקיים ללא הנוכחות שלך',
    zoomDiscussionMessage: 'הדיון יתקיים בשיחת ZOOM, קישור ישלח לפני המועד',
    zoomLinkAvailable: 'יש להיכנס לקישור בשעה שנקבעה',
    joinZoomMeeting: 'הצטרפות לדיון בZOOM',
    postponedOrNotHeldCommittees: 'ועדות שנדחו או שלא התקיימו',
    discussionPostponedFrom: 'הדיון נדחה מתאריך:',
    discussionPlannedFor: 'הדיון תוכנן לתאריך:',
    postponedByAuthority:
      'דחינו את הדיון לבקשת יחידת הוועדות, נדאג לעדכן אותך כשיקבע תאריך חדש',
    postponedByApplicant: 'הדיון נדחה לבקשתך, נדאג לעדכן אותך כשיקבע תאריך חדש',
    postponedByLawyer:
      'הדיון נדחה לבקשת הייצוג המשפטי, נדאג לעדכן אותך כשיקבע תאריך חדש',
    notHeldApplicantAbsent:
      'נעדרת מהדיון ולכן הוא לא התקיים. יש לפנות אל האגף להמשך טיפול',
    contactDepartment: 'לפנייה לאגף',
    getPurposeTypeName: (id: number) => {
      switch (id) {
        case 1:
          return 'ערעור נכה';
        case 2:
          return 'תקנה 9';
        case 3:
          return 'פסק דין בית משפט';
        case 4:
          return 'ערעור קת"ג';
        case 5:
          return 'ועדה מדרג ראשון';
        case 6:
          return 'ועדה לפי 28א';
        case 7:
          return 'חזרת מצב קודם';
        case 8:
          return 'חוזרת החמרת מצב';
        case 9:
          return 'פסק דין בית משפט – דיון חוזר';
        case 10:
          return 'ועדה לפי 37 קת"ג';
        case 11:
          return 'נוספת';
        case 12:
          return 'אירוע חיצוני';
        case 9999:
          return 'אחר';
        default:
          return 'ועדה';
      }
    },

    getStageTypeName: (id: number) => {
      switch (id) {
        case 1:
          return 'דיון בוועדה';
        case 2:
          return 'אישור הפרוטוקול';
        case 3:
          return 'הוצאת החלטה';
        default:
          return '';
      }
    },
    externalCommitteeContactInfo:
      'תאריך, שעה ופרטים נוספים ניתן לקבל מיחידת הוועדות:',
    externalCommitteeContactInfoWithLocation:
      'תאריך, שעה ופרטים נוספים ניתן לקבל מיחידת הוועדות ב',
    externalCommitteeSiteButton: 'ועדה רפואית ב',
    externalCommitteeNavigateButton: 'ניווט למקום',
    externalCommitteeLocation: 'הועדה מתקיימת ב',
    followUpMeetingInfoBox: (date: string) =>
      `לבקשת צוות הוועדה, נקבע עבורך דיון נוסף לתאריך ${date}`,
    uploadMedicalOpinionTitle: (committeeTitle: string, subjects?: string) =>
      `נושא: צירוף קובץ חוות דעת רפואית לועדה ${committeeTitle}${
        subjects ? `  ופגיעות בנושא ${subjects}.` : ''
      }`,
  },
  [DICTIONARY.Feedback]: {
    recordingDone: 'בוצעה הקלטת מסך',
    notes: 'הערות',
    stopRecording: 'הפסקת הקלטת מסך',
    startRecording: 'הפעלת הקלטת מסך',
    thankYou: 'תודה על המשוב',
    thankYouMessage: 'ההערות שלך יעזרו לנו לשפר את האתר והשירות',
    technicalProblemMessage: 'נעביר את המידע לצוות הטכני של האתר',
    newPageTitle: 'מה חשבת על העמוד החדש?',
    newPageMessage:
      'העמוד הזה נוצר לאחרונה, במטרה לשפר את המענה הדיגיטלי והשירות באתר.',
    yourOpinionIsImportant: 'דעתך חשובה לנו',
    wasItHelpful: 'האם הוא תרם לך?',
    whatDidYouThinkSite: 'מה חשבת על האתר והשירות הדיגיטלי?',
    whatDidYouThinkPage: 'מה חשבת על העמוד?',
    file: 'הקובץ שצירפת',
    delete: 'מחיקה',
    view: 'צפייה',
    send: 'שליחת משוב',
    wantToReachOut: 'רוצה לפנות בנושא אישי?',
    sendRequest: 'נא לשלוח פנייה לאגף',
    rowNumber: 'מספר',
    status: 'סטטוס',
    device: 'מכשיר',
    browser: 'דפדפן',
    deviceDetails: 'פרטי מכשיר',
    statuses: ['ממתין לטיפול', 'טופל', 'בטיפול'],
    getStatus: (id: FEEDBACK_STATUSES) =>
      ['ממתין לטיפול', 'טופל', 'בטיפול'][id - 1],
    getDeviceType: (id: DEVICE_TYPE) => {
      switch (id) {
        case 1:
          return 'IOS';
        case 2:
          return 'ANDROID';
        case 3:
          return 'PC';
        case 4:
          return 'OTHER';
        default:
          return '';
      }
    },
    getBrowserType: (id: BROWSER_TYPE) => {
      switch (id) {
        case 1:
          return 'CHROME';
        case 2:
          return 'SAFARI';
        case 3:
          return 'EDGE';
        case 4:
          return 'FIREFOX';
        case 5:
          return 'SAMSUNG INTERNET';
        case 6:
          return 'OPERA';
        case 7:
          return 'OTHER';
        default:
          return '';
      }
    },
    number: 'מספר:',
    date: 'תאריך',
    websiteArea: 'סביבה באתר',
    feedbackContext: 'מהות המשוב',
    feedbackReason: 'הסיבה למשוב',
    newEnvironmentRating: 'סביבה חדשה',
    mainTitle: 'ריכוז משובים באזור האישי',
    attachedFiles: 'קבצים שצורפו',
    id: 'תעודת זהות',
    fullName: 'שם מלא',
    phone: 'טלפון',
    email: 'דוא"ל',
    managerName: 'אדמין',
    downloadFile: 'הורדת קובץ',
    downloadScreenRecord: 'הורדת הקלטת מסך',
    remarks: 'הערות',
    backToFeedbackList: 'חזרה לרשימת המשובים',
    showResults: 'הצגת תוצאות',
    clearSelection: 'איפוס בחירה',
    back: 'חזרה',
    singleFeedback: {
      subTitle: 'משוב מהאזור האישי',
    },
    sortOldToNew: 'מהישן לחדש',
    sortNewToOld: 'מהחדש לישן',
    exportToCSV: 'ייצוא לאקסל',
    exportToCSV2: 'ייצוא לאקסל (מומלץ לבחור סננים, בפרט סנן תאריך)',
    importCsv: 'ייבוא אקסל',
    feedbacksFound: (count: number) =>
      `נמצאו ${count > 0 ? count : '0'} משובים`,
    nextFeedback: 'למשוב הבא',
    previousFeedback: 'למשוב הקודם',
    selectedItems: (count: number) => `${count} נבחרו`,
    chooseDateRange: 'בחירת טווח תאריכים',
    allFeedbacks: {
      subTitle1: 'כאן נמצאים כל המשובים שהתקבלו ממשתמשי האתר',
      subTitle2: 'ניתן לבצע סינון לפי קטגוריות שונות',
    },
    unifiedImprovementAreas: {
      improvementRequired: 'יש מה לשפר',
      TechnicalProblem: 'יש בעיה טכנית',
      Liked: 'אהבתי',
      Other: 'אחר',
    },
    negativeFeedbackReasons: {
      NotComfortable: 'לא היה לי נוח',
      Unclear: 'לא היה לי ברור',
      Other: 'אחר',
    },
    helpfulnessRating: {
      Helped: 'תרם לי מאוד',
      PartiallyHelped: 'תרם לי חלקית',
      DidNotHelp: 'לא תרם לי בכלל',
    },
    dateChoices: {
      lastWeek: 'בשבוע האחרון',
      lastMonth: 'בחודש האחרון',
      lastYear: 'בשנה האחרונה',
      dateRange: 'טווח תאריכים',
    },
    note: {
      title: 'במה מדובר?',
      clarification: 'המשוב מיועד לשיפור האתר - ולא לפניות אישיות',
      placeHolder:
        'חשוב לנו להבין את הבעיה כדי לעזור: למשל, סדר הפעולות שביצעת, ואיזה הודעות התקבלו שמעידות על שגיאה',
      errorMessage: 'שדה חובה',
      howToImprove: 'איך אפשר לשפר לדעתך? (חובה)',
      howToImprovePlaceholder:
        'פה אפשר לכתוב על בעיות טכניות או הצעות לשיפור האתר',
      whatIsTheProblem: 'במה מדובר?',
      whatIsTheProblemPlaceholder:
        'חשוב לנו להבין את הבעיה כדי לעזור:\nלמשל, סדר הפעולות שביצעת, ואיזה הודעות התקבלו שמעידות על שגיאה',
      details: 'נשמח לדעת, מה אהבת?',
      detailsPlaceholder: 'פה אפשר לכתוב מה אהבת במיוחד',
    },
    uploadArea: {
      dragFileHere: 'אפשר לגרור לכאן קובץ',
      or: 'או',
      uploadFileMobile: 'לצרף קובץ (למשל, צילום מסך)',
      uploadFile: 'צירוף קובץ',
      uploadVideoFile: 'צירוף קובץ מסוג סרטון',
      typeError:
        'הקובץ לא תקין. אפשר לצרף קובץ עד משקל 20Mb עם אחת מהסיומות: doc, docx, jpg, png, pdf, tif',
    },
    reason: {
      reasonIs: 'נשמח להבין, מה הסיבה?',
      errorMessage: 'שדה חובה',
    },
    info: {
      sizeError: 'הקובץ גדול מדי. אפשר להעלות עד 20MB',
      info: 'אורך הקלטה מירבי עד 30 שניות ועד 20mb',
      infoMobile:
        'אפשר להקליט מסך באמצעות האפשרות הקיימת במכשיר הנייד. אורך הקלטה מירבי עד 30 שניות ועד 20mb',
    },
  },
  [DICTIONARY.Lawyers]: {
    title: 'המיוצגים שלך מול האגף',
    subtitle: 'כאן מופיעים כל מבקשי ההכרה בנכות שמיוצגים על ידך',
    repFor: 'ייצוג משפטי עבור:',
    idNumberWithColon: 'מספר תז:',
    toPreformAction: 'כדי לבצע פעולה עבור אדם זה, יש לבחור מהתפריט בצד ימין',
    description: 'ניתן לצפות במידע ולבצע פעולות, בלחיצה על השם המבוקש:',
    sortAscending: 'מיון: א - ת',
    sortDescending: 'מיון: ת - א',
    lastName: 'שם משפחה',
    firstName: 'שם פרטי',
    idNumber: 'מספר תז',
    mobileNumber: 'מספר נייד',
    select: 'בחירה',
    didNotSelect: 'לא בחרת אדם מיוצג',
    goBackToList:
      'יש לחזור לרשימת המיוצגים, לבחור את האדם ואז את הפעולה שרצית לבצע עבורו',
    backToList: 'חזרה לרשימת המיוצגים',
    helloName: (name: string) => `שלום עו”ד ${name}`,
    switchBetweenLawyersAndUsers: 'מעבר בין משתמש רגיל לעורך דין',
    personalArea: 'אזור אישי',
    repArea: 'אזור מיוצגים',
  },
  [DICTIONARY.SearchResults]: {
    searchFilter: 'מה אפשר לחפש עבורך',
    updateDate: 'עודכן בתאריך: ',
    dateOfReceive: 'מועד קבלת התשלום: ',
    lastUseDate: 'תאריך מימוש אחרון: ',
    uploadDate: 'תאריך העלאה: ',
    noData: 'חסר מידע',
    download: 'להורדה',
    downloadAccessible: 'להורדת תלוש נגיש',
    moreInfo: 'פרטים נוספים',
    sendApply: 'שליחת פנייה באתר',
    actionsTitle: 'פעולות קשורות',
    clear: 'נקה חיפוש',
    treatmentsEntitlements: 'חמי מרפא - זכאות',
    treatmentsOrders: 'חמי מרפא - הזמנות',
    claimsEvents: 'נושא הבקשה',
    eligibleMedications: 'שם תרופה',
    availableConsEquipment: 'ציוד מתכלה',
    consEquipmentOrders: 'הזמנות ציוד מתכלה',
    prescriptionsOrders: 'התרופות שבהזמנה: ',
    SearchResults: 'תוצאות חיפוש',
    form106FileName: (year?: number) => `טופס 106 לשנת ${year}`,
    toApplyIn: 'להגשת פניה ב',
    duty: 'תפקיד',
    allResults: 'כל התוצאות מהאזור האישי',
    pagination: 'עמודות',
    oldToNew: 'מהישן לחדש',
    newToOld: 'מהחדש לישן',
    resultCount(count: string) {
      return `מציג ${count} תוצאות`;
    },
    payslipTitle: (month?: number, year?: number) =>
      `תלוש חודש ${month && payslipMonthToText(month)} שנת ${year}`,
    filter: 'מיון וסינון',
    openFilters: 'פתח מיון וסינון',
    whatToShow: 'מה להציג',
    selectedCount: (count: number) => `נבחרו ${count}`,
    whatToShow2: 'מה להציג?',
    sortBy: 'מיון תוצאות לפי',
    popularSuggestions: 'הצעות פופולריות',
    notYetDetermined: 'טרם נקבע',
    forEver: 'לצמיתות',
    sortByDropdown: 'מיון לפי:',
    close: 'סגירה',
    typeFilter: 'סינון לפי סוג',
    subject: 'נושא',
    documentsShown: (count: number) => `${count} מסמכים מוצגים`,
    type: (type: SEARCH_RESULTS_TYPE) => {
      switch (type) {
        case SEARCH_RESULTS_TYPE.MEDICAL_REFERRAL: //done
          return 'התחייבות (הפניה) רפואית';
        case SEARCH_RESULTS_TYPE.APPLIES: //done
          return 'פניות לאגף';
        case SEARCH_RESULTS_TYPE.LONG_TERM_EQUIPMENT: //done
          return 'ציוד ארוך טווח';
        case SEARCH_RESULTS_TYPE.PAYMENTS_AND_DEDUCTIONS: //done
          return 'תשלומים וניכויים';
        case SEARCH_RESULTS_TYPE.UNIVERSAL_REQUEST:
          return 'הגשת פניה לאגף';
        case SEARCH_RESULTS_TYPE.YOUR_TEAM: //done
          return 'הצוות האישי שלך';
        case SEARCH_RESULTS_TYPE.COMPASS: //done
          return 'מצפן זכויות';
        case SEARCH_RESULTS_TYPE.DOCUMENTS: //done
          return 'מסמכים שלך';
        case SEARCH_RESULTS_TYPE.PAYSLIPS: //done
          return 'תלושים';
        case SEARCH_RESULTS_TYPE.FORM106: //done
          return 'טפסי 106';
        case SEARCH_RESULTS_TYPE.TREATMENTS_ENTITLEMENTS: //done
          return 'חמי מרפא - זכאות';
        case SEARCH_RESULTS_TYPE.TREATMENTS_ORDERS: //done
          return 'חמי מרפא - הזמנה';
        case SEARCH_RESULTS_TYPE.CLAIMS_EVENTS: //done
          return 'סטטוס הכרה';
        case SEARCH_RESULTS_TYPE.ELIGIBLE_MEDICATIONS: //done
          return 'תרופות ומרשמים -תרופה';
        case SEARCH_RESULTS_TYPE.PRESCRIPTIONS_ORDERS: //done
          return 'תרופות ומרשמים - הזמנה';
        case SEARCH_RESULTS_TYPE.AVAILABLE_CONS_EQUIPMENT:
          return 'ציוד מתכלה -ציוד';
        case SEARCH_RESULTS_TYPE.CONS_EQUIPMENT_ORDERS:
          return 'ציוד מתכלה - הזמנה';
        default:
          return '';
      }
    },
    getSortBy: (sortBy: SORT_BY) => {
      switch (sortBy) {
        case SORT_BY.SCORE:
          return 'רלוונטיות';
        case SORT_BY.ASCENDING:
          return 'מהישן לחדש';
        case SORT_BY.DESCENDING:
          return 'מהחדש לישן';
        default:
          return '';
      }
    },
    getStatus: (type: SEARCH_RESULTS_TYPE, status: number) => {
      switch (type) {
        case SEARCH_RESULTS_TYPE.PAYMENTS_AND_DEDUCTIONS:
          switch (status) {
            case PAYMENT_DEDUCTION_STATUS.OPENED_IN_SYSTEM:
              return 'הבקשה נפתחה';
            case PAYMENT_DEDUCTION_STATUS.UNDER_REVIEW:
              return 'בבדיקה';
            case PAYMENT_DEDUCTION_STATUS.APPROVED:
              return 'הסתיים';
            case PAYMENT_DEDUCTION_STATUS.ON_HOLD:
              return 'בוטלה';
            case PAYMENT_DEDUCTION_STATUS.REJECTED:
              return 'נדחתה';
            default:
              return '';
          }
        case SEARCH_RESULTS_TYPE.MEDICAL_REFERRAL ||
          SEARCH_RESULTS_TYPE.APPLIES:
          switch (status) {
            case STATUSES.OPENED_IN_SYSTEM:
              return 'הבקשה נפתחה';
            case STATUSES.UNDER_REVIEW:
              return 'בבדיקה';
            case STATUSES.APPROVED:
              return 'אושרה';
            case STATUSES.ON_HOLD:
              return 'בוטלה';
            case STATUSES.REJECTED:
              return 'נדחתה';
            default:
              return '';
          }
      }
    },
    showMore: 'הצג עוד',
    showLess: 'הצג פחות',
    status: 'מצב הטיפול: ',
    appMaanakSum: 'סכום ההחזר: ',
    deductionSum: 'סכום הניכוי: ',
    notDetermined: 'טרם נקבע',
    semanticRerankerScore: 'רלוונטיות: ',
    rerankerBoostedScore: 'רלוונטיות משוכללת:',
    eligibilityType: 'סוג זכאות: ',
    contact: 'איש קשר: ',
    description: 'תיאור: ',
    entitlementType: 'סוג הזכאות: ',
    supplierName: 'שם הספק: ',
    treatmentStage: 'שלב הטיפול: ',
    entitlementPeriod: 'תקופת הזכאות: ',
    hotelName: 'שם המלון: ',
    remainingEntitlementDays: 'יתרת לילות: ',
    orderNumber: 'מספר ההזמנה: ',
    notValid: 'לא בתוקף',
    validToDate: 'תוקף ההפניה: ',
    future: 'התחייבות (הפניה) עתידית',
    numberOfNights: 'מספר הלילות: ',
    entitlementAccompanied: 'מספר מלווים: ',
    startDate: 'תאריך התחלה: ',
    nextRefreshDate: 'תוקף המרשם הנוכחי: ',
    lastOrderOfThatItem: 'תאריך הזמנה אחרונה: ',
    createDate: 'תאריך הזמנה: ',
    eligibilityPeriodEnd: 'סוף תקופת הזכאות: ',
    documentType: 'מסמך בנושא: ',
    itemName: 'שם הפריט: ',
    treatmentStatus: 'מצב הטיפול: ',
    name: 'שם: ',
    phone1: 'טלפון 1: ',
    phone2: 'טלפון 2: ',
    fax: 'פקס: ',
    email: 'דוא"ל: ',
    userNote: 'הפנייה שלך: ',
    reply: 'תשובת האגף: ',
    canRedeemFromDate: 'ניתן לממש מתאריך',
    getAppMaanakSum: (sum: number) => {
      return `${Math.abs(sum)}${Math.sign(sum) === -1 ? '-' : ''} ₪`;
    },
    noSearchTitle: 'כדי שנוכל להציג תוצאות,',
    noSearchSubTitle: 'כדאי להקליד בתיבה למעלה מה מעניין אותך לחפש',
    noResultsTitle: 'מצטערים, לא מצאנו את מה שחיפשת',
    noResultsSubTitle: 'כדאי לחפש שוב במילים אחרות, או לנסות לחפש משהו אחר',
    goToEnvironment: 'מעבר לסביבה',
  },
  [DICTIONARY.EmergencyCallAdmin]: {
    title: 'מאגר שיחות לתומכי אגף השיקום',
    totalDisables: 'סה"כ נכים',
    needToCall: 'נדרש להתקשר',
    numOfAnsweredCalls: 'כמות שנענו',
    noAnswer: 'אין מענה',
    callLater: 'להתקשר מאוחר יותר',
    contactDepartment: 'פנייה לאגף',
    totalWithWrongPhone: 'טלפון שגוי',
    gender: 'מגדר',
    city: 'עיר',
    familyStatus: 'מצב משפחתי',
    disableName: 'שם הנכה',
    inProcess: 'בטיפול',
    answered: 'נענה',
    status: 'סטטוס',
    unknown: 'לא ידוע',
    dateAndHour: 'תאריך ושעה',
    yesAllOptions: ['הכל', 'כן'],
    districtTitle: 'יש לבחור מחוז להצגת הנתונים',
    district: 'מחוז',
    chooseDistrict: 'בחירת מחוז',
    backToList: 'חזרה לרשימת הנכים',
    isrId: 'ת"ז',
    fullName: 'שם מלא',
    phoneNumber: 'טלפון',
    representative: 'נציג מטפל',
    questionnaire: 'שאלון',
    accordingToScript: 'האם שוחחתם בהתאם לתסריט השיחה?',
    hadProblems:
      'האם העלה קושי או מצוקה, ודרוש שעובד מקצועי מאגף השיקום יחזור אליו?',
    specialist: 'לאיזה גורם במחוז הוא מבקש לפנות?',
    needHelpExplanation: 'במה הוא צריך עזרה? (נא לפרט בהרחבה)',
    subject: 'נושא',
    getSubjectLabel: (id: number) => {
      switch (id) {
        case 143:
          return 'מרפאה';
        case 144:
          return 'רווחה';
        case 145:
          return 'עובדת סוציאלית';
        default:
          return '';
      }
    },
    inHandle: 'בטיפול',
    all: 'הכל',
    currentlyBeingHandled: 'בטיפול כעת',
    agentsForEmergencyCalls: 'מוקדנים לשיחות חירום',
    addNewAgent: 'הוספת מוקדן חדש',
    idAlreadyExists: 'ת.ז כבר קיים במערכת',
    noAgentsFound: 'לא נמצאו מוקדנים',
    edit: 'עריכה',
    delete: 'מחיקה',
    searchByName: 'חיפוש לפי שם',
    searchById: 'חיפוש לפי ת.ז',
    editAgent: 'עריכת מוקדן',
    israeliId: 'ת.ז',
    name: 'שם',
    phone: 'מספר טלפון',
    cancel: 'ביטול',
    save: 'שמירה',
    confirmDeletion: 'אישור מחיקה',
    areYouSureYouWantToDelete: 'האם אתה בטוח שברצונך למחוק את',
    getStatusLabel: (statusId: number) => {
      switch (statusId) {
        case STATUS_TYPES.NO_ANSWER:
          return 'אין מענה';
        case STATUS_TYPES.WRONG_PHONE:
          return 'טלפון שגוי';
        case STATUS_TYPES.CALL_LATER:
          return 'להתקשר מאוחר יותר';
        case STATUS_TYPES.ANSWERED:
          return 'נענה';
        default:
          return '';
      }
    },
    yes: 'כן',
    no: 'לא',
  },
  [DICTIONARY.EmergencyCall]: {
    title: 'מאגר שיחות לתומכי אגף השיקום',
    subtitle: [
      'כאן נמצאים פרטים של נכי צה”ל שיש ליצור עימם קשר במסגרת מצב חירום',
      'מעבר לתסריט',
    ],
    search: 'חיפוש לפי שם, ת.ז או טלפון...',
    searchById: 'חיפוש לפי ת.ז',
    refreshList: 'רענון התוצאות',
    id: 'ת"ז',
    patientsFullName: 'שם מלא של הנכה',
    district: 'מחוז',
    status: 'סטטוס',
    dateAndTime: 'תאריך ושעה',
    noAnswer: 'אין תשובה',
    callLater: 'להתקשר מאוחר יותר',
    wrongPhone: 'טלפון שגוי',
    success: 'הצלחה',
    successMessage: 'הפרטים נקלטו בהצלחה',
    finish: 'סיום',
    takenErrorTitle: 'אופס',
    takenErrorMessage: 'נציג אחר כבר נמצא בתוך כרטייסית הנכה יש לצאת ממנה',
    exit: 'יציאה',
    treatingFactors: [
      'מרפאה (בנושא טיפול רפואי, בדיקות, תרופות, הפניות וכדומה)',
      'רווחה (בנושא תשלומים ותגמולים, רכב רפואי)',
      'עובדת סוציאלית (טיפול נפשי, לימודים, שיקום תעסוקתי)',
    ],
    selectionRequired: 'חובה לבחור',
    fillRequired: 'חובה למלא',
    fullName: 'שם מלא',
    phone: 'טלפון',
    gender: 'מין',
    familyStatus: 'מצב משפחתי',
    city: 'עיר/ישוב',
    answered: 'יש מענה',
    adminName: 'אדמין מטפל',
    all: 'הכל',
    questions: 'שאלון',
    didYouTalk: 'האם שוחחתם בהתאם לתסריט השיחה',
    yes: 'כן',
    no: 'לא',
    didNeedHelp:
      'האם העלה קושי או מצוקה, ודרוש שעובד מקצועי מאגף השיקום יחזור אליו?',
    whichTreatingFactor: 'לאיזה גורם במחוז הוא מבקש לפנות?',
    selectTreatingFactor: 'בחירת נושא/גורם מטפל',
    needHelpDetails: 'במה הוא צריך עזרה? (נא לפרט בהרחבה)',
    submit: 'שליחה',
    previousCall: 'לשיחה הקודמת',
    nextCall: 'לשיחה הבאה',
    otpGenerationError: 'שגיאה ביצירת קוד OTP',
    idValidationError: 'תעודת זהות חייבת להיות 9 ספרות',
    phoneValidationError: 'מספר טלפון חייב להיות 10 ספרות',
    incorrectDetails: 'הפרטים שהוזנו אינם נכונים',
    login: 'התחברות',
    loginInstructions: 'לקבלת קוד יש להזין תעודת זהות וטלפון נייד',
    idNumber: 'תעודת זהות',
    phoneNumber: 'מספר טלפון',
    getCode: 'קבלת הקוד',
    blockedMessage: 'נחסמת ל-5 דקות עקב ניסיונות כושלים רבים.',
    goToQuestionnaire: 'מעבר לשאלון',
    backToList: 'חזרה לרשימת השיחות',
  },
  [DICTIONARY.DataAnalysis]: {
    searchTitle: 'חיפוש מתקדם',
    search: 'חיפוש פניות',
    searchResults: 'תוצאות חיפוש',
    notMatching: 'לא תואם',
    title: 'מאגר פניות - ניתוב פניות וניתוחן',
    statsTitle: 'התפלגות פניות לפי מצבי קיצון',
    totalEvaluations: 'סה”כ פניות',
    avgTime: 'זמן ממוצע לטיפול',
    formatInTreatmentHours: (totalHours?: number | null) => {
      if (totalHours === undefined || totalHours === null) return '-';
      if (totalHours < 24) return `${totalHours} שעות`;

      const days = Math.floor(totalHours / 24);
      const remainingHours = totalHours % 24;

      return `${days} ימים ו${remainingHours} שעות`;
    },
    evalsInTreatment: 'פניות בטיפול',
    dateInputTitle: 'מוצגים נתונים לחודש:',
    backToLobby: 'חזרה לרשימת הנכים',
    itemTitle: 'מאגר פניות - ניתוב פניות וניתוחן',
    prevLine: 'לשורה הקודמת',
    nextLine: 'לשורה הבאה',
    idNumber: 'מספר ת”ז',
    fullName: 'שם מלא',
    phone: 'טלפון',
    county: 'מחוז',
    age: 'גיל',
    hours: 'שעות',
    gender: 'מין',
    residence: 'ישוב מגורים',
    maritalStatus: 'מצב משפחתי',
    subject: 'נושא',
    subSubject: 'תת נושא',
    aiSubject: 'נושא (ניתוב מוצע ע״י ai)',
    aiSubSubject: 'תת נושא (ניתוב מוצע ע״י ai)',
    workQueue: 'תור עבודה',
    dateAndTime: 'תאריך ושעה',
    requestContentTitle: (date: string) =>
      `תוכן הפנייה (מתאריך ${format(new Date(date), 'dd/MM/yyyy')})`,
    requestSummary: 'תקציר הפנייה',
    addedFiles: 'קבצים מצורפים',
    allConditionTypes: 'כל סוגי המצבים',
    violenceLevel: 'רמת אלימות',
    justification: 'ביסוס הניתוח',
    confidenceScore: 'ציון הניתוח',
    findings: 'ממצאים',
    history: 'הסטוריה',
    inApply: 'בפנייה',
    identified: 'זיהה סימנים ל',
    exportToCsv: 'ייצוא לאקסל',
    csvHeaders: [
      'מספר בדיקה',
      'מספר ת”ז',
      'תאריך הפנייה',
      'מחוז',
      'סיכום הערה',
      'הערה מקורית',
      'מצוקה רגשית',
      'פ.טראומה',
      'דיכאון',
      'בדידות',
      'קשיי תפקוד',
      'רמת אלימות',
      'ציון הניתוח',
      'ביסוס הניתוח',
    ],
    getConfidenceScoreLabel: (score: number) => {
      return `ציון ${score} ומעלה`;
    },
    getTotalResults: (total: number) =>
      `מוצגות ${total.toLocaleString()} רשומות`,
    totalResultsOverLimit:
      'מוצגות 15,000 רשומות (מוצגות מקסימום הרשומות האפשרי, לצמצום הרשימה ניתן להשתמש בסננים של החיפוש המתקדם)',
    getEvaluationTypeLabel: (type: string) => {
      switch (type) {
        case 'extremeEmotionalDistress':
          return 'מצוקה רגשית';
        case 'postTraumaticSymptoms':
          return 'פ.טראומה';
        case 'depression':
          return 'דיכאון';
        case 'deepLoneliness':
          return 'בדידות';
        case 'functionalDifficulties':
          return 'קשיי תפקוד';
        default:
          return '';
      }
    },
    getEvaluationTypeFromLabel: (label: string) => {
      switch (label) {
        case 'מצוקה רגשית':
          return 'extremeEmotionalDistress';
        case 'פ.טראומה':
          return 'postTraumaticSymptoms';
        case 'דיכאון':
          return 'depression';
        case 'בדידות':
          return 'deepLoneliness';
        case 'קשיי תפקוד':
          return 'functionalDifficulties';
      }
    },
    getViolenceLevelLabel: (levelId: number) => {
      switch (levelId) {
        case 0:
          return 'ללא אלימות';
        case 1:
          return 'אלימות רמה 1';
        case 2:
          return 'אלימות רמה 2';
        case 3:
          return 'אלימות רמה 3';
        case 4:
          return 'אלימות רמה 4';
        default:
          return '';
      }
    },
    getCountTypeLabel: (type: keyof IUserNotesStats) => {
      switch (type) {
        case 'extremeEmotionalDistressCount':
          return 'מצוקה רגשית';
        case 'postTraumaticSymptomsCount':
          return 'פ.טראומה';
        case 'depressionCount':
          return 'דיכאון';
        case 'deepLonelinessCount':
          return 'בדידות';
        case 'functionalDifficultiesCount':
          return 'קשיי תפקוד';
        case 'violenceLevel1Count':
          return 'אלימות 1';
        case 'violenceLevel2Count':
          return 'אלימות 2';
        case 'violenceLevel3Count':
          return 'אלימות 3';
        case 'violenceLevel4Count':
          return 'אלימות 4';
        default:
          return '';
      }
    },
    getFilterLabel: (index: number) => {
      switch (index) {
        case 0:
          return 'מספר ת.ז';
        case 1:
          return 'מחוז';
        case 2:
          return 'תאריך ושעה';
        case 3:
          return 'רמת אלימות';
        case 4:
          return 'ציון הניתוח';
        case 5:
          return 'סיווג מצבי קיצון';
        default:
          return '';
      }
    },
    isMatchingOptions: ['תואם', 'לא תואם'],
    promptManager: {
      pageTitle: 'ניהול פרומפטים - ניתוח נתונים',
      historicalPromptTitle: 'צפייה בפרומפט היסטורי',
      historicalPromptDescription:
        'הכנס מספר הערכה כדי לראות את הפרומפט ששימש עבור הערכה זו',
      evaluationIdLabel: 'מספר הערכה',
      evaluationIdRequired: 'נא להזין מספר הערכה',
      evaluationIdInvalid: 'נא להזין מספר תקין',
      loadingText: 'טוען...',
      savingText: 'שומר...',
      currentPromptTitle: 'עריכת הפרומפט הנוכחי',
      currentPromptDescription: 'ערוך את החלקים הניתנים לעריכה של הפרומפט',
      loadPromptButton: 'טען פרומפט לעריכה',
      primaryTextLabel: 'טקסט ראשי (לקריאה בלבד)',
      editablePlaceholdersLabel: 'חלקים ניתנים לעריכה',
      saveChangesButton: 'שמור שינויים',
      resetChangesButton: 'איפוס שינויים',
      successMessage: 'הפרומפט עודכן בהצלחה',
      errorLoadingPrompt: 'שגיאה בטעינת הפרומפט',
      errorSavingPrompt: 'שגיאה בשמירת הפרומפט',
      errorPromptNotFound: 'לא נמצא פרומפט עבור הערכה זו',
      errorLoadingCurrentPrompt: 'לא ניתן לטעון את הפרומפט הנוכחי',
      onlyManagersCanSave: 'רק מנהלים יכולים לשמור שינויים',
      historySectionTitle: 'גרסאות פרומפט קודמות',
      historySectionDescription:
        'ניתן לבחור גרסה היסטורית כדי לטעון את ערכיה ולערוך אותם לפני שמירה.',
      historyListCreatedAtLabel: 'נוצר ב־',
      historyListActiveBadge: 'גרסה פעילה',
      historyListApply: 'טען גרסה',
      historyEmptyState: 'לא נמצאו גרסאות קודמות להצגה.',
      historyErrorLoading: 'שגיאה בטעינת היסטוריית הפרומפטים',
      historyAppliedSuccess: 'הגרסה שנבחרה נטענה, ניתן לערוך ולשמור.',
    },
    promptDialog: {
      title: 'פרומפט ששימש להערכה זו',
      showPromptButton: 'הצג פרומפט',
      errorLoadingPrompt: 'שגיאה בטעינת הפרומפט',
      errorPromptNotFound: 'לא נמצא פרומפט עבור הערכה זו',
    },
  },
  [DICTIONARY.MedicalCar]: {
    notEligible: 'אין זכאות לרכב רפואי',
    whatCanWEOfferYouNow: 'מה נוכל להציע לך עכשיו?',
    contactDepartment: 'פנייה לאגף',
    medicalCarGetInfo: 'מידע בנושא רכב רפואי',
    title: 'רכב רפואי',
    subTitle:
      'כאן אפשר לקבל מידע על תתהליך קבלת רכב רפואי, מול האגף, המרב"ד והיבואן',
    eligibleForMedicalCar: 'יש לך זכאות לרכב רפואי',
    getCarLicenseNote: () => {
      const currYear = new Date().getFullYear();
      return `קיבלת רשיון רכב לשנת ${currYear}?`;
    },
    carLicenseSubText:
      'כדאי לשלוח אותו אלינו, כדי שנוכל לחדש את ההטבות הנלוות לשנה הבאה',
    uploadCarLicense: 'העלאת קובץ לשליחה',
    canChangeCarNote: 'איזה כיף! אפשר להחליף רכב',
    yourCarArrived: 'איזה כיף, הרכב החדש שלך הגיע! ',
    allYouNeedToKnow: 'הנה כל מה שצריך לדעת',
    releasedFromCustomsTitle: 'הרכב שלך שוחרר מהגבלת מכס',
    releasedFromCustomsSubtitle:
      'הרכב שלך כבר לא משועבד, וההגבלות שהיו רשומות ברישיון הרכב הוסרו.',
    downloadCarLicense: 'הורדת רשיון רכב מעודכן',
    exchangeCarBeforeTime: 'החלפת רכב לפני הזמן',
    marbadNoApprovalTitle:
      'לא אושרה לך כשירות נהיגה על ידי המרב"ד, לפי הנתונים המעודכנים אצלנו',
    marbadNoApprovalSubtitle: 'באפשרותך להגיש בקשה לנהג או נהגת מלווה',
    downloadAccompaniedDriverForm: 'הורדת טופס נהג מלווה',
    licenceNumber: 'מספר רישוי',
    onRoadDate: 'תאריך עלייה לכביש',
    exchangeCarBeforeTimeSubTitle:
      'אפשר להגיש בקשה להחלפת הרכב לפני שעברו 3.5 שנים, במקרים הבאים:',
    carWasStolen: 'הרכב נגנב',
    totalLoss: 'תאונה שבה הרכב לא ניתן לתיקון',
    totalLossEn: '(Total loss)',
    medicalChanged: 'שינוי במצבך הרפואי',
    exchangeReq: 'הגשת בקשה להחלפה',
    moreInfo: 'מידע נוסף',
    exchangeCarTime: 'מועד החלפת הרכב',
    moreUsefulData: 'עוד מידע שימושי',
    fillUpFileToStart:
      'כדי לממש את הזכאות ולהתחיל בתהליך, יש למלא את טופס הבקשה.',
    fillUpFileDesktop: 'כדי להתחיל, יש למלא טופס בקשה',
    suggestionsTitle: 'יכול לעניין אותך עכשיו',
    howItWorks: 'איך זה עובד?',
    watch: 'צפייה',
    filesToDownload: 'טפסים להורדה',
    filesYouGot: 'מסמכים שקיבלת בנושא רכב',
    yourCar: 'הרכב שלך',
    yourCarDate: 'תאריך עלייה לכביש',
    exchangeTime: 'מועד החלפה',
    levelsTitle: 'שלבי קבלת רכב רפואי',
    parkingTagGuide: 'כל הדרכים להשתמש בתג החניה',
    fillUpFile: 'מילוי טופס בקשה',
    carsHistoryTitle: 'היסטוריית הרכבים הרפואיים שלך',
    filesTitle: 'שליחת קבצים לאגף בנושא רכב',
    sendMarbadResults: 'שליחת תוצאות הבדיקות מהמרב"ד',
    appliesNote: 'הקבצים שנשלחו יופיעו באזור פניות לאגף, לנוחיותך',
    fileAttached: 'הקובץ שצירפת',
    delete: 'מחיקה',
    attachFileToSend: 'צירוף קובץ לשליחה',
    attachAdditionalFile: 'צירוף קובץ נוסף (במידת הצורך)',
    attachFile: 'צירוף קובץ',
    emptyFieldErr: 'שדה חובה, לא נוכל להתקדם בלי צירוף קובץ',
    remarkTitle: 'פירוט והערות (לא חובה)',
    remarkPlaceholder:
      'פה אפשר לכתוב איזה קובץ צירפת, או לציין הערות כלליות, במידת הצורך',
    back: 'חזרה',
    send: 'שליחה',
    filesWasSuccessfullySent: 'הקבצים נשלחו בהצלחה',
    applyNumber: 'פנייה מספר:',
    applySentDate: 'תאריך שליחת הפנייה',
    numOfFiles: 'מספר הקבצים ששלחת',
    filesWillAppearHere: 'הקבצים ששלחת יופיעו פה: ',
    end: 'סיום',
    yourEligibilities: 'הזכאויות שלך',
    medicalCarLevel: 'רמת זכאות לרכב רפואי',
    getLevelText: (value: Levels) => {
      switch (value) {
        case Levels.Level1:
          return 'רמה 1';
        case Levels.Level2:
          return 'רמה 2';
        case Levels.Level3:
          return 'רמה 3';
        case Levels.Level4:
          return 'רמה 4';
        case Levels.Level5:
          return 'רמה 5';
        case Levels.Level6:
          return 'רמה 6';
        case Levels.Level2A:
          return 'רמה 2A';
        default:
          return '';
      }
    },
    getGrant: (value: number) => value.toLocaleString('en-US') + ' ₪',
    getMaxGrant: (value: number) => `מענק ${value.toLocaleString('en-US')} ₪`,
    getMaxLoan: (value: number) => `הלוואה ${value.toLocaleString('en-US')} ₪`,
    until: 'עד',
    nis: '₪',
    grantPortion: 'חלוקת הסיוע',
    grant: 'מענק',
    loan: 'הלוואה',
    mobilityFees: 'דמי ניידות',
    perMonth: 'בחודש',
    moreEligibilities: 'זכאויות נוספות',
    welfareContact: 'פנייה לעובדת רווחה',
    ContactDepartment: 'פנייה לאגף בנושא רכב רפואי',
    marbadLimitationsTitle: 'הגבלות והיתרים שנקבעו במרב"ד',
    additionalFile: 'קובץ נוסף מסוג זה',
    additionalFilePlus: '+ קובץ נוסף מסוג זה',
    file: 'הקובץ שצירפת',
    view: 'צפייה',
    feeDiscount: 'הנחה באגרה',
    exemption: 'פטור מאגרה',
    refund: 'החזר דמי אגרה',
    annualInsuranceBenefit: 'הטבת ביטוח שנתית',
    ituran: 'איתוראן',
    ituranText: 'זכאות להתקנה ודמי מנוי',
    parkingTag: 'תג חניה',
    parkingTagEligibility: 'יש לך זכאות אוטומטית',
    close: 'סגירה',
    getTasksNote: (number: number) =>
      `יש ${number} משימות עבורך, שיקדמו את התהליך`,
  },
  [DICTIONARY.CookieConsent]: {
    title: 'האתר עושה שימוש ב-Cookies',
    body: 'אנחנו משתמשים בקובצי Cookies כדי לשפר את חווית השימוש בשירותים הדיגיטליים שלנו.',
    gotIt: 'הבנתי',
    privacyPolicy: 'מדיניות הפרטיות',
  },
  [DICTIONARY.DisabilityCalculator]: {
    homeCrumb: 'דף הבית',
    pageName: 'כלי להערכת אחוזי נכות',
    title: 'מחשבון אחוזי נכות',
    expectationDisabilityPercentageTool: 'כלי להערכת אחוזי הנכות שלך',
    whatIsYourExpectation: 'מה הצפי?',
    subtitle: [
      'כאן אפשר לחשב אחוזי נכות משוערים על בסיס מצבך הרפואי, ולקבל רשימת מסמכים נדרשים לקראת הוועדה הרפואית.',
      'המחשבון נועד לאפשר לך הצצה לאופן קביעת אחוזי הנכות, לתת לך אפשרות להערכה עצמית, ולסייע בתיאום ציפיות.',
    ],
    youShouldKnow: 'כדאי לדעת:',
    youShouldKnowInfo: [
      'אין צורך בפרטים מזהים, והמידע שלך לא נשמר במערכת',
      'אם יש לך מסמכים רפואיים עדכניים הקשורים בפגיעה, כדאי להכין אותם מראש כדי להקל על מילוי התשובות',
      'תוצאות המחשבון הן להתרשמות כללית. כדי לקבוע אחוזי נכות רשמיים יש צורך בתהליך מעמיק מול ועדה רפואית',
    ],
    haveRead: 'קראתי והבנתי',
    continue: 'המשך',
    ifYouAreRecognized:
      'אם כבר הוכרת על ידי האגף, כדאי להוסיף את הפגיעות  שהוכרו כדי לקבל שקלול מדויק יותר ',
    addClaims: 'הוספת פגיעות שהוכרו',
    requiredField: 'יש לאשר את ההצהרה כדי להתקדם',
    exit: 'יציאה',
    searchPlaceholder: 'למשל: עיניים, מערכת העצבים',
    searchFilter: 'חיפוש',
    searchQuestion: 'באיזה איבר, מערכת בגוף או מחלה מדובר?',
    fullListTitle: 'איברים, מערכות גוף ומחלות',
    searchInfo:
      'בהמשך אפשר להוסיף פגיעה נוספת, ואנחנו נבצע שקלול של כל הפגיעות יחד',
    searching: 'חיפוש...',
    noResults: 'אין תוצאות, אפשר לנסות חיפוש אחר',
    fullList: 'לרשימה המלאה',
    back: 'חזרה',
    select: 'בחירה',
    selectToProceed: 'יש לבחור באחת מהאפשרויות כדי להתקדם',
    addDisability: 'להוסיף פגיעה?',
    addDisabilityInfo: 'הוספת פגיעה',
    yes: 'כן',
    no: 'לא',
    summaryTitle: 'אז מה הצפי שלך?',
    estimatedDisabilityPercentage: 'אחוזי נכות משוערים:',
    summaryDisclaimer:
      'תוצאות המחשבון הן הערכה בלבד. האחוזים הסופיים ייקבעו על ידי הוועדה הרפואית',
    sendResultsTitle: 'שליחת התוצאות',
    toWhatsApp: 'לוואטסאפ',
    toEmail: 'לדואר האלקטרוני',
    startOver: 'התחלה מחדש',
    whatAreResultsBasedOn: 'על מה מבוססות התוצאות?',
    updatedInjuries: 'פגיעות שעדכנת',
    edit: 'עריכה',
    delete: 'מחיקה',
    exclusionReasonLabel: 'סיבת הביטול:',
    noResultsTitle: 'אין תוצאות',
    noResultsSubtitle: 'אפשר לנסות לשנות את הסינון',
    disclaimerText:
      'אחוזי הנכות הסופיים מחושבים בצורה של שקלול מורכב, ולא בחיבור פשוט של הפגיעות.',
    expand: 'הרחבה',
    documentsRequiredForCommittee: 'מסמכים שצריך להכין לוועדה',
    noSummaryDataAvailable: 'אין נתוני סיכום זמינים',
    addInjuryDisclaimerIntro:
      'אם יש לך מספר פגיעות, כדאי להוסיף את כולן כדי לקבל הערכה מדויקת יותר של אחוזי הנכות',
    addInjuryDisclaimerCalculationTitle: 'אחוזי הנכות מחושבים בצורה זו:',
    addInjuryDisclaimerCalculationPoint1:
      'הפגיעה עם אחוזי הנכות הגבוהים ביותר מחושבת במלואה מתוך 100%',
    addInjuryDisclaimerCalculationPoint2:
      'הפגיעה השניה מחושבת מתוך האחוזים שנותרו אחרי חיסור הפגיעה הראשית',
    addInjuryDisclaimerCalculationPoint3:
      'הפגיעה הבאה (אם יש) תחושב מתוך האחוזים שנותרו אחרי הפחתת שתי הפגיעות הראשונות, וכן הלאה',
    addInjuryDisclaimerSpecialCase:
      'אם נפגעת בשתי הידיים או בשתי הרגליים, אחוזי הנכות שנקבעו עבור שתי הגפיים יחוברו יחד, ללא החישוב המפורט מעלה.',
    addInjuryDisclaimerMoreInfoPrefix: 'אפשר לקרוא עוד על',
    addInjuryDisclaimerMoreInfoLink: 'אופן החישוב באתר',
    understood: 'הבנתי',
    editInjuries: 'עריכת פגיעות',
    injuryName: 'שם הפגיעה',
    injuryPercentage: 'אחוזי נכות',
    finishedEditing: 'סיימתי לערוך',
    undoDelete: 'ביטול מחיקה',
    deleted: 'נמחקה',
    almostDone: 'נוספו עוד כמה שאלות - כבר מסיימים',
    finish: 'סיום',
    selectionPath: 'נתיב בחירה',
    estimatedPercentage: 'אחוזים משוערים',
    selectedInjuries: 'פגיעות שנבחרו',
    injuriesPlaceholder: 'כאן יופיעו פגיעות שיבחרו',
    basedOnAlreadyAddedInjuries: 'על בסיס הפגיעות שכבר הוספת',
    doctorExplains: 'הדוקטור מסבירה',
    wristStiffnessComfortableDesc1:
      'כף היד נעולה בכיפוף גבי \nשל בין 15º ל 25º מעלות',
    wristStiffnessComfortableDesc2:
      'בנוסף יש קיבוע של היד בזוית ישרה \nאו עם כיפוף לכיוון הזרת',
    wristStiffnessMediumDesc:
      'שורש כף היד נעול (לא זז), בזווית שאינה אידיאלית אך אינה משביתה לגמרי. ניתן לבצע חלק מהפעולות היומיומיות, אך האחיזה חלשה יותר, הפעולות מסורבלות ולעיתים מלוות באי-נוחות.',
    wristStiffnessUncomfortableDesc1: 'כף היד נעולה בכיפוף כפי (לכיוון כף היד)',
    wristStiffnessOr: 'או',
    wristStiffnessUncomfortableDesc2: 'היד נמצאת בקיבוע עם נטיה לכיוון האגודל',
    shoulderStiffness25Label: '25° מהגוף',
    shoulderStiffness50Label: '50° מהגוף',
    disabilityPercentSuffix: 'אחוזי נכות',
    shoulderLimitation30Percent: '1% אחוזי נכות',
    shoulderLimitation45Percent: '15% אחוזי נכות',
    shoulderLimitationUpToPercent: '25% אחוזי נכות',
    shoulderLimitationAbovePercent: '35% אחוזי נכות',
    elbowBend150Percent: '1% אחוזי נכות',
    elbowStraightening30Percent: '10% אחוזי נכות',
    elbowStraightening150Percent: '1% אחוזי נכות',
    kneeBend15Percent: '30% אחוזי נכות',
    kneeBend30Percent: '20% אחוזי נכות',
    kneeBend45Percent: '10% אחוזי נכות',
    kneeBend70Percent: '5% אחוזי נכות',
    kneeBend90Percent: '1% אחוזי נכות',
    kneeStraightening45Percent: '45% אחוזי נכות',
    kneeStraightening30Percent: '40% אחוזי נכות',
    kneeStraightening15Percent: '20% אחוזי נכות',
    kneeStraightening10Percent: '10% אחוזי נכות',
    kneeStraightening5Percent: '1% אחוזי נכות',
    close: 'סגירה',
    howDisabilityDeterminedHeartDiseases: 'איך קובעים דרגת נכות במחלות לב?',
    chronicObstructiveDiseasesNote:
      'חשוב לדעת: במקרה שהמצב הקליני חמור יותר ולא תואם את מצב תפקודי הריאות, יכולים להיקבע אחוזי נכות זמניים בדרגה אחת גבוהה מהמוגדר באפשרויות הקודמות',
    heartDiseaseDisabilityDeterminationIntro: 'קביעת דרגת הנכות מתבססת על:',
    heartDiseaseDisabilityPoint1: '(1) עדות קלינית או מעבדתית לקיום האבחנה;',
    heartDiseaseDisabilityPoint2:
      '(2) הערכה תפקודית מעבדתית בשיטות של אסכולה רפואית עדכנית;',
    heartDiseaseDisabilityPoint3:
      '(3) הערכה קלינית לפי ארבעת השלבים התפקודיים של ה-NYHA:',
    heartDiseaseFunctionalStage1: 'שלב תפקודי I',
    heartDiseaseFunctionalStage1DescFirst: 'אין הגבלה בפעילות גופנית.',
    heartDiseaseFunctionalStage1DescRest:
      'פעילות גופנית שגרתית לא גורמת לעייפות, פלפיטציות, קוצר נשימה או תעוקת לב.',
    heartDiseaseExerciseTest: 'במבחן מאמץ',
    heartDiseaseFunctionalStage1Test:
      'לא פחות מ- METS 7 או שלב שני לפי פרוטוקול BRUCE או WATT 100.',
    heartDiseaseFunctionalStage2: 'שלב תפקודי II',
    heartDiseaseFunctionalStage2DescFirst: 'הגבלה קלה בפעילות גופנית.',
    heartDiseaseFunctionalStage2DescRest:
      'הרגשה נוחה במנוחה ובביצוע פעילות שגרתית קלה, אבל פעילות גופנית יותר משגרתית גורמת לעייפות, פלפיטציות, קוצר נשימה או תעוקת לב.',
    heartDiseaseFunctionalStage2Test:
      'לא פחות מ- METS 5 או שלב ראשון לפי פרוטוקול BRUCE או WATT 75.',
    heartDiseaseFunctionalStage3: 'שלב תפקודי III',
    heartDiseaseFunctionalStage3DescFirst: 'הגבלה ניכרת בפעילות גופנית.',
    heartDiseaseFunctionalStage3DescRest:
      'הרגשה נוחה במנוחה, אבל פעילות שגרתית גורמת לעייפות, פלפיטציות, קוצר נשימה או תעוקת לב.',
    heartDiseaseFunctionalStage3Test:
      'לא פחות מ- METS 2 או שלב ראשון לפי פרוטוקול BRUCE או WATT 25.',
    heartDiseaseFunctionalStage4: 'שלב תפקודי IV',
    heartDiseaseFunctionalStage4DescFirst:
      'כל פעילות גופנית מלווה בהרגשה לא נוחה, גם בזמן מנוחה.',
    heartDiseaseFunctionalStage4DescRest:
      'סימני אי ספיקת לב, גודש ריאתי או סיסטמי, קוצר נשימה ותעוקת לב מופיעים במנוחה וגוברים במאמץ.',
    heartDiseaseFunctionalStage4Test:
      'תוצאות מתחת לערכים המוגדרים בשלב תפקודי III.',
    heartDiseaseMultipleDiseasesRule:
      '(4) במקרה של שתי מחלות לב או יותר, תקבע דרגת הנכות לפי השלב התיפקודי הגבוה ביניהן.',
    coronaryHeartDiseaseQuestionPrefix: 'דרגת הנכות תיקבע בהתאם ',
    coronaryHeartDiseaseQuestionLink: 'לשלב התפקודי',
    coronaryHeartDiseaseQuestionSuffix: ' לפי סימפטומים וממצאי המעבדה',
  },
  [DICTIONARY.RecognitionDashboard]: {
    pageTitle: 'דאשבורד טופס הכרה',
    totalFormsSubmitted: 'כמות טפסים שהוגשו',
    districtDistribution: 'חלוקה למחוזות',
    ageDistribution: 'התפלגות לפי גיל',
    age: 'גיל',
    years: 'שנים',
    requestType: 'סוג בקשה',
    recognizedAsDisabled: 'מוכר כנכה',
    firstTimeRecognition: 'הכרה פעם ראשונה',
    chooseDateRange: 'בחירת טווח תאריכים',
    dateRange: {
      last30Days: '30 ימים אחרונים',
      lastWeek: 'בשבוע האחרון',
      lastMonth: 'בחודש האחרון',
      lastYear: 'בשנה האחרונה',
      yearStart: 'מתחילת השנה הנוכחית',
      custom: 'טווח מותאם אישית',
      fromDate: 'מתאריך',
      toDate: 'עד תאריך',
      back: 'חזרה',
      showResults: 'הצג תוצאות',
    },
    familyStatus: 'מצב משפחתי',
    maritalStatus: {
      single: 'רווק/ה',
      married: 'נשוי/ה',
      divorced: 'גרוש/ה',
      widowed: 'אלמן/ה',
      status: 'סטטוס',
    },
    gender: 'מגדר',
    male: 'זכר',
    female: 'נקבה',
    treatmentStatus: 'מצב טיפול - סטטוסים',
    injuryTypes: 'סוגי פגיעות',
    injuryTypesList: {
      physical: 'פגיעה פיזית או חבלה',
      disease: 'מחלה',
      postTrauma: 'פוסט טראומה',
      mentalIllness: 'מחלה נפשית/הפרעה נפשית',
    },
    representatives: 'מייצגים',
    representativesSubtitle: '(ע"י מי הוגש הטופס)',
    churnRate: 'אחוזי נטישה',
    churnRateInfo: 'שנתיים ללא פעילות נחשבת נטישה',
    treatmentTime: {
      average: 'זמן טיפול ממוצע',
      months: 'חודשים',
      shortest: 'הקצר ביותר',
      days: 'ימים',
      longest: 'הארוך ביותר',
      calculationInfo: 'זמן הטיפול מחושב מרגע הגשת הטופס ועד שלב ההחלטה',
    },
  },
  [DICTIONARY.SelfServiceReferrals]: {
    getSelfReferral: 'פנייה להפקת התחייבות',
    getSelfReferralDescription:
      'כדי להפיק התחייבות לשירות זה, יש לפנות למחוז שלך.',
    continueToDistrict: 'המשך פנייה למחוז',
    back: 'חזרה',
    backToMain: 'חזרה למסך הראשי',
    pageTitle: 'הפקת התחייבות (הפניה)',
    pageSubtitle:
      'כאן מופיעים השירותים הרפואיים שעבורם יש לך אפשרות להפיק התחייבות באופן מיידי',
    communicationBanner: {
      line1: 'יש להפיק התחייבות רק עבור טיפול',
      line2: 'בפגיעות שהוכרו או בתהליך ההכרה',
      popupTitle: 'קבלת טיפול רפואי מאגף השיקום',
      popupIntroLine1:
        'אפשר לקבל טיפול רפואי רק עבור פגיעות שהוכרו באגף או שנמצאות בתהליך הכרה.',
      popupIntroBeforeBold: 'אם ההתחייבות תמומש לצורך רפואי ',
      popupIntroBold: 'שאינו קשור',
      popupIntroAfter: 'בפגיעות אלה, תידרש השתתפות בתשלום.',
      popupBlock1Bold: 'נקבעו לך אחוזי נכות:',
      popupBlock1Rest: 'אפשר לראות את רשימת סעיפי הנכות',
      popupBlock1Link: 'בפרטים האישיים',
      popupBlock2Bold: 'הבקשה שלך בתהליך הכרה:',
      popupBlock2Rest: 'אפשר לראות את רשימת הפגיעות',
      popupBlock2Link: 'במצב הטיפול בבקשה להכרה',
      popupDone: 'סיום',
    },
    generatedRefBanner: {
      line1: 'אפשר למצוא התחייבויות שהפקת לבד',
      line2: 'בריכוז פניות לאגף',
    },
    searchTitle: 'מה נושא ההתחייבות?',
    searchSubtitle: 'אפשר לחפש סוג שירות, מקצוע או בית חולים',
    searchPlaceholder: 'למשל: פיזיותרפיה / שערי צדק',
    searchNoResults: 'לא נמצאו תוצאות',
    searchGroupDoctors: 'בדיקה רפואית',
    searchGroupParamedical: 'טיפולים משלימים',
    searchGroupHospitals: 'בתי חולים',
    searchGroupMental: 'טיפול נפשי',
    searchGroupLabTests: 'בדיקות מעבדה',
    searchDrawerTitle: 'חיפוש',
    searchNoResultsTitle: 'לא מצאנו את מה שחיפשת בסל השירותים שלך',
    searchNoResultsHint: 'כדאי לנסות לאיית אחרת, או שאפשר:',
    filterTitle: 'אפשר גם לחפש לפי:',
    categories: {
      doctors: 'רופאים ורופאות',
      paramedical: 'טיפולים משלימים',
      mental: 'טיפול נפשי',
      hospitals: 'בתי חולים',
      imaging: 'מכוני דימות',
      labTests: 'בדיקות',
    },
    categoryCarousel: {
      prev: 'הקודם',
      next: 'הבא',
      pagesAriaLabel: 'עמודי קטגוריות',
      pageAriaLabel: (page: number) => `עמוד ${page}`,
    },
    showAll: (count: number) => `הצג הכול (${count})`,
    showLess: 'הצג פחות',
    footerNotFound: 'לא מצאת את התחום שחיפשת?',
    footerSubtitle: 'אם יש לך צורך בשירות רפואי שלא מופיע כאן, אפשר:',
    searchSuppliers: 'לחפש ספקי שירות',
    contactDepartment: 'לפנות לאגף',
    doctors: {
      listTitle: 'לאיזה תחום להפיק התחייבות?',
      listSubtitle: 'בחר תחום טיפול להפקת הפניה:',
    },
    typeSelectionPopup: {
      title: 'לאן מיועדת ההתחייבות (הפניה)?',
      hospital: 'בית חולים',
      privateClinic: 'מרפאה פרטית',
    },
    hospitalSelect: {
      searchPlaceholder: 'חיפוש בית חולים',
      listTitle: 'לאיזה בית חולים להפיק התחייבות?',
      regionAll: 'כל הארץ',
      backToTypeSelection: 'חזרה לבחירת יעד ההפניה',
    },
    regionFilter: {
      title: 'בחירת אזור בארץ',
      filterByRegion: 'סינון לפי אזור',
      all: 'כל הארץ',
      north: 'צפון',
      central: 'מרכז',
      south: 'דרום',
      apply: 'סינון',
      saveAndContinue: 'שמירה והמשך',
      reset: 'איפוס בחירה',
    },
    paramedical: {
      listTitle: 'עבור איזה שירות להפיק הפניה?',
      listSubtitle: 'בחר שירות להפקת הפניה:',
    },
    imaging: {
      listTitle: 'לאיזו בדיקה להפיק התחייבות?',
      listSubtitle: 'בחר בדיקה להפקת הפניה:',
    },
    labTests: {
      listTitle: 'לאיזו בדיקה להפיק התחייבות?',
      listSubtitle: 'בחר בדיקה להפקת הפניה:',
    },
    mental: {
      selectSupplierButton: 'בחירת ספק לטיפול נפשי',
      infoText: 'אפשר לחפש במנוע ספקים או להגיש פנייה לאגף',
    },
    hospitals: {
      listTitle: 'לאיזה בית חולים להפיק התחייבות?',
      regionFilter: 'כל הארץ',
    },
    departmentSelect: {
      searchPlaceholder: 'חיפוש תחום טיפול',
      listTitle: 'לאיזה תחום להפיק הפניה?',
      backToHospitalSelection: 'חזרה לבחירת בית חולים',
    },
    noEntitlement: {
      title: 'הפקת התחייבות (הפניות)',
      subtitle: 'לא מצאנו את מה שחיפשת בסל השירותים שלך',
      submitRequest: 'לפנות לאגף',
      searchSuppliers: 'לחפש ספקי שירות',
    },
    referralCreator: {
      confirmTitle: 'רגע לפני, נאשר שהפרטים נכונים:',
      validityLine: 'ההתחייבות תקפה ל-3 חודשים:',
      psychiatryValidityLine: 'ההתחייבות תקפה לשנה:',
      paramedicalTreatmentsValidityLine: (treatmentCount: number) =>
        `ההתחייבות תקפה ל-${treatmentCount} טיפולים.`,
      fromDateLabel: 'מתאריך:',
      toDateLabel: 'עד תאריך:',
      infoBubbleTitle: 'לתשומת ליבך:',
      infoBubbleItem1: '1. כדאי לקבוע תור לשירות הרצוי לפני הפקת ההתחייבות',
      infoBubbleItem2:
        '2. חשוב להביא איתך את ההמלצה הרפואית, בנוסף להתחייבות שהפקת',
      infoBubbleDoctorsText:
        'כדאי לקבוע תור לשירות הרצוי, לפני הפקת ההתחייבות.',
      submit: 'הפקת התחייבות',
      successTitle: 'ההתחייבות הופקה בהצלחה!',
      downloadCommitment: 'הורדה',
      viewCommitmentHint: 'אפשר לראות את ההתחייבות',
      requestsLobbyLink: 'בריכוז פניות לאגף',
      commitmentFileName: 'התחייבות',
      finish: 'סיום',
    },
  },
  [DICTIONARY.SelfReferral]: {
    claimToPgimaPageTitle: 'ניהול קשרי אברים ומחלות לסימול-פגימה',
    sectorToSimulPgimaPageTitle: 'ניהול קשרי תחום רפואי לסימול-פגימה',

    // Step 1 — type selection
    claimTypeLabel: 'בחר סוג:',
    claimTypeBodyPart: 'אבר',
    claimTypeDisease: 'מחלה',

    // Step 2 — name + details
    claimNameLabel: 'בחר שם:',
    claimDetailsLabel: 'בחר פירוט:',
    claimDetailsNone: 'ללא פירוט',
    claimSelectNameFirst: 'יש לבחור שם תחילה',
    claimSelectTypeFirst: 'יש לבחור סוג תחילה',

    // Results panels
    selectedClaimSubject: (name: string, details: string | null) =>
      details ? `${name} — ${details}` : name,
    linkedSimulPgimasTitle: (count: number) =>
      `סימולי פגימה מקושרים (${count})`,
    availableSimulPgimasTitle: (count: number) =>
      `הוסף סימול פגימה (${count} זמינים)`,
    noLinkedSimulPgimas: 'אין סימולי פגימה מקושרים',
    searchSimulPgimaPlaceholder: 'חיפוש לפי שם...',

    // SectorToSimulPgima
    chooseSimulPgima: 'בחר סימול-פגימה:',
    selectedSimulPgima: 'סימול פגימה נבחר:',
    linkedSectorsTitle: 'תחומים רפואיים מקושרים',
    linkedSectorsTitleWithCount: (count: number) =>
      `תחומים רפואיים מקושרים (${count})`,
    addSectorsAvailable: (count: number) => `הוסף תחום רפואי (${count} זמינים)`,
    noLinkedSectors: 'אין תחומים מקושרים',
    searchSectorsPlaceholder: 'חיפוש לפי נושא, שם תחום או מחלקה...',

    // Shared
    loading: 'טוען...',
    noResults: 'לא נמצאו תוצאות',
    add: 'הוסף',
    remove: 'הסר',
    emptyValue: '—',
    errorAddRelation: 'שגיאה בהוספת הקשר',
    errorDeleteRelation: 'שגיאה במחיקת הקשר',
    noAccessTitle: 'אין הרשאה',
    noAccessMessage: 'דף זה זמין למנהלים בלבד.',

    // SectorToSimulPgima admin (CRUD grid)
    sectorToSimulPgimaAdminPageTitle: 'ניהול טבלת תחום רפואי לסימול-פגימה',
    colSimulPgima: 'סימול-פגימה',
    colMedicalSector: 'תחום רפואי',
    colMaamad: 'מעמד',
    colMinGeneralDisabilityPercent: 'אחוז נכות כללי מינימלי',
    colMinPgimaDisabilityPercent: 'אחוז נכות פגימה מינימלי',
    colActions: 'פעולות',
    addNewRowTitle: 'הוספת שורה חדשה',
    existingRowsTitle: (count: number) => `שורות קיימות (${count})`,
    selectSimulPgimaPlaceholder: 'בחר סימול-פגימה',
    selectMedicalSectorPlaceholder: 'בחר תחום רפואי',
    save: 'שמור',
    saving: 'שומר...',
    delete: 'מחק',
    noRows: 'אין שורות',
    selectKeysFirst: 'יש לבחור סימול-פגימה ותחום רפואי',
    keyAlreadyExists: 'שילוב סימול-פגימה ותחום רפואי כבר קיים',
    errorSaveRow: 'שגיאה בשמירת השורה',
    errorLoadRows: 'שגיאה בטעינת הנתונים',
  },
  [DICTIONARY.AdminSelfReferralGeneratedList]: {
    pageTitle: 'הפניות עצמאיות שהופקו',
    backToMain: 'חזרה למסך הראשי',
    noAccessTitle: 'אין הרשאה',
    noAccessMessage: 'דף זה זמין למשתמשי אדמין בלבד.',
    noResults: 'לא נמצאו תוצאות',
    loading: 'טוען...',
    getTotalResults: (count: number) => `סך הכל ${count} תוצאות`,
    exportToExcel: 'ייצוא לאקסל',
    csvHeaders: [
      'מספר תז',
      'מחוז',
      'תאריך ושעה',
      'נושא',
      'תחום',
      'סוג ספק',
      'קוד ספק',
      'קוד ספק SAP',
      'שם ספק',
      'מספר מק"ט',
      'תיאור',
      'תוקף מ-',
      'תוקף עד',
    ],

    // Filter labels
    filterDateFrom: 'תאריך מ-',
    filterDateTo: 'תאריך עד',
    filterSubject: 'נושא',
    filterMedicalSectorName: 'תחום',
    filterSupplierKind: 'סוג ספק',
    filterSupplierId: 'קוד ספק',
    filterSapSplrCode: 'קוד ספק SAP',
    filterCatalogNumber: 'מספר מקט',
    supplierKindAll: 'הכל',
    supplierKindHospital: 'בית חולים',
    supplierKindPrivate: 'ספק פרטי',
    searchButton: 'חיפוש',
    clearFiltersButton: 'נקה סינון',

    // Column headers (in display order)
    columnIdNumber: 'מספר תז',
    columnBranch: 'מחוז',
    columnCreatedAt: 'תאריך ושעה',
    columnSubject: 'נושא',
    columnMedicalSectorName: 'תחום',
    columnSupplierKind: 'סוג ספק',
    columnSupplierId: 'קוד ספק',
    columnSapSplrCode: 'קוד ספק SAP',
    columnSupplierName: 'שם ספק',
    columnCatalogNumber: 'מספר מקט',
    columnDescription: 'תיאור',
    columnValidFromDate: 'תוקף מ-',
    columnValidToDate: 'תוקף עד',

    exportError: 'שגיאה בייצוא הקובץ',
  },
  [DICTIONARY.AdminSelfReferralDebug]: {
    pageTitle: 'בדיקת זכאות הפקת הפנייה אוטומטית',
    pageDescription:
      'מסך לבדיקת הנתונים שמהם מחושבת זכאות היוזר להפקת הפנייה אוטומטית — נכויות קיימות (משמש) ופגימות בתהליך הכרה.',
    backToMain: 'חזרה למסך הראשי',
    noAccessTitle: 'אין הרשאה',
    noAccessMessage: 'דף זה זמין למשתמשי אדמין בלבד.',

    caseNumberLabel: 'מספר תיק',
    caseNumberPlaceholder: 'הזן מספר תיק נכה',
    searchButton: 'בדוק',
    fetchError: 'שליפת הנתונים נכשלה.',

    userHeaderTitle: 'נתוני יוזר',
    fieldCaseNumber: 'מספר תיק',
    fieldFullName: 'שם היוזר',
    fieldDisabilityStatus: 'מעמד נכות',
    fieldDisabilityPercent: 'אחוזי נכות',

    recognizedSectionTitle: 'נכויות קיימות (T_ShikumComSeifMivchan)',
    noRecognizedRows: 'לא נמצאו נכויות קיימות עבור מספר תיק זה.',
    recognizedColumnCode: 'קוד נכות',
    recognizedColumnName: 'שם נכות',
    recognizedColumnPercent: 'אחוזי נכות',
    recognizedColumnValidDate: 'תאריך תוקף',
    recognizedColumnSymbol: 'סימול פגימה',

    activeClaimsSectionTitle: 'נכויות בתהליך הכרה (ClaimEvent)',
    noActiveRows: 'לא נמצאו פגימות בטיפול עבור מספר תיק זה.',
    activeColumnPgimaNumber: 'מס׳ פגימה',
    activeColumnPart: 'PART',
    activeColumnPartDetails: 'PARTDETAILS',
    activeColumnSick: 'SICK',
    activeColumnSickDetails: 'SICKDETAILS',
    activeColumnTreatmentStage: 'שלב טיפול',
    activeColumnDisplayedStatus: 'סטאטוס פגימה',
    activeColumnMatchedSimulPgima: 'סימול פגימה (תואם)',
  },
  [DICTIONARY.AdminLogs]: {
    pageTitle: 'Application Logs',
    pageDescription:
      'Search Application Insights telemetry (traces, requests, exceptions, dependencies) across configured sources.',
    backToMain: 'Back to home',
    noAccessTitle: 'Access denied',
    noAccessMessage: 'This page is available to admin users only.',

    filterFrom: 'From',
    filterTo: 'To',
    filterSeverity: 'Min severity',
    filterSources: 'Source',
    filterSearch: 'Search text',
    filterOperationId: 'Operation ID',
    filterTake: 'Max rows',
    quickLast15Min: 'Last 15 min',
    quickLastHour: 'Last hour',
    quickLast24Hours: 'Last 24 hours',
    quickLast7Days: 'Last 7 days',
    autoRefreshLabel: 'Auto-refresh',
    autoRefreshOff: 'Off',
    autoRefreshEvery: (seconds: number) => `Every ${seconds}s`,
    searchButton: 'Search',
    clearButton: 'Clear',
    refreshButton: 'Refresh',

    severityVerbose: 'Verbose',
    severityInformation: 'Information',
    severityWarning: 'Warning',
    severityError: 'Error',
    severityCritical: 'Critical',

    kindTrace: 'Trace',
    kindException: 'Exception',
    kindRequest: 'Request',
    kindDependency: 'Dependency',

    columnTimestamp: 'Time (UTC)',
    columnSeverity: 'Severity',
    columnSource: 'Source',
    columnKind: 'Type',
    columnMessage: 'Message',
    columnOperation: 'Operation',
    columnDuration: 'Duration',
    columnActions: '',

    noResults: 'No logs found for the selected filters.',
    noSourcesConfigured:
      'No Application Insights sources are configured. Set AdminLogs:Sources:*:ResourceId on the API (or ApplicationInsights:ConnectionString for local dev).',
    fetchError: 'Failed to load logs',
    truncatedNotice: (count: number) =>
      `Showing ${count} rows only. Narrow the time range or refine filters.`,
    getTotalResults: (count: number) => `${count} rows`,

    viewDetails: 'View details',
    viewTrace: 'View full operation',
    copyOperationId: 'Copy Operation ID',
    copied: 'Copied',

    drawerTitle: 'Log details',
    detailsTimestamp: 'Timestamp (UTC)',
    detailsSource: 'Source',
    detailsKind: 'Record kind',
    detailsSeverity: 'Severity',
    detailsCloudRole: 'Cloud role',
    detailsOperationName: 'Operation name',
    detailsOperationId: 'Operation ID',
    detailsParentId: 'Parent ID',
    detailsMessage: 'Message',
    detailsResultCode: 'Result code',
    detailsUrl: 'URL / target',
    detailsDuration: 'Duration (ms)',
    detailsExceptionType: 'Exception type',
    detailsExceptionMessage: 'Exception message',
    detailsExceptionStack: 'Stack trace',
    detailsProperties: 'Custom dimensions',
    closeButton: 'Close',
    backToSearch: 'Back to search',
    traceModeBanner: (operationId: string) =>
      `Trace mode: all records for operation ${operationId}`,
  },
  [DICTIONARY.RefundsMedicalEquipment]: {
    title: 'החזר מהיר: ציוד רפואי',
    attachInvoice: 'צירוף חשבונית',
    nis: '₪',
    back: 'חזרה',
    continue: 'המשך',
    steps: {
      verify: 'אימות נתונים',
      summary: 'סיכום החזר',
    },
    errors: {
      analyze: 'אירעה תקלה בעת סריקת החשבונית. אפשר לנסות שוב.',
      submit: 'אירעה תקלה בעת שליחת הבקשה. אפשר לנסות שוב.',
      invalidFile:
        'הקובץ אינו תקין. ניתן לצרף קבצים מסוג png, jpg, doc, docx, pdf, tif',
      duplicateFile: 'הקובץ כבר צורף',
      maxFiles: 'ניתן לצרף קובץ אחד בלבד',
      maxSize: 'סך גודל הקבצים חורג מ-15MB',
    },
    upload: {
      zoneSubtitle: 'יש לצרף חשבונית אחת',
      dragFileHere: 'גררו לכאן את הקובץ',
      dragOrClick: 'אפשר לגרור קובץ או ללחוץ להעלאה',
      uploadInvoice: 'העלאת חשבונית',
      nonMedicalNotePrefix:
        'להחזר בנושא שאינו ציוד רפואי, יש להגיש בקשה דרך סביבת ',
      nonMedicalNotePrefixDesktop:
        'להחזר בנושא שאינו ציוד רפואי, יש להגיש בקשה דרך ',
      expenseRefundLink: 'החזר הוצאות',
      expenseRefundLinkDesktop: 'סביבת החזר הוצאות',
    },
    uploadError: {
      invalidFormat: 'ניתן לצרף קבצים בפורמטים המותרים בלבד',
      fileTooLarge: 'גודל הקובץ חורג מ-15MB',
      delete: 'מחיקה',
      allowedFilesNote:
        'ניתן לצרף קבצים עד 15MB עם הסיומות: png, jpg, jpeg, doc, docx, pdf, tif',
    },
    viewer: {
      remove: 'מחיקה',
      view: 'צפייה',
    },
    scanning: {
      title: 'סריקה ואימות נתונים',
      subtitle: 'עוד רגע נסיים לסרוק את החשבונית שהעלית ולהצליב עם הזכויות שלך',
    },
    items: {
      invoiceLabel: 'חשבונית',
      invoiceNumberPrefix: 'מספר: ',
      detected: (count: number) => `זיהינו ${count} פריטים להחזר מהיר:`,
      quantityToRefund: 'כמות להחזר',
      invoiceAmount: 'סכום בחשבונית',
      refundAmount: 'סכום להחזר',
      totalRefund: 'סכום החזר :',
      reUpload: 'חזרה',
      requestRefund: 'שליחה',
      noItemsSelected: 'יש לבחור לפחות פריט אחד',
      mismatchTitle: 'מצאת אי התאמה?',
      mismatchText:
        'בכל מקרה של אי התאמה בכמות, בסכום או בזיהוי הפריטים ביחס לחשבונית, אפשר:',
      describeInYourWords: 'לפרט לנו במילים שלך',
    },
    summary: {
      greatTitle: 'נהדר!',
      refundAmountTitle: 'סכום ההחזר שביקשת:',
      successText:
        'הבקשה שלך הועברה לבדיקת זכאות מהירה. אם תאושר, ההחזר ישולם ישירות לחשבון הבנק המעודכן אצלנו.',
      requestNumber: 'מספר בקשה:',
      requestDate: 'תאריך הגשת הבקשה:',
      followText: 'אפשר לעקוב אחרי הבקשה',
      followLink: 'בריכוז פניות לאגף',
      finish: 'סיום',
      anotherRequest: 'בקשת החזר נוסף',
    },
    fallbackBanner: {
      invoiceTooOld:
        'חשבונית שהופקה לפני למעלה משנה אינה מתאימה להחזר מהיר. כאן אפשר לבקש החזר עבור הפריטים שרצית',
      noItems:
        'לא זוהו פריטים להחזר מהיר. כאן אפשר לבקש החזר עבור הפריטים שרצית',
    },
  },
};
